webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 1 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(0);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/OBr5T9/%3F1724535425961&title=Lady%20Bean%20and%20Family&summary=Lady%20Bean%20and%20Family%2C%20the%20follow-up%20to%20Gerald%20and%20Usanna%20Stribling%19s%20Mr%20Cabbage%20and%20Family%2C%20is%20an%20in-depth%20exploration%20of%20the%20world%20of%20leguminous%20plants%2C%20presenting%20a%20blend%20of%20historical%2C%20botanical%2C%20and%20culinary%20perspectives.%20This%20book%20details%20the%20develop&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/OBr5T9/%3F1724535425961",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=Lady%20Bean%20and%20Family%2C%20the%20follow-up%20to%20Gerald%20and%20Usanna%20Stribling%19s%20Mr%20Cabbage%20and%20Family%2C%20is%20an%20in-depth%20exploration%20of%20the%20world%20of%20leguminou%0Dhttps://textcafe.co/books/OBr5T9/%3F1724535425961&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/OBr5T9/%3F1724535425961&posttype=link&caption=Lady%20Bean%20and%20Family%2C%20the%20follow-up%20to%20Gerald%20and%20Usanna%20Stribling%19s%20Mr%20Cabbage%20and%20Family%2C%20is%20an%20in-depth%20exploration%20of%20the%20world%20of%20leguminous%20plants%2C%20presenting%20a%20blend%20of%20historical%2C%20botanical%2C%20and%20culinary%20perspectives.%20This%20book%20details%20the%20develop",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/OBr5T9/%3F1724535425961&description=Lady%20Bean%20and%20Family%2C%20the%20follow-up%20to%20Gerald%20and%20Usanna%20Stribling%19s%20Mr%20Cabbage%20and%20Family%2C%20is%20an%20in-depth%20exploration%20of%20the%20world%20of%20leguminous%20plants%2C%20presenting%20a%20blend%20of%20historical%2C%20botanical%2C%20and%20culinary%20perspectives.%20This%20book%20details%20the%20develop&media=https://textcafe.co/books/OBr5T9/tc-custom/9781398463455.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon UK',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.co.uk/s?k=9781398463455&i=stripbooks&linkCode=qs&tag=mobilebookcom-20',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=890GEQAAQBAJ&amp;rdid=book-890GEQAAQBAJ&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=gb',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9781398463455').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/OBr5T9/tc-custom/9781398463455.jpg?1724535425961',
        alt: 'Lady Bean and Family'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "cover", "STRIBLING-Lady-Bean-Prelims-all_in_one_-without_H--links_", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/OBr5T9/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_STRIBLING_Lady_Bean_Prelims_all_in_one_without_H_links___ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_STRIBLING_Lady_Bean_Prelims_all_in_one_without_H_links____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_STRIBLING_Lady_Bean_Prelims_all_in_one_without_H_links___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_last__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_last__);
/*jshint esversion: 6 */









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/cover",
    "name": "cover",
    "component": __WEBPACK_IMPORTED_MODULE_4__components_cover___default.a
  }, {
    "path": "/STRIBLING-Lady-Bean-Prelims-all_in_one_-without_H--links_",
    "name": "STRIBLING-Lady-Bean-Prelims-all_in_one_-without_H--links_",
    "component": __WEBPACK_IMPORTED_MODULE_5__components_STRIBLING_Lady_Bean_Prelims_all_in_one_without_H_links____default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_6__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/OBr5T9/tc-custom/9781398463455.jpg?1724535425961",
      "alt": "This image is the cover for the book Lady Bean and Family"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Lady Bean and Family\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Lady Bean and Family, the follow-up to Gerald and Usanna Stribling’s Mr Cabbage and Family, is an in-depth exploration of the world of leguminous plants, presenting a blend of historical, botanical, and culinary perspectives. This book details the development of beans throughout history, examining their botanical structure, emphasizing their nutritional importance and even discussing their sometimes surprising cultural role. The authors share expert knowledge on various aspects of bean cultivation and storage, highlighting different methods of preservation and discussing the health benefits and diverse uses of beans. The narrative takes readers on a global journey, culminating in an extensive collection of recipes that showcase beans in various forms. From savoury snacks popular in the Americas to traditional soybean-based dishes from China and Japan, and even classic French culinary delights, the book provides a wide array of options for cooking enthusiasts and food lovers. Ideal for readers with an interest in food history, botany, and gastronomy, Lady Bean and Family is an informative resource that offers a comprehensive look at one of the world’s most versatile and nutritious plant families.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Gerald Stribling\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Gerald Stribling travelled far and wide in his professional working life, appreciating good food prepared in various ways. After retiring, he decided to look a little more closely at cabbages and the cruciferous vegetables. As he dug into the subject, he realised the field was very large and would keep him out of trouble for some time. Usanna Stribling has always had a love affair with food. She feels she was lucky enough to raise her family on a smallholding, growing their own vegetables. Life has afforded her opportunities to travel and enrich her mind and palate along the way, a love which she continues to nourish by living in France. From offering her humble help as a five-year-old on her grandfather’s vegetable plot and now helping her father compiling this book, they’ve continued on their culinary adventures together.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "epub:type": "cover"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781398463431.jpg",
      "src": "image/9781398463431.jpg"
    }
  })])])])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "Prelims-head"
  }, [_vm._v("About the Authors")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main"
  }, [_vm._v("Gerald Stribling travelled far and wide in his professional working life, appreciating good food prepared in various ways. After retiring, he decided to look a little more closely at cabbages and the cruciferous vegetables. As he dug into the subject, he realised the field was very large and would keep him out of trouble for some time. ")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main"
  }, [_vm._v("Usanna Stribling has always had a love affair with food. She feels she was lucky enough to raise her family on a smallholding, growing their own vegetables. Life has afforded her opportunities to travel and enrich her mind and palate along the way, a love which she continues to nourish by living in France. From offering her humble help as a five-year-old on her grandfather’s vegetable plot and now helping her father compiling this book, they’ve continued on their culinary adventures together.")]), _vm._v(" "), _c('p', {
    staticClass: "Subtitle-tp ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A layman’s handbook on Nutritive Leguminous vegetables")])]), _vm._v(" "), _c('p', {
    staticClass: "Title-tp-1"
  }, [_vm._v("Lady Bean")]), _vm._v(" "), _c('p', {
    staticClass: "Title-tp-2 ParaOverride-2"
  }, [_vm._v("and")]), _vm._v(" "), _c('p', {
    staticClass: "Title-tp-3"
  }, [_vm._v("Family")]), _vm._v(" "), _c('p', {
    staticClass: "Author-tp"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Gerald and Usanna Stribling")])]), _vm._v(" "), _c('p', {
    staticClass: "Author-tp"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Lady-bean.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Austin-Macauley-Publishers-logo.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Copyright-name"
  }, [_vm._v("Copyright © Gerald and Usanna Stribling 2024")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright-space"
  }, [_vm._v("The right of Gerald and Usanna Stribling to be identified as authors of this work has been asserted by the author in accordance with Sections 77 and 78 of the Copyright, Designs and Patents Act 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright-space"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publishers.")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright-space"
  }, [_vm._v("Any person who commits any unauthorised act in relation to this publication may be liable to criminal prosecution and civil claims for damages.")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright-space"
  }, [_vm._v("A CIP catalogue record for this title is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright-space"
  }, [_vm._v("ISBN 9781398463431 (Paperback)")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright-text"
  }, [_vm._v("ISBN 9781398463448 (Hardback)")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright-text"
  }, [_vm._v("ISBN 9781398463455 (ePub e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright-space"
  }, [_vm._v("www.austinmacauley.com")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright-space"
  }, [_vm._v("First Published 2024")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright-text"
  }, [_vm._v("Austin Macauley Publishers Ltd®")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright-text"
  }, [_vm._v("1 Canada Square")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright-text"
  }, [_vm._v("Canary Wharf")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright-text"
  }, [_vm._v("London")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright-text _idGenParaOverride-1"
  }, [_vm._v("E14 5AA")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-head"
  }, [_vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main _idGenParaOverride-1"
  }, [_vm._v("All the images used are either taken by ourselves, have been added by the publishers from their stock library or were bought from 123RF ("), _c('span', {
    staticClass: "Hyperlink _idGenCharOverride-1"
  }, [_vm._v("https://fr.123rf.com")]), _vm._v(")")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('p', {
    staticClass: "Toc"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("Chapter 1\tIntroduction\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("Why Beans and Peas?\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("Chapter 2\tClassification and Description of Peas and Beans\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("2.1 General Description of Leguminous\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("2.2 Leguminous Family\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("2.3 Classification of Leguminous Plants\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("General Description\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("Leguminous Trees and Shrubs\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("2.4 Full Description of the Plants\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.4.1 Leaves\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.4.2 Roots and Nitrogen Fixation\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.4.3 Flowers\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.4.4 Fruit\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("Dry Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.4.5 Grains\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("Bean Seed Size\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("2.5 List of Species by Group\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.5.1 Peas and Mangetout\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.5.2 Broad Beans\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.5.3 Chickpeas\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.5.4 Fresh Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.5.5 Dry Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.5.6 Lentils\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.5.7 Lupins\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.5.8 Peanuts and Groundnuts\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.5.9 Carob Tree Ceratonia siliqua\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.5.10 Tamarind Tamarindus indica\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.5.11. Mesquite\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.5.12 Fenugreek Trigonella foenum-graecum\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.5.13 Liquorice Glycyrrhiza glabra\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.5.14 Rooibos Aspalathus linearis\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.5.15 False Acacia Robinia pseudoacacia\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.5.16 Mimosa Abacia dealbata\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.5.17 Animal Food and Fodder Leguminous Plants\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("Chapter 3\tIntroduction to the History of Peas and Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("3.1\tPre-history of humans and plants\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.1.1 The Big Migration\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.1.2 Settlement and Domestication\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.1.3 Geographical Origin of the Leguminous Plants\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.1.4 The Result and Present Place of the Bean Family\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.1.5 Effects of Domestications\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("3.2 History of the Early Civilisations\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.2.1 Mesopotamia: the Fertile Crescent (About 9000 BC – 100 AD)\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.2.2 Egypt: The Nile Valley (6000 BC-300 AD)\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.2.3 India (9000 BC – Present)\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("Ganges Valley\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.2.4 East Asia China (8000 BC – Present)\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.2.5 Early Mexican Civilisation (8000 BC – 1521 AD)\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.2.6 Early Andean Civilisation (8000 BC – 1574 AD)\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.2.7 The African Continent other than Egypt (4000 BC – 1000 AD)\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.2.8 Australasia (40000 BC): Papua New Guinea, Australia, Vanuatu, New Caledonia, New Zealand\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.2.9 Europe (6000 BC – Present)\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.2.10 The Greek Empire 700 BC – 300 AD\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("3.3 Evolution of Agriculture and Plants Since A.D.0 1\t....")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.3.1 Roman Civilisation\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.3.2 The Arab World 700-1200 AD\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.3.3 Medieval Europe\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.3.4 Christopher Columbus and the Discovery of the Americas\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.3.5 Colonisation and the Slave Trade\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.3.6 Asia 0-2000 AD\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.3.7 European and American and Modern ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("Times\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("3.4 Historical Dates of the Leguminous Plants in Early Civilisations\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("Knowledge of Food Plants at the End of Early Civilisations\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("3.5 List of Plants and their Geographical Origin\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.5.1 Peas\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.5.2 Broad Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.5.3 Chickpeas\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.5.5 Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.5.6 Lentils\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.5.7 Lupins\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.5.8 Peanuts and Groundnuts\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.5.9 Carob Tree (St John bread, Locust bean Ceratonia siliqua)\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.5.10 Tamarind (Tamarindus indica)\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.5.11 Mesquite\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.5.12 Fenugreek (Trigonella foenum-graecum)\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.5.13 Liquorice (Glycyrrhiza glabra)\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.5.14 Rooibos (Aspalathus linearis)\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.5.15 False Acacia\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.5.16 Mimosa\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("Chapter 4\tLeguminous Plants and Folklore...")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("4.1 Expressions\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("4.2 Fairy Tales and Legends\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.2.1 Jack and the Bean Stalk\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.2.2 The Beans of Soissons\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.2.3 Lyrics\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.2.4 Lyrics: Beans and Cornbread\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("4.3 Music\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.3.1 Beans, an American Rapper\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.3.2 Louis Armstrong’s Creole Beans and Rice\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.3.3 Red Beans & Rice Jazz Band\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.3.4 Beans on Toast\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.3.5 Les Haricot Rouges (The Red Beans)\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.3.6 Black Beans and Jazz\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.3.7 Bread and Beans Line Dancing\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("4.4 Comic Strips and Films\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.4.1 Beano\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.4.2 Peanuts\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.4.3 Mr Bean\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.4.4 Tintin\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("4.5. Other Uses\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.5.1 Carat\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.5.2 Michael Lotito (Monsieur Mangetout)\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.5.3 Peashooter\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.5.4 Blowgun or Blowpipe\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("Chapter 5\tCooking and Recipe Codes\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("5.1.1 Codes\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("5.1.2 Notes on the Use of Leguminous Plants and their Cooking\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("5.1.3 Use of Leguminous Derived Products\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("5.1.4 Sprouting Grains of Leguminous Plants\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("5.1.5 New Nutritional Values, Diet and Health\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("5.1.6 Evolution of the Use of Leguminous Grains and Gluten-Free Food\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("Chapter 6\tIndex for Recipes\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("6.1 Soup and Consommé Recipes\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.1.1 Pea and Mangetout Soups\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.1.1 Green Pea Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.1.2 Green Pea and Shrimp Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.1.3 Split Pea Soup\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.1.4 Mangetout Soup with Garlic Bread\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.1.5 Pease Pudding\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("Making Pease Pudding\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.1.2 Broad Bean Soups\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.2.1 Broad Bean Soup with Harissa\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.2.2 Dry Broad Beans with Lamb Soup\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.2.3 Cream of Broad Bean Soup\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.2.4 Broad Bean and Potato Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.2.5 Broad Bean and Courgette Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.2.6 Broad Beans with Red Peppers and Rice Soup\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.2.7 Cream of Broad Bean Pod Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.2.8 Syrian Foul Soup with Dried Fava Beans (Broad Beans)\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.1.3 Chickpea Soups\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.3.1 North African Chickpea Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.3.2 Chickpea Soap Served with Spare Ribs\t....")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.3.3 Chickpea and Onion Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.3.4 Mexican Chickpea Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.3.5 Chickpea Soup for Good Thursday\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.1.4 Fresh Bean Soups\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.4.1 Green Beans Fresh Dill Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.4.2 Fresh Shelled Beans Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.4.3 Fresh Flageolet Bean Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.4.4 Pesto Soup with Pesto Sauce\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.1.5 Dry Bean Soups\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.5.1 White Bean and Red Pepper Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.5.2 Black Beans and Mushroom Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.5.3 Cream of White Bean and Boletus Soup\t...")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.5.4 Mexican Chilli Bean Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.5.5. Japanese Napa Cabbage and Tofu Soup\t.....")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.5.6 Bok Choy and Shrimp Soy Milk Soup\t.....")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.1.6 Lentil Soups\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.6.1 Red Lentil Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.6.2 Lentil Coconut Milk and Lemongrass Soup\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.6.3 Egyptian Red Lentil Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.6.4. Lentils and Swiss Chard Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.1.7 Lupin Soups\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.7.1 Sweet Lupin Pumpkin and Sweet Potato Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.1.8 Peanut Soups\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.8.1 Equatorial Peanut Soup\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.8.2 Ghanaian Peanut Butter Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.8.3 West African Peanut Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.8.4 Indian Peanut Chaat\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.1.10 Tamarind Soups\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.1.10.1 Fish Soup with Tamarind\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.1.12 Fenugreek Soups\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.12.1 Pumpkin Soup with Fenugreek and Alfalfa Sprouts\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("6.2 Salads, Starters, Snacks, Breads and Sauces Recipes\t...")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.1 Peas and Mangetout\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.1.1 Green Pea Salad\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.1.2 Mangetout Salad\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.1.3 Green Pea and Bacon Salad\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.1.4 Green Peas and Vegetable Salad\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.1.5 Mangetout, Beetroot and Orange Salad\t.....")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.1.6 Erbswurst German Green Pea Flour and Sausage Meat\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.1.7 Fresh Pasta with Green Pea Flour\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.1.8 Arancini: Rice Balls Stuffed with Bolognese and Green Peas\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.1.9 Grass Peas and Tomatoes on Drum Bread Toast\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.1.10 Green Pea and Chickpea Fritters\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.2.2 Broad Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.2.1 Young Broad Beans and Olive oil\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.2.2 Broad Bean Salad\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.2.3 Broad Bean Dip\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.2.4 Grilled Broad Beans\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.2.5 Fried Dried Broad Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.2.6 Stir-Fried Fresh Broad Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.2.3 Chickpea\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.3.1 Socca, Farinata, Chickpea Pancake\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.3.2 Genoese Pesto Sauce\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.3.3 Chickpea Fries (Panisse)\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.3.4 Chickpeas Polenta Fries\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.3.5 Chickpea and Chestnut Crackers\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.3.6 Bread Rolls with Chickpea Flour\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.3.7 Fresh Pasta with Chickpea Flour\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.3.8 Chickpea Crackers\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.3.9 Hummus (Chickpea Dip)\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.2.4 Fresh Bean Salads and Starters\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.4.1 Fresh Slender Green Beans and Basil Salad\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.4.2 Fresh Yellow Bean, Red Peppers and Anchovy Salad\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.4.3 Flat Green Bean and Feta Salad\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.4.4 Salad of Fresh Cranberry Beans, Cockles and Mussels\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.4.5 Green Bean and Bacon Bundles\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.4.6 Edamame Soybean Aperitif\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.2.5 Dry Bean Salads\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.5.1 White Bean and Green Pepper Salad\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.5.2 Black Bean and Sweet Corn Salad\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.5.3 Red Bean, Rice and Shrimp Salad\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.5.4 Sushi with Mung Bean Sprouts Salad\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.5.5 Korean Style Mung Bean Sprouts Salad\t....")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.5.6 Salad of Coco Beans with Cockles and Mussels\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.5.7 Peppers Stuffed with Black Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.5.8 Tofu\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.5.9 Grilled Tofu and Vegetables\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.5.10 Soy Sauce\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.5.11 Coco Beans with Cod Paste (Brandade De Morue)\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.2.6 Lentil Salads\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.6.1 Puy Lentil Salad\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.6.2 Coral Lentils and Pepper Salad\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.6.3 Beluga Lentil Basil Salad Sauce\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.6.4 Sprouted Lentil Salad\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.6.5 Roast Lentils\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.6.6 Sprouted Green Lentil Burger\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.2.7 Lupin Salads and Starters\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.7.1 Sweetening of Traditional Lupins\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.7.2 Lupin Beans as Aperitif\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.7.3 Lupin Houmous\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.7.4 Low Carb Pancake with Lupin and Plain Flour\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.7.5 Low Carb Pizza with Sweet Lupin Flour\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.2.8 Peanut Salads and Aperitifs\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.8.1 Roasted Peanuts\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.8.2 Peanut Butter\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.8.3 Sugar-Coated Peanuts\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.8.4 Potato and Beetroot Salad with Peanut Sauce\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.8.5 Indian Peanut Chaat Salad\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.2.16 Mimosa Aperitifs\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.16.1 Mimosa Eggs\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.3 Main Dishes\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.1 Peas/Mangetout Main Dishes\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.1.1 Rice with Green Peas and Broad Beans\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.1.2 Gratin of Peas and Spinach with Brandade\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.1.3 Mangetout with Rice and Shrimps\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.1.4 Lamb Stew with Green Peas\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.1.5 Greek-Style Peas and Potatoes with Chicory\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.1.6 Goat’s Meat Stew with Peas\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.1.7 Chickpeas and Chorizo\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.1.8 Pork Fillet with Coco Beans and Mangetout\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.3.2 Broad Beans Main Dishes\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.2.1 Broad Bean Risotto\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.2.2 Gratin of Broad Beans\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.2.3 Whole Broad Beans with Pork\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.2.4 Stir-Fried Broad Beans and Vegetables\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.3.3 Chickpeas\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.3.1 Lamb with Chickpeas\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.3.2 Andalusian Chickpeas with Spinach\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.3.3 La Cocido Spanish Chickpea Stew\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.3.4 White Shark with Chickpeas\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.3.5 Chickpeas with Beef\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.3.4 Fresh Bean Main Dishes\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.4.1 Coco Beans and Black Cabbage\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.4.2 Fresh Green Bean Gratin\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.4.3 Indian Cluster Beans and Potato Curry\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.3.5 Dried Bean\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.5.1 Brazilian Feijoada\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.5.2 Cassoulet\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.5.3 Garbure\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.5.4 Chilli Con Carne\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("Cooking in Louisiana\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.5.5 Dry White Beans and Sweet Corn\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.5.6 Creole Beans and Rice with Sausages\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.5.7 Oven Dish with Borlotti Beans and Chorizo\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.5.8 Savoy Beans with Diots\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.5.9 Baked Beans On Toast\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.5.10 Loubia White Beans with Beef and Calf’s Feet\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.5.11 Stir-Fried Tofu and Vegetables\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.5.12 Stir-Fried Chicken with Cellophane Noodles\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.5.13 Stir-Fried Shrimps and Bean Sprouts\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.5.14 Akra with Dry Black-eyed Beans\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.5.15 Akra with Black-eyed Beans\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.5.16 Cornbread and Beans\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.3.6 Lentils\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.6.1 Lentils with Herb Sausages\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.6.2 Beef Sausages with Lentils\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.6.3 Wild Duck with Lentils\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.6.4 Lentils with Fresh Pasta\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.6.5 Rice with Lentils ‘Mujadara’\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.6.6 Confit of Duck with Lentils\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.3.8 Peanuts\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.8.1 Beef with Peanuts and Noodles\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.8.2 West African Pork with Beans in Peanut Sauce\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.8.3 Fish with Dried Peppers Sichuan Pepper and Peanuts\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.8.4 Spicy Lamb and Peanut Sauté\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.8.5 Chard, Sweet Potato and Peanut Stew\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.8.6 West African Chicken Peanut Stew\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.8.7 Mafe Senegalai with Two Meats\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.4 Side Dishes\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_vm._v("6.4.1 Peas and Mangetout\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.1.1 Fresh Peas with Lean Gammon\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.1.2 Mushy Peas\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.1.3 Pea Fritters\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.1.4 Green Peas with Capers and Braised Chicory\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.1.5 Mangetout with Sesame\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.1.6 Mangetout Sautéd with Shallots\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.1.7 Mangetout with Carrots\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_vm._v("6.4.2 Broad Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.2.1 Plain Boiled Fresh Broad Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.4.2 Broad Beans and Tomatoes\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.4.3 Chickpeas\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.3.1 Chickpeas with Tomato and Harissa\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.3.2 Chickpeas with Peppers\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.3.3 Chickpeas and Spinach\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.3.4 Galettes of Lentils and Chickpeas\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.4.4 Fresh Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.4.1 Boiled Fresh Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.4.2 Boiled Beans with Onions and Garlic\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.4.3 Beans and Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.4.4 Green Beans with Tomatoes\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.4.5 Green Bean Relish\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.4.5 Dry Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.5.1 White Lima Beans Sauté with Coriander\t...")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.5.2 Kidney Beans with Peppers\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.5.3 Beans and Sauerkraut\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.5.4 Dry Black Beans with Potatoes and Bok Choy\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.5.5 Refried Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.4.6 Lentils\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.6.1 French Lentils with Pork Belly\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.6.2 Black Beluga Lentils with Rice\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.6.3 Brown Lentils with Swiss Chard and Za’atar (Spices)\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.4.7 Lupins\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.7.1 Low Carb Spätzle\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.7.2 Low Carb Gnocchi with Herbs\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.7.3 Gluten-Free Gnocchi with Pesto\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.5 Sweets, Desserts and Drinks\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_vm._v("6.5.3 Chickpeas\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.3.1 Chickpea and Pistachio Biscuits\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.3.2 Fried Churros\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.3.3 Gluten-Free Canistrelli with Chestnut and Chickpea Flour Buns\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.3.4 Canistrelli with Chickpea Flour\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.5.5 Dry Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.5.1 Adzuki Bean Sweets\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.5.2 Korean Sweet Bean Paste Bread\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.5.3 Japanese Red Bean Paste Pancakes\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.5.4 Making Soy Milk\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.5.5. Chocolate Cake with Soy Milk\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.5.6 Soy Yoghurt\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.5.7 Kudzu Japanese Starch Cake\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("6.5.6 Lentils\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.6.1 Lentil and Chocolate Brownies\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.6.2 Lentil Granola Bars\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.5.7 Lupins\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.7.1 Low Carb Pancake with Lupin and Plain Flour\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.7.2 Lupin Spice Biscuits\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.7.3 Gluten-Free Lupin Pancakes\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.7.4 Lupin Carrot Cake\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.5.9 Carob\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.9.1 Carob Cake\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.9.2 Carob Sauce\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.5.10 Tamarind\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.10.1 Tamarind Sweet Balls\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.10.2 Tamarind Date Cake\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_vm._v("6.5.11 Mesquite\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.11.1 Mesquite Bean Jelly\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.11.2 Mesquite Syrup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.11.3 Mesquite Tortillas\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.5.13 Liquorice\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.13.1 Liquorice Root Extract\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.13.2 Black Liquorice Caramels\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.13.3 Liquorice Cake\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.5.14  Rooibos\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.14.1 Rooibos beverage\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.5.15 False Acacia\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.15.1 Acacia Flower Fritters\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.5.16 Mimosa\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.16.1 Mimosa and Lemon Jelly\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.16.2 Crystallised Mimosa Flowers\t")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer012"
    }
  }, [_c('p', {
    staticClass: "Chapter-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Chapter 1\tIntroduction")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-3",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-1-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a sequel to our book "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Mr Cabbage and Family")]), _vm._v(", a review of the crucifer family of edible and useful plants including cabbage, cauliflower, kale, mustards and many other edible plants. (The crucifer plants are plants in which the flower is in the form of a Maltese cross.) That book was a general description of the edible crucifer and their origin history and how they are used, ending with a series of recipes to illustrate the great diversity of their use. We enjoyed the research and discovery. The book was published by Austin Macauley Publishers in 2019.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-4",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-1-02.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-4",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-1-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This book inspired us into writing another book. Again, great discoveries with a lot of historical interest.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The object of the present book, "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lady Bean and Family")]), _vm._v(", is to examine the edible and useful leguminous plants. The leguminous plants are a vast family with many species, from small plants to vines, rooted plants shrubs and trees. The family comprises thousands of species. The edible leguminous plants are eaten all over the world in one form or another. Peas, broad beans and beans are one of four principal foods and also have many uses. Peanuts are found everywhere as an aperitif accompaniment or in food. Lentils are widespread. Certain beans are used for making cakes in Asia. Rooibos, a South African shrub, is used as a drink and used worldwide. The fermented products are used all over the world; there are few houses worldwide where there is not a bottle of soy sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The leguminous plants are of the "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Fabaceae")]), _vm._v(" family (peas and beans family). Most of the edible leguminous plants belong to the "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Papilionaceae")]), _vm._v(" sub-family comes from the French word for ‘butterfly’, "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("papillon")]), _vm._v(", as the leaved flower that resembles a butterfly in flight. Most of the leguminous plants generally have a capacity to fix atmospheric nitrogen and therefore fertilises the soil. Peas and beans are also gluten-free, which these days has become very important.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-5",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-1-04.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-6",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-1-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The book begins with a description of the edible and useful leguminous plants, their positions in the plant family, a general description of them as they grow from small herbaceous plants to vines, roots shrubs and trees. It shows the family tree of the plants concerned and a more detailed description of each. Equally, there is a description of the derived products. The family tree of the plants is followed by an illustration of the leaves, the flowers, pods and fruit. This is a complete detailed description of each member with a number of illustrations.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The next section is about the history and the origin of these leguminous plants. This has been somewhat difficult to research due to the fact that early evidence is rare and often disputed in rival academic schools. There are things that are easy to understand like the fact that the North American beans were not known before the voyages of Christopher Columbus. However, what is strange is that Asian and Chinese beans were not known through the silk road and all the exchanges with the east. Perhaps this was in the same way that beans never came to Europe from West Africa, although coastal trading between West Africa and Europe was active well before Columbus.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The next section we are concerned by discusses the legends and stories about the leguminous plants, like Jack and the Bean Stalk and other stories, songs, musicians and groups, comic strips and films, and others. (We had fun writing this!)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The final section is dedicated to the use of leguminous plants in cooking and in the preparation of derived products. We start by an explication of the set-out and coding of the different recipes. This is followed by a general idea about the culinary use of leguminous plants and derived products. This is completed with a section on the sprouting of the same plants. Next comes a description and nutritive values of these plants and their dietary use. The principal part of this section is the different recipes for the use of leguminous plants; this is divided into five groups. This is followed by some mouth-watering recipes, showing the diversity with which you can cook with them from recipes worldwide.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("Why Beans and Peas?")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer009"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-1-06.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("(Gerald:) The following words give the reasons for my interest in beans that seem to have been with me all my life. I spent my youth in England, and beans were very important during and after the war. Baked beans with sausages and beans on toast: a still important, cheap and nutritious food.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("After working in Africa, my work took me to the South of France where beans are very important all along the Mediterranean coast. Pistou soup is a soup that is found from Genoa Italy to Marseille in France. This soup is based on the herb ‘pistou’ (basil in English) and is made basically from cocoa beans and basil. from Genoa to Nice it tends to be a light soup with onion, garlic and carrot with some pasta; around Marseille, it appears as a heavier soup with meat and pasta. Another bean stew, cassoulet, is a famous dish from Toulouse.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Latterly my work took me to the Americas, where beans originated from. Today, from the southern states of the United States to Peru and Brazil, beans and rice are the basic food staples.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("At about the same time, part of my work was in Asia. Here I found very different varieties of beans. From India to Japan and from Southern Asia to Indonesia, there was a completely different world of beans: sprouted, cooked, caramelized, and fermented.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-break"
  }, [_vm._v("***")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In this book, we have tried to illustrate these different varieties of beans and their vast differences, from soybeans to peanuts. Beans and peas are very popular today, as they are gluten-free.")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic--L",
    attrs: {
      "id": "_idContainer010"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-1-08.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("(Usanna:) As far back as I can remember, I have had a love affair with food. I was lucky enough to raise my family on a smallholding where we grew vegetables, fruits and kept beehives. Our livestock included sheep, goats, geese, chickens, ducks, a turkey and a pig a real menagerie. We grew a variety of vegetables, from the mainstream to the exotic. We would often have gluts of something or other which helped to force my hand in creating new recipes that would help stretch our yields to feed a family and avoid ‘marrow fatigue’, the inevitable feeling of eating the same thing night after night. Life has afforded me opportunities to travel and enrich my mind and palate along the way, introducing me to spices, techniques and ingredients the world over. Travel has certainly helped keep my love of food, good ingredients and experimenting with new tastes alive. A love that I continue to nourish by living in France. Eating delicious food in other people’s homes and my own has been a lifelong pursuit. From Finnish venison or Spanish tapas to North African tagine to stir the senses, and still a whole world’s worth to discover!")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-7",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-1-09.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("From offering my humble help as a five-year-old on my grandfather’s vegetable plot and now helping my father compile this book, we’ve continued on our culinary adventures together. After writing "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Mr Cabbage")]), _vm._v(", which we really enjoyed, we then started to look for beans and peas. This offers an even wider variety and is so diverse and interesting. I hope you enjoy the book as much as we have written it.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer120"
    }
  }, [_c('p', {
    staticClass: "Chapter-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _vm._v("Chapter 2\tClassification and Description of Peas and Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v("2.1 General Description of Leguminous")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Fabaceae")]), _vm._v(" or "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Papilionoideae")]), _vm._v(", normally called ‘leguminous’ plants, are a family of flowering plants that grow as trees, shrubs, vines, perennial or annual herbaceous plants. They are very widely spread and grow all over the world in many climates, from cold to tropical rain forests and the arid forests of America and Africa.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The name "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Papilionoideae")]), _vm._v(" comes from the flowers, whose five drooping, irregular petals resemble a butterfly in flight.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Most leguminous plants have the capacity to fix free nitrogen as a usable form for plant nutrition, thus fertilising the soil with nitrogen. Leguminous plants are very important in the world economy, particularly in the following fields: vegetables for human consumption, e.g. peas, broad beans, chickpeas, beans, lentils, lupins and peanuts.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("These are other uses for leguminous plants.")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "Bullet-list-first"
  }, [_vm._v("As spices: fenugreek, liquorice and tamarind.")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("For wood (and food): mesquite, carob, and acacia.")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("For animal fodder,:clover, lucerne, vetch and soybeans.")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("For green manure: peas.")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("For their flowers: orchids, mimosa and glycine.")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("For derived products: soy and adzuki beans.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Leguminous plants were amongst the first used by early man and provided food in the earliest times: peas, broad beans, chickpeas and lentils in Europe and beans and others in the Americas and Asia.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The leguminous family is large and consists of some 19,000 known and identified species.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _vm._v("2.2 Leguminous Family")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer013"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-02.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer014"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Pea flower")])])]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Numbered-list-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peas and Mangetout")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Broad Beans")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Chickpeas")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Fresh Beans")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Dry Beans")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Lentils")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Lupins")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Peanuts")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Carob")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Tamarind")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Mesquite")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Fenugreek")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Liquorice")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Rooibos")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("False Acacia")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Mimosa")])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  }), _vm._v("2.3 Classification of Leguminous Plants")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-8",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _vm._v("General Description")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The leguminous,"), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Leguminosae")]), _vm._v(" (also called "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Fabaceae")]), _vm._v(" or "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Papilionaceae,")]), _vm._v(" sometimes called the pea, bean family) are a large family of plants, herbaceous, vines, shrubs and trees growing all over the world in virtually all climates and at all altitudes. They are characterized by generally having five-drooping-petal flowers that produce pods containing grains, which have the capacity for atmospheric nitrogen fixation. They can be annual or perennial and are very important economically as they are used as animal and human food, for floral decoration, industrially for natural gums, for dyeing and for the pharmaceutical industry for certain active chemical and other raw materials. The position of the "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Fabaceae")]), _vm._v(" family in the botanic system is shown below.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The following chart shows the position of the "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Fabaceae ")]), _vm._v("or leguminous"), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }), _vm._v("plants:")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-9",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-03.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-10",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  }), _vm._v("Leguminous Trees and Shrubs")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-11",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-05.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-12",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tTamarind\tCarob")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-13",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-07.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-14",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-08.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tFalse Acacia\tMimosa")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-15",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-09.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Mesquite")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor008"
    }
  }), _vm._v("2.4 Full Description of the Plants")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor009"
    }
  }), _vm._v("2.4.1 Leaves")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The leaves are alternated and compound, with multiple leaves: often three but sometimes more. The leaves are often heliotrope and follow the sun to improve the plant’s metabolism.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The following illustrations show some of the different forms:")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-16",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-10.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-17",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-11.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tPea\tPea alpha type")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-18",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-12.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-19",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-13.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tBroad bean\tChickpea")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-20",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-14.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-21",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-15.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tBean\tLentil")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-22",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-16.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-23",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-17.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tLupin\tPeanut")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_vm._v("\t`"), _c('img', {
    staticClass: "_idGenObjectAttribute-24",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-18.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-25",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-19.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tLiquorice\tCarob")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-26",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-20.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-27",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-21.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tMesquite\tTamarind")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-28",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-22.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-29",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-23.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tFenugreek\tRooibos")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor010"
    }
  }), _vm._v("2.4.2 Roots and Nitrogen Fixation")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer037"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-24.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer038"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Root with nodules")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The majority of the leguminous plants live with symbiotic bacteria called "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Rhizobia")]), _vm._v(". These bacteria live in the root nodules of the plant and are capable of fixing atmospheric nitrogen, transforming it into molecular ammonia. This free ammonia radical is transferred in an ammonium salt, which is absorbable by the roots of other plants.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This ability to fix nitrogen allows the plant to be independent for nitrogen nutrition to supply and to feed surrounding plants and equally plant for the next culture. The majority of edible leguminous plants have a simple taproot and nodules. There are exceptions, e.g. peanuts, where the fruit grows underground; liquorice, where it’s the root that is harvested to give the extract; yam beans and kudzu, whose roots grow underground.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The root is a taproot with nodules as illustrated:")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-30",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-25.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-31",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-26.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tPeanuts\tLiquorice")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_vm._v("\t`"), _c('img', {
    staticClass: "_idGenObjectAttribute-32",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-27.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-33",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-28.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tYam bean root\tKudzu root")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor011"
    }
  }), _vm._v("2.4.3 Flowers")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main ParaOverride-7"
  }, [_vm._v("The flowers are five leaved and drooping. Typically:")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-34",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-29.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-35",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-30.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Pea flowers")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-36",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-31.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Broad bean flowers")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-37",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-32.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-38",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-33.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Bean flowers")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-36",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-34.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-39",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-35.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tChickpea flowers\tLentil flowers")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-40",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-36.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-41",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-37.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tLupin flowers\tRooibos flowers")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-42",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-38.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-43",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-39.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tLucerne flowers\tSoy flowers")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-44",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-40.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-45",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-41.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tPeanut flowers\tTamarind flowers")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-46",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-42.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-47",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-43.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tFalse acacia flowers\tMimosa flowers")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor012"
    }
  }), _vm._v("2.4.4 Fruit")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The fruit of the leguminous plant is a pod, which is composed of two halves. These are generally green and are joined by a filament that can be separated when the plant reaches a certain maturity. The pod contains grains, which will develop as the pod grows. The pod will develop progressively and change colour. We harvest some plants before maturity and the rest when they are at full maturity and dry.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("There are a number of ways that fruits can be eaten.")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Numbered-list-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Before maturity of the grains, as for mangetout and broad beans. This can be eaten cooked or raw.")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("At maturity of the grains, as for green peas, broad beans and chickpeas.")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("At full maturity when the pod has dried, as for most leguminous plants.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("There are two exceptions: coco beans that are harvested at the beginning of pod drying; and flageolet beans that are harvested when the leaves start to turn yellow. Here, the plants are pulled from the ground and the beans are separated while they still contain about 45% of water.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Other cases are liquorice, tamarind, yam beans and rooibos.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-48",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-44.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-32",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-45.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tIndian peas\tMangetout")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-49",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-46.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-50",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-47.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tPigeon peas\tBroad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-51",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-48.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-52",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-49.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tChickpea pod\tChickpea")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-53",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-50.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-54",
    attrs: {
      "alt": "C:\\Users\\Mr et Mme HOFER\\Documents\\Peas & Beans Book 20.3.2018\\Pictures Beans & Peas\\Dads photos 4th December 2017\\PIC_0022.JPG",
      "src": "image/Stribling-2-51.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Dwarf beans              Runner beans")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-55",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-52.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Flat bean")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor013"
    }
  }), _vm._v("Dry Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-56",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-53.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-57",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-54.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tCoco beans\tOne-eyed beans")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-58",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-55.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-59",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-56.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tLentils\tLupin pod")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-60",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-57.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-61",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-58.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tPeanuts\tCarob")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-62",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-59.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-63",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-60.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tMesquite\tTamarind")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-64",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-61.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Fenugreek")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor014"
    }
  }), _vm._v("2.4.5 Grains")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main ParaOverride-7"
  }, [_vm._v("The grains vary in form, from kidney shape to round or oval and in the form of lens for lentils.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main ParaOverride-7"
  }, [_vm._v("Typically:")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-65",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-62.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-66",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-63.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tPeas: green or yellow\tBroad beans: light green")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-67",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-64.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Chickpeas: beige or black")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-68",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-65.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Lentils: many colours")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-69",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-66.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" Lupins: yellow")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor015"
    }
  }), _vm._v("Bean Seed Size")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main ParaOverride-7"
  }, [_vm._v("It is very difficult to give a general sense of the size of the different beans; the following are the approximate sizes of some typical beans.")]), _vm._v(" "), _c('table', {
    staticClass: "No-Table-Style _idGenTablePara-1",
    attrs: {
      "id": "table001"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Soisson Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("16-18 mm")])])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Dark Red Kidney Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("17-20 mm")])])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("White Kidney Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("16-18 mm")])])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Cranberry Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("15-17 mm")])])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Pink Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("14-16 mm")])])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Black Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("8-12 mm")])])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Soy Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("6-7 mm")])])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Adzuki Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("5-6 mm")])])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Mung Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("4-5 mm")])])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Wild Mexican Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("4 mm")])])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Wild Andean Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("3 mm")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1-break"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor016"
    }
  }), _vm._v("2.5 List of Species by Group")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor017"
    }
  }), _vm._v("2.5.1 Peas and Mangetout")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-70",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-68.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The pea is an annual or evergreen herbaceous plant of the leguminous family, mainly cultivated in the Middle East, Europe, India and East Asia from Neolithic times and also in East Africa, probably more recently.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The original domestication of the pea is difficult to determine and depends on the type. Each type will be examined in turn.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The plant produces a pod that contains generally green spherical grains, which will dry. In early times, the plants were grown or harvested for the dry seeds, which were cooked. The harvesting of green peas is a fairly recent event, probably dating from the end of the Middle Ages.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("We have the following types of peas:")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table002"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Garden or Cultivated Peas")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Pisum sativum")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Dried Peas and Animal Food")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Pisum sativum")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Marrowfat Peas")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Pisum sativum")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Mangetout Peas")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Pisum sativum")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Snow Peas")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Pisum sativum var. saccharatum")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Snap Peas")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Pisum sativum var. macrocarpon")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Indian Peas")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lathyrus sativus")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Kudzu Peas")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Pueraria montana")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Pigeon Peas")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Cajanus cajan")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.1.1 Garden or Cultivated Green Peas")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-71",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-72.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Peas")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The green pea is an annual plant growing in cool climates and is the most cultivated pea. Originating in the Fertile Crescent, it is now cultivated worldwide and is grown anywhere from simple gardens to large-scale industrial farming to supply pea-processing factories.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The mature pea plant is about 1-2"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("m in height. They are grown generally on support and produce pods about 10"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm long containing about 8-9 peas. These are generally green but sometimes yellow, each weighing from 0.1 to 3.6"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("g.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Today these peas are consumed fresh, canned or frozen and also dried for household use. Freeze-dried peas are also available for domestic consumption or lyophilize for industrial use as a food additive. However, this is relatively recent, as before the end of the Middle Ages peas were always consumed cooked.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.1.2 Dried Peas and Animal Food")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Pea plants have been developed by selection to produce peas that have high protein content and are used mainly for animal food.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Peas are generally of the alpha type. The normal form of pea leaves have three or four pairs of opposed leaves and two or three vine-type filaments. In the alpha type there are only one or two pairs of opposed leaves. It is resistant to falling in rain or wind and is easier to harvest with a combined harvester.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.1.3 Mangetout Peas")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Mangetout peas are the same species as the normal pea but are a variety. The characteristic of this pea, as its French name suggests, is that the whole pod is edible. This pea was developed by selective cultivation.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Other members of the mangetout family are snap peas and snow peas, both of which are edible.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Snap peas are also called sugar peas which are cultivated in the same way as garden peas. Their scientific name is "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Pisum sativum var. macrocarpon")]), _vm._v(". They are of Mediterranean origin and were largely cultivated in Europe, particularly in England in the nineteenth century. They can be grown in open fields in winter and spring and are eaten like mangetout.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Snow peas, "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Pisum sativum var. saccharatum")]), _vm._v(", are thought to be a cross between snap peas and a Chinese snow pea or mutant. In cooler climates, snow peas are grown in the field in winter and spring. The snow pea can be eaten like mangetout. In China, it is grown to maturity to produce seeds, which are sprouted as food.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.1.4 Indian Peas")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This pea is also known as grass pea. It has blue flowers. It is widely grown in Asia and East Africa and is very suited to poor soil and drought conditions. It is used both for human and animal consumption. In many countries, it is considered as a safeguard against famine and drought. It grows at temperatures of 5°C to 25°C and will support floods and drought. The origin of this pea is obscure but is probably India or the Eastern Mediterranean.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("It is somewhat different to the normal pea in that the pea when shelled is green and round but on drying it has a yellow colour and a slightly square form. It is generally used dry. It was widely cultivated in Southern Europe for hundreds of years, but today has generally disappeared, but still present in parts of Italy and Spain.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In Italy these peas are used in the Florence area. In the South of Italy, there is a typical popular soup made from grass peas and served on bread made from durum wheat in Bari.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In Spain, in the region of La Mancha, the popular dish, ‘Gachas Manchego’, is made from pork and grass pea flour.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The dried peas should be soaked and boiled before use. The Indian pea contains small quantities of neurotoxins which do not cause problems in normal usage; however, it has been noted that there can be problems if eaten too often. This is the staple diet in much of India.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.1.5 Kudzu Peas (Japanese Arrowroot)")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer083"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-73.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer084"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Root with nodules")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a very strange pea. It is a quick-growing ‘everlasting vine’ native to East Asia and Japan. The fruit is a hairy pod containing peas, and the plant has a large taproot. The whole of the plant is edible but is not often used for human consumption. The root is very rich in starch and copper and when dried produces Japanese arrowroot, which is the main ingredient for starch cakes, an important ingredient in desserts in Eastern Asia. The whole plant can be used as food for livestock, particularly for goats on poor land.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Both grains and roots of the plant have an important place in traditional Chinese medicine as they contain many isoflavones. The extracts from Kudzu are used for the treatment of tobacco and alcohol dependence. They are present today in homoeopathic treatments worldwide.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The plant is very vigorous and if allowed will climb shrubs and trees and smother them, causing them to die.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The long-dried stems of the kudzu pea are used in wickerwork for making mats and baskets.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The Kudzu pea was introduced into the United States in the 1800s as a decorative plant, as it is very pretty. Later, it was used as a soil improvement crop and as an anti-soil erosion plant and operated well in these functions. However, if not controlled it is very invasive. The control of the plant is difficult as it reproduces by both seeds and runner roots. Since the seeds can stay inert for many years, it is necessary to destroy the root crown. Apart from using unacceptable herbicides, it is a long and difficult process to decontaminate the soil.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.1.6 Pigeon Peas")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer085"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-74.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer086"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Pigeon peas")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This pea was first domesticated in the South of India, first grown in about 1500 BC. The plant is a tropical shrub, either annual or perennial, and grows in deciduous woodlands. It can be from 1 to 4 metres  and has yellow flowers. Its pods generally contain four to five green to yellow or brown peas, which are speckled and slightly oval. The plant moved to Southern Asia and to East Africa and from there to West Africa. It was found by early European explorers and called the Gungo bean. Later on, it moved to the Americas with the slave trade.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The pea can in some cases last from three up to five years; however, the yield drops after the second year. For pea production, annual culture is better.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The pea grain is very rich in proteins and eaten with a cereal makes for a very rich diet. Today it is grown worldwide and is particularly popular in the Caribbean Islands and in Central America, where it is used in lots of traditional dishes.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The pigeon pea can be sprouted before cooking. This has the advantage of making the cooked bean more digestible.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor018"
    }
  }), _vm._v("2.5.2 Broad Beans")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer087"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-75.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer088"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Broad beans")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Broad beans are an annual plant of the leguminous family that can grow from 0.5 to 2.0 metres. The plant is erect and self-standing and will produce white flowers with black spots that after pollination by insects will give a pod with grains. These European broad beans are of the genus"), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v(" Vicia")]), _vm._v(" of the "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Fabaceae")]), _vm._v(" family.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("There are two main types of European Broad Bean:")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table003"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Common or Garden Broad Bean")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Vicia faba")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Horse or Field Broad Bean")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Vicia faba")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.2.1 Common Broad Beans or Garden Broad Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is the classic broad bean used in Europe for general consumption. The plant is generally about 60 cm high and has a heavy central stem with a square section. It will give as fruit a pod, which will develop until the grains are between 20 and 25 mm. At maturity, the pod, previously green, thick and slightly hairy, will dry and become almost black.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("For consumption, the harvest will usually be a week before green maturity. The beans are harvested when the pod is still green and the grains have not started to harden. The beans are harvested manually and the grain is separated from the po. The grains are generally boiled to eat, either with the skin or without.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In countries around the Mediterranean, the pods are harvested well before maturity and after removal from the pod are eaten raw or with salt or olive oil. In some parts of Southern Spain, the pods are harvested even earlier and cooked with the pods.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.2.2 Horse or Field Beans")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer089"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-76.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer090"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Horse beans")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This broad bean is very similar to the common broad bean and is cultivated for both human and animal consumption. The grain is smaller and darker and has a stronger flavour than the common broad bean. It is, however, referred to in some countries as the ‘normal’ broad bean. For example, in Egypt, this bean is preferred to make bean dips like hummus and falafel.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("There are two other beans that are similar to the European broad bean. They are the Jack beans (called the Brazilian broad bean) and the sword beans. These two beans belong to the genus "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Canavalia")]), _vm._v(" of the "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Fabaceae ")]), _vm._v("family. They are from a group of some 50 plants of climbing vines, whose origin is in the Hawaiian Islands.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor019"
    }
  }), _vm._v("2.5.3 Chickpeas")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer091"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-77.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer092"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Beige and black chickpeas")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Chickpea is an annual leguminous plant that grows around the Mediterranean as well as in Asian countries. The plant grows to 50-70 cm. It has many branches and grows like a bush. The branches are covered with feathery leaves, which end in small pods, each containing two or three peas. ")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("There are four types of chickpeas.")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table004"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Desi Chickpeas")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Cicer arietinum")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Bombay Chickpeas")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Cicer arietinum")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Kabuli")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Cicer arietinum")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Black Chickpeas")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Cicer arietinum")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.3.1 Desi Chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This chickpea has a dark coat and a rough surface. It grows mainly in India and surrounding countries. These peas have much higher fibre content than other chickpeas, and they are lower in sugar.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.3.2 Bombay Chickpeas, Desi Dahl")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This chickpea is very similar to the Desi chickpea but is darker and smaller.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.3.3 Kabuli")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is the conventional chickpea used in most parts of Europe. It is light in colour and about 10"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("mm in diameter. It is called Kabuli as it is believed that it originates from Afghanistan.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.3.4 Black Chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This chickpea from South-Eastern Italy is totally black-skinned and slightly larger than the Kabuli type. It is called ‘"), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("ceci nigra")]), _vm._v("’ in Italian and is popular all over southern Italy.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor020"
    }
  }), _vm._v("2.5.4 Fresh Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Fresh beans are from the common bean family ("), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Phaseolus vulgaris")]), _vm._v(") and have pods that are harvested well before maturity, often before the beginning of seed formation. However, in some cases the seed is formed and more developed, as with kidney beans, when the grain is formed but not mature. In other cases, the grains are formed but the pods not quite dry, as with flageolet or coco beans.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("All beans derived from the original wild bean were of the vine or climbing type; the bush bean is a fairly modern development, produced by selective breeding. The vine type of bean flowers from the bottom up and is harvested progressively. This progressive harvest is convenient in a small garden or market garden, while the object of the development of the bush bean was to have a plant that would be easier to grow, where all the pods matured at the same time, allowing modern methods of harvesting to be carried out.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Fresh beans as food are relatively recent; up to the end of the 1600s, beans were only used dried and after soaking and cooking. At this time, it was found in the south of Italy that the immature bean could be cooked and eaten. After this, the cooking of green beans progressed, and it was Catherine de’ Medici who introduced the green beans to the royal French court.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In 1872, a French farmer, G. Chevrier, found that when an immature green bean is fully formed but not dry, it could be harvested: you harvest the bean pods, then shell them, and the resulting beans can be cooked. Thus the flageolet was born.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Fresh beans can be a bush or climbing type of plant and the colour can vary from yellow to green or violet. There are so many different sorts of beans; some of them you eat as a whole bean and others you have to pod them.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The harvest is generally carried out by hand for both bush and climbing types; however, in the case of intensive production for conserves, the harvest is generally mechanical.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Generally, the growing time averages for fresh beans is about 50 to 60 days for the bush type and longer for the climbing varieties.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main ParaOverride-7"
  }, [_vm._v("Types of fresh bush beans:")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("A. Fresh bush beans are found in three principal colours:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Numbered-list-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Green")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Purple to black")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("They are also found in a number of different forms.")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "Bullet-list-first"
  }, [_vm._v("Round and short")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Tall, long and short")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Broad")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In most cases, the beans will be from 16 to 24"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm long.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Climbing beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Climbing beans are of two types: short, growing to about 1"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("metre high; and the general run of the mill, growing to about 2"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("metres. In the two cases, you find the same type of variations in colour and size as in the bush type. The length of the pods will vary from about 20"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm to about 25"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("There are many cultivars of beans depending on the climate and tastes in the area.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Most of the fresh beans belong to the "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Phaseolus vulgaris")]), _vm._v(" family. One exception is the asparagus bean, "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Vigna unguiculata")]), _vm._v(", also known as the yard-long. This is a herbaceous plant of the leguminous family, which seems to have its origins in semi-tropical Africa and is now grown in semi-tropical areas all over the world. This climbing plant, which can grow to 3-4 metres high, produces pods of up to 1"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("metre in length. The pods are edible and have a taste between beans and asparagus. The seeds are green and round and are edible when fresh.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Certain cultivars of the plant can be cultivated in a temperate climate with a warm southern exposure.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Today the following fresh beans are widely available:")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table005"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Mangetout Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Green, yellow or black.")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Need ends trimming before cooking.")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Diameter: 6 - 10 mm"), _c('br'), _vm._v("Length: 100 - 115 cm")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Flat Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Generally green.")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Needs trimming and string removed.")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Thickness: 3 - 4 mm"), _c('br'), _vm._v("Width: 10 - 15 mm"), _c('br'), _vm._v("Length: 20 -30 cm")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Kidney Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Need to be prepared the same as flat beans.")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Thickness: 5 - 8 mm"), _c('br'), _vm._v("Width: 10 - 15 mm"), _c('br'), _vm._v("Length: 20 - 25 cm")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Flageolet Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Need to be podded.")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Coco Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Generally white or striped with red.")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("When pods dry out they go brownish and crinkled.")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Yard Long Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("All these beans are available fresh most of the year-round nowadays or either deep-frozen or canned.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("2.5.5 Dry"), _c('a', {
    attrs: {
      "id": "_idTextAnchor021"
    }
  }), _vm._v(" Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Note: Peanuts and groundnuts are treated later.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The bean is a very old vegetable but only known in Europe after the return of Columbus from his first voyage to the Americas. The bean is typically an annual herbaceous plant of the leguminous family. It is generally a vine and climbs on any support available. It produces longish pods which contain grains that we call beans.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("However, there were other bean-cultivating areas: the Indus Valley, East Asia, Papua New Guinea and the Pacific isles, and West Africa. ")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("We will deal with each case.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2a"
  }, [_vm._v("The American Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("There are two basic origins of beans in the Americas, Meso America and the Andin highlands part of South America, the beans from this area have the genus name of "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Phaseolus")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("When Columbus arrived in the Caribbean. Island, he found five varieties of beans being cultivated by the Pre-Columbian population.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Pre-Columbian Culture of Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("When Columbus and other explorers came to the New World, they found a new way of cultivating crops.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The culture was often carried by a number of tribes working together.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In the case of beans, a field would be sown with patches of maize of about six plants and when the maize grew to a certain height, they would sow the beans around the maize. The bean as they grew would climb the maize and develop.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Around the bean plantation, they would sow squash, the beans by their nitrogen fixation would feed the maize and squash, the beans being heliotrope would follow the sun and provide shade for the squash. This type of culture was successful and even protected the crops from wild animals. The method is still used in certain regions is called the culture of The Three Sisters.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main ParaOverride-7"
  }, [_vm._v("The following are the varieties found in the Americas:")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table006"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Tepary Bean")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Phaseolus acutifolius")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Runner Bean")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Phaseolus coccineus")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Lima Bean")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Phaseolus lunatus")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Common Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Phaseolus vulgaris")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Trailing Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Strophostyles umbellata")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Yam Long Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Pachyrhizus")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Jicama")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Pachyrhizus erosus")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Goitenyo")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Pachyrhizus tuberosus")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Ahipa")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Pachyrhizus ahipa")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.1 Tepary Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This bean is an annual plant of the leguminous family, it is a drought-resistant species of the "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Phaseolus")]), _vm._v(" genus. It is native to the desert regions of South Western United States and Northern Mexico. It was cultivated by Amerindians in pre-Columbian times in river beds and valleys after the spring floods. It was harvested 60-129 days after sowing. The plant can grow to 3-4"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("m, has three slightly pointed leaflets, has a white flower and gives a pod with 2-7 grains. The plant has been cultivated in northern Mexico since 5000 BC.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.2 Runner Beans (scarlet runner beans)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This bean is native to the mountains of Central America and Mexico.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("It is an annual plant of the leguminous family, a vine reaching 3 meters in height, the three-leaved leaf is pointed, giving generally red flower that produces a knife-shaped pod containing coloured beans.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The bean is grown both as food and for decoration, as food the green pods are edible young and the dry beans.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This bean is cultivated worldwide and is used in many kitchens.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.3 Lima Beans (butter beans)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The Lima bean is native to the Andes and Mesoamerica, it would appear that two different developments took place, the first in the Andes in about 2000 BC giving a large white bean of the Lima type, and a second in Mesoamerica in about 800 AC giving a smaller bean kidney shape.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.4 Common Beans (string beans, field beans, flageolet beans)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This bean is an annual plant of the leguminous family and has a lot of diversity in its forms. It is native to the Americas and was domesticated separately in Mesoamerica and the Andes, the two distinct types exist today. The common bean is with maize and squash, the third member of the ‘Three Sisters’ famous base of North American agriculture.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The common bean started as a vine growing to about 2-3"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("m, cultivars of the bush type have been developed growing to about 60"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm. All varieties have green or purple leaves which are divided into three oval leaflets. The flowers are white, pink, yellow or purple and give pods containing 4-6 beans.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The common bean is cultivated all over the world and is the most important bean producer.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.5 Trailing Beans (pink fuzzy beans)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a bean of the vine type belonging to the leguminous family it is native to North America, Eastern Canada and Mexico. It has a fuzzy stem that will grow up to 3 meters long, has a leaf with three leaflets, the pea light purple flowers grow on the leaf stalks and give fuzzy pods containing black hairy beans. The plant grows as a weed in abandoned or worked land and seashores. It is not cultivated but was used by certain Native American Indians as medicine and food.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.6 Yam Long Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a rather surprising member of the legume family, as it has swollen taproot that is often edible. The genus is small with five or six species.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.7 Jicama")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer093"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-79.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer094"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Jicama")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Also known as Mexican yam bean or Mexican turnip, this is cultivated for its large taproot. The plant is a vine that can grow to a height of 4-5"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("m given support, the root can attain some 2"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("m and weigh up to 2"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("kg. The vine gives white or blue flowers that give pods similar to the Lima bean. The root is edible either raw or cooked, the rest of the plant is poisonous, and the seeds at maturity contain a chemical that can be used as a pesticide or insecticide.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Its origin is Mexico and Central America, it was taken to the Philippines by the Spanish and has spread through Asia where it is popular. It is also very popular in West Africa.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.8 Goitenyo")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Goitenyo, the Amazonian yam bean, is an annual vine of the leguminous family. It has a thick and hairy stem with a ligneous base, giving white to lilac flowers which give pods 10-20"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm long containing beans that are edible and very rich in proteins. All part of the plant is edible, and the leaves can be fed to livestock.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The vine is indigenous to the Amazonian tropical rain forests and is cultivated by native Indians who practice shifting horticulture.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.9 Ahipa")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer095"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-80.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer096"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Ahipa")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This plant is known as the Andean yam bean, it’s not too similar to other beans, it’s a tall bean but is not a vine, and has longer tubercles than jicama. The plant originates in the Andes and can grow up to 2000 meters in altitude, it is commonly found in the Bolivian highlands and in the Argentinian provinces of Salta and Juyjuy. In the 1800’s it was introduced into the Caribbean Islands where it grows regularly as food eaten raw and cooked.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3 ParaOverride-1"
  }, [_vm._v("The Indus Valley Beans")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table007"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Moth Bean")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Vigna aconitifolia")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Black Gram")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Vigna mungo")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Mung Bean")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Vigna radiata")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.10 Moth Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This bean is native to the Indus Valley and is an annual creeping herbaceous plant of the leguminous family. The plant when adult will cover the ground and attain 4"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm height and cover 1.5"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("m of ground, it gives yellow flowers that produce brown pods from about 5"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm long which give 4-9 beans. These beans exist in a variety of colour’s from yellow-green to black. The bean is very rich in proteins, but like most beans needs soaking and cooking to destroy the toxins.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The plant is drought-resistant and has been traditionally cultivated in the arid areas of India and Pakistan, today it is cultivated worldwide.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.11 Black Gram")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This bean is also known as mungo bean when whole but once, dehusked and split it is white and is known as Ural Dal.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This annual herbaceous plant of the leguminous family is an erect or semi-erect trailing hairy plant that will grow to 30-100"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm in height with a taproot with smooth nodules, the pods are cylindrical and up to 6"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm long.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The origin of black gram in India and it is today one of the most cultivated pulses in India and Pakistan and is now cultivated worldwide.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.12 Mung Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Also known as the green gram, this bean is an annual herbaceous plant of the leguminous family, it is an erect, slightly trailing plant from 15 to 100"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm high the stem is branched sometimes twining at the top. The leaves are alternate, trifoliate with elliptical or oval leaflets, 5-18"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm long and 3-15"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm broad. The flowers are "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Papilionaceae")]), _vm._v(" yellow or green in colour giving pods that are cylindrical and pending, they contain 7-20 small elliptical grains variable in colour from green to brown or black.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The Mung bean may have been domesticated in Persia, but has been present in India for very long-time archaeological evidence goes back more than 4000 years.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2a ParaOverride-1"
  }, [_vm._v("The East Asian Beans")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table008"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Adzuki Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Vigna angularis")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Soy Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Glycine max")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.13 Adzuki Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This plant is an annual or perennial herbaceous member of the leguminous family. It is a bushy erect or twining from 30 to 90"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm high. There exist climbing varieties; the stem is green and slightly hairy. The root is of the taproot type and can penetrate to 40-50"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm. The leaves are trifoliate, pinnate and arranged alternately along the stem on a long petiole. The leaflets are oval 5-10"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm long and 5-8"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm wide. The flowers are bright and give pods of 5-13"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm long containing up to 14 beans, generally red but may vary.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The origin of the adzuki bean in Japan, Korea and China, first domestication in its present size dates from about 2000 BC, today it is cultivated all over Asia.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The main use of the bean is to produce the sweet bean paste, which is the base of desserts in cakes and sweet bread all over Asia.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.14 Soy Beans")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer097"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-81.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is an annual herbaceous plant of the leguminous family that grows erect to a height of 1.5"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("m high with a thick stem covered with thick brown hairs. The leaves are alternate, trifoliate with oval leaves and short peduncle the basal ones simple. The flowers with white or white-violet 5-6"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm long in clusters. The pods are up to 7"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm long with one to four to form beans, the colour depending on the variety, yellow, black or green.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The plant grows wild in China and its origin is South-East Asia, there is evidence of its existence very early, it was domesticated in about 2800 BC.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The soya bean genus is divided into two sub-genus.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("2.5.5.14.1 Glycine")]), _vm._v(" soy that contains the wild varieties of soy including the ancestors of present-day cultivated soybeans.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("2.5.5.14.2 Glycine Edamame")]), _vm._v(" max that contains the present-day cultivated soybeans:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The yellow and black soybeans are now cultivated worldwide.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v(" The Edamame soybean, this bean is harvested immature and green and looks somewhat like a broad bean and has four grains per pod. This bean was first reported in Japan in the 1299’s and is popular in Japan as an aperitif, in a similar way as the European lupin in Spain and Portugal, but is easier to prepare as it only needs cooking and for this reason, it has spread all over the world.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The edamame soybean came to Europe in the 1700s and to America in the 1800s.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Its development all over Asia was important basically as food and secondly for all the derived products that have been produced for centuries, bean sprouts, soy milk and all the fermented products, tofu, soy sauce, miso.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In the United States, the use was to an extent the same as in Asia but it was found that the soybeans could be used as animal feed.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-72",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-82.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Harvesting beans")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2a"
  }, [_vm._v("The South East Asian and Pacific Beans")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table009"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Rice Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Vigna umbellata")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Winged Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Psophocarpus tetragonolobus")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.15 Rice Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("The rice bean is a warm climate short-lived perennial plant of the leguminous family. It is normally cultivated as an annual and is generally 30-100")]), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("cm high, but has a variable habit and can attain 200")]), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("cm. In fact, in some areas, it is called the mountain climbing bean. The bean produces bright yellow flowers that give cylindrical pods 7.5-12.5")]), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("cms long that contains 6-10 beans 6-8")]), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("mms long with a kidney shape, the beans are variable in colour going from yellow to brown and red.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The rice bean is used as food for humans and animals, the green parts are also edible and can be dried to make hay for livestock. The beans are somewhat difficult to cook because of the tough skin and should be dehusked before boiling or cooking.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The plant originated in Indo China where it is wild, it was first domesticated in Thailand from where it spread all over Asia and the Indian Ocean. It is grown and is popular in Northern India and the Himalayas, also grown in Central America and Brazil.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.16 Winged Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("This is a perennial vine of the leguminous family, mainly grown as an annual. The Winged bean grows as a climbing vine up to 3-4")]), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("m high and gives pale blue flowers that in their turn pods typically 15-22")]), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("cm long with four wings with feathery edges. At maturity, the pods turn brown and split releasing the beans that are similar in colour and content to soybeans. The plant is of a variable type the leaves may have different forms and colours; the beans can vary in colour and shape.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The whole of the plant except the beans is edible raw or cooked, even the tuberous roots. The beans need to be boiled for 3 hours to remove toxins.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The plant is native to New Guinea but is now cultivated in tropical areas.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2a"
  }, [_vm._v("The African Beans")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table010"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Cowpeas (Beans)")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Vigna unguiculata")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Guar Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Cyamopsis tetragonoloba")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Lablab Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lablab purpureus")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Velvet Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Mucuna pruriens")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Yardlong Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Vigna unguiculata subsp. Sesquipedalis")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Cornille Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Vigna unguiculata subsp. Unguiculata")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.17 Cowpeas (beans)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Also known as the black-eyed bean or yardlong bean, is an annual herbaceous plant of the leguminous family originating in West Africa and probably Ghana. It is a warm-weather plant growing in many different conditions, it can be erect, droopy or even trailing depending on the method of culture and the climate. From its original home, it travelled to East Africa to Asia and was grown all over the old world and then to the Americas with the slave trade. Today it is one of the most cultivated beans in semi-tropical areas worldwide.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In certain countries, it is eaten at all stages of growth, typically in Tamil Nadu where it’s very popular it is eaten green with the leaves in soups often with tamarin and is also eaten dried and cooked.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.18 Guar Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("This plant is also called the")]), _c('em', {
    staticClass: "italic CharOverride-5",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Cluster bean, is an annual herbaceous member of the leguminous family. It grows to a height of 1-2")]), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("m gives rose flowers that give in their turn clusters of pods containing the guar bean seeds. The origin of the plant is not known, it is believed to have originated in Africa as they have similar species, the first domestication of the plant was in Indus and Pakistan the plant resist drought as is very useful in dryer areas.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The guar bean contains gum that is very important as a thickening agent for the food industry.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Today the gum is also used as a thickening agent for water in the fracturing oil shale and has become an important market for bean producers.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The cluster beans are considered as a very interesting rotation crop in drylands as nitrogen fixation, this technique is widely used in Rajasthan.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.19 Lablab Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a climbing herbaceous plant generally annual sometimes a short-lived perennial of the leguminous family. It is widely grown in the tropical areas of Africa, Asia and the Americas. It is used both for human and animal food. Its origins are obscure and thought to be Africa or Pakistan.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The plant produces violet flowers and is cultivated in certain areas as a decorative plant.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.20 Velvet Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This plant is a tropical shrub vine of the leguminous family growing in Africa and Asia. It is a hairy plant whose vines can develop up to 15 meters and when young are very hairy and well known for itchiness by contact with the young vegetation. When the plant is older it loses its hairiness.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The plant is mainly cultivated for animal food and forage, it can be dried, or used to make silage.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In some parts of the world, the beans are eaten; typically, it is popular in the Indonesian islands of Java.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("One of the important uses of the velvet bean is in agriculture as green, manure or a rotation plant as being leguminous, it will fix nitrogen that is available for the next crop.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The seeds are also used in medicine as they contain quantities of active ingredients.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In certain states in the USA like Florida, the plant is considered an invasive weed as it tends to escape from its cultivated areas and invade deserted land and shore fronts.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.21 Yardlong Beans")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer099"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-83.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer100"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Yardlong beans")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("This annual climbing vine grows in the tropics and sub-tropics and gives pods that can reach 50-80")]), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("cm long and is excellent green for human consumption.")])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.22 Cornille Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This bean is thought to have originated in West Africa in the savannas of Burkina Faso, Ghana and as far as the Belgium Congo. It is a bean of average size and today grows all over the warmer parts of America and Asia, particularly in the Southern states of the USA and Brazil.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The beans need to be cooked for about 10 minutes fresh and 40 minutes dry. They give a slightly sweet taste.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2a"
  }, [_vm._v("The Sub-Species and Cultivars")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table011"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Cranberry Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Phaseolus vulgaris var. cranberry")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Tarbes Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Phaseolus vulgaris var. tarbes")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Soisson Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Phaseolus vulgaris var. soissons")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.23 Cranberry Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This bean developed in Columbia from the common bean has a hazelnut colouring with black or purple splashes. This was brought to Italy; in the early 1889s, it was further developed to give slightly different beans called the Borlotti bean, both names are used today as many commercial cultivars exist. These beans are popular all over the Americas, in Italy, Portugal, Greece and Turkey.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.24 Tarbes Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This bean was developed in the South West of France a little time after the bean crossed the Pyrenees from Spain with seeds from the beans that Columbus brought to Spain. This bean followed a long development and was used to prepare the two, major dishes of the region Garbure and Cassoulet. These beans have obtained a geographical agreement that limits the area where they can be cultivated, with a specification for the beans. That it’s to have a certain size, be white with a thin skin and have a creamy texture and not a taste of flour.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.25 Soisson Beans")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer101"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-84.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer102"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Soisson beans")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This bean was found in the town of Soisson in the North East of France, it is a very large white bean that has developed locally and has obtained a geographical certificate.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor022"
    }
  }), _vm._v("2.5.6 Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("The lentil was one of the first plants domesticated by early man. Its origin is unknown but it was in the Middle East probably in Syria or Turkey. Archaeological remains have been found dating to about 7000 BC. These remains were lentils seeds from wild plants that had been collected. Lentils were widely used in Egypt and later by the Greeks and Romans.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("The lentil plant is an annual herbaceous bushy plant of the leguminous family occurring all over the world in many different types. The plant grows to a height of about 75")]), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("cm high. The stem is angular and hairy, the leaves are compound alternate and have up to 7 pairs of oval leaflets, the flowers are grouped on stems and vary a lot in colour from white to yellow, pink and purple. The flowers give pods that are about 1.5 cm long containing two seeds of about 5")]), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("mm in diameter. The colour of the skin and the cotyledons is variable depending on the variety.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Lentils are commercialised in different forms according to their use.")])]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "Bullet-list-first"
  }, [_vm._v("Whole, generally used for cooking. The cooking must be done very carefully with a minimum of water, to be added as the cooking progresses to maintain the shape and skin.")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Peeled or peeled and split. The lentil has a tendency to melt and is often used in soups or to thicken a dish or stew. It is possible to keep the form but this requires careful attention.")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Flour. This flour is used in many ways, to thicken dishes or as an additive for cakes, pastry, pasta and bread.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("There are many different varieties of lentils in the species "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lens culinaris")]), _vm._v(". In India which is the largest consumer of lentils, there are about 50 different varieties cultivated. We will consider the main types. It should be noted that lentils must be cooked before eating as like many beans they contain toxins that are destroyed by cooking.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main ParaOverride-7"
  }, [_vm._v("The following are the main types:")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table012"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Black Beluga Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lens culinaris")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Brown Spanish Pedrina Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lens culinaris")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Green Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lens culinaris")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Puy Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lens esculenta puyensis")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Verdina Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lens culinaris")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Urad Dal Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lens culinaris")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Queen Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lens culinaris")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Armura Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lens culinaris")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Crimson Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lens culinaris")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Indian Head Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lens culinaris")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.6.1 Black Beluga Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("This is a small shiny black lentil about 5")]), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("mm in diameter and is called Beluga because of its resemblance to caviar and since it is the most expensive. It originates from Syria or Turkey and is cultivated worldwide, Canada being a large producer. It has thin skin and normally keeps its form after cooking which requires about 20 minutes on low heat, it is the lentil with the highest content of protein and is used in particular for salads and soups.")])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.6.2 Brown Spanish Pedrina Lentils")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer103"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-85.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer104"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Brown lentils")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Sometimes, it is called brown lentil that is a small brown and melts when cooking, was cultivated in the Pyrenees, but today is largely produced in the United States. It is earthy brown to reddish-brown, yellow inside, often used with pasta or salad and generally Mediterranean food, needs slow cooking on low heat for about 30 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.6.3 Green Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is the green lentil grown in France, Germany and Russia, the European green lentil.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.6.4 Puy Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This plant is derived from the standard European lentil but has been cultivated in a particular area in Southern Central France, Puy-en-Valley, Rhone Department. The particular area has a good exposure to the sun and a micro-climate that suits this type of lentil its cultivation dates back to 1647.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.6.5 Verdina Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a small and green lentil, and is mainly used in South America and is often served in stews and baked dishes with chilli. It requires about 30 minutes of cooking.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.3.6.6 Urad Dal Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This lentil is from India where is cultivated largely, it has an ivory white colour and is very rich in proteins, and for this reason, it is a good replacement for meat. The flour is used for making bread and in particular poppadums.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.6.7 Queen Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is one of the largest lentils it is yellow and flattened.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.6.8 Armura Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This lentil comes from the Spanish area of Salamanca, it is a blonde yellow colour. This lentil is very large and is considered one of the best tasting.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.6.9 Crimson Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("A lentil from Turkey.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.6.10 Indian Head Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Known also as the Egyptian lentil.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor023"
    }
  }), _vm._v("2.5.7 Lupins")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The genus lupines contain many species about 600 which are very diverse, the plant is a herbaceous annual or everlasting and belongs to the leguminous family. It is a flowering plant. The lupin plant produces beans, and has been eaten by humans and animals from very early times. They are very rich in proteins.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("There were two sites of early domestication one in the old-world Mediterranean basin and another in the new world Andes.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Lupins are also used as decoration; they have very beautiful flowers and lots of different colour’s.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2a"
  }, [_vm._v("Mediterranean and European Lupins")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table013"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("White Lupins")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lupinus albus")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Yellow Lupins")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lupinus luteus")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Gallery Blue Lupins")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lupinus cosentini")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.7.1 White Lupins")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("This is thought to be the first domesticated lupin, grains were found in tombs of the Phaethon’s, used by Egyptians as food. Cultivated and used by the Greeks It is an annual plant growing to 50-120")]), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" cm")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" high, it has white flowers that give pods containing grains rich in proteins and containing bitter alkaloids, that have to be removed by soaking and cooking. This lupin is widely grown all around the Mediterranean and even in Germany. It is a popular aperitif dish all around the Mediterranean and particularly in Spain, Portugal and Southern France. The preparation, for removing the bitterness is long.")])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.7.2 Yellow Lupins")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The European lupin or yellow lupin have been cultivated around the Mediterranean and in the Nile valley, seeds were found in the tomb of Ramses 111, about 1500 BC. This lupin does contain bitter alkaloids and requires preparation of soaking and cooking being used generally it is served in brine as a snack or street food all-round the Mediterranean.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.7.3 Gallery Blue Lupins")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This lupin is mainly grown for livestock feed and green manure, it is a deep-rooted annual plant growing to about 120 cms. It contains large quantities of bitter alkaloids and care must be taken with animal feed.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2a"
  }, [_vm._v("The Old World Lupins")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table014"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Andean Lupins")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lupinus mutabilis")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Australian White Lupins")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lupinus angustifolius")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.7.4 Andean Lupins")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer105"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-86.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer106"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Lupin flower")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lupinus mutabilis")]), _vm._v(" was cultivated in the Andes by pre-Inca civilisations in about 600 BC. These lupin beans were used as food by the Incas and were also eaten by previous civilisations, they spread all over South America the New World lupin beans contain generally lower bitter alkaloids than the European types.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.7.5 Australian White Lupins")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This lupin known as the narrow-leafed lupin grows in Australia and has a lower level of bitter alkaloids than the other lupins.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Sweet Lupins")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("A lot of genetic work has been carried out on lupines to produce nontoxic food for humans and animals.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The first low alkaloids lupins were produced in Germany in the late 1920s, but this work was not continued.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In Australia farmers in Western Australia in the early 1900s in the land that was generally considered to be sterile after ploughing back the lupines it was much richer for the next crop, this technique of green manure was developed and contributed to the success of farming in Western Australia.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Sweet lupines are interesting as they allow the use of lupin beans without soaking and cooking, they also permit the production of lupin flour and lupin flakes. Both flour and flaked can be useful as a replacement of cereals in breads due to their low starch contents paste and other dishes to reduce the carb contains, as the lupin has very low carb content.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor024"
    }
  }), _vm._v("2.5.8 Peanuts and Groundnuts")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer107"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-87.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer108"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Peanut Flowers")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a general name used in discriminately to describe the leguminous plants that produce beans in underground pods sometimes also called monkey nuts. ")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("There are three main members of this group.")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table015"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("American Peanuts")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Apios americana")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Groundnuts")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Vigna subterranea")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Peanuts")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Arachis hypogaea")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.8.1 American Peanuts")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Also called "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Apios tuberosa")]), _vm._v(", sometimes called American groundnuts.")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer109"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-88.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer110"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Groundnuts")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This plant is native to the southern parts of North America and is also called potato bean or Indian potato. It is a perennial vine that bears edible tubers. This vine grows up to about 5"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("m in length, with peanut leaves 8-15"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm long with 5-7 leaflets. The flowers are usually pink to purple or reddish-brown and produce dense racemes 7-13"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm long. The fruit is a tuber pod on the rhizome type root stem, being 5-13 cm long. Its natural growing area is from the south of Canada down to Florida and to Colorado in the West.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("It is toxic raw but can be eaten cooked as boiling destroys the toxicity like in many beans. The Apios Americana peanut cooked has the taste of potato with a nutty note, it is richer in starch and proteins than potatoes. It was largely consumed by Amerindians for centuries. It was used by settlers and pilgrims and helped them to survive the first winters.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.8.2 Groundnuts")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This plant is also called bambara bean or earth pea. It is an annual herbaceous climbing plant, having long glabrous trifoliate leaves. It has a deep taproot that carries lateral roots that carry nitrogen-fixing nodules. Flowers are present with papilla’s feller that once fertilized are drawn underground and produce fruit which gives a pod continuing 2-3 grains.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The plant originated in West Africa where it grows mainly in the tropical areas of the sub-Sahara.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.8.3 Peanuts")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The peanut also called groundnut ("), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Arachis hypogaea")]), _vm._v("), is a herbaceous annual plant of the leguminous family. It grows to a height of 30-50"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm. Like most plants of this family, peanuts plant has a nitrogen fixation capacity present in the root nodules. The plant has a bush form with leaves that are opposite and pinnate with four leaflets, two opposite pairs, each leaflet is 1-7"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm long and 1-3"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm large, and like many leguminous, the leaves close at night. The flowers are yellow-orange and 1-1.5"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm long. The flower structure is different from other plants in the family in that the ovary is mounted on a sort of stem, that after polarisation will push the ovary underground where it will produce a pod 3-7"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cms long and form the peanuts. The peanuts have a similar taste to tree nuts; they can be used in place of nuts but are generally used as food or to produce oil.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The peanut is a hybrid of two different plants, it would seem that this mutation occurred somewhere in the highland between Bolivia and the Argentine. In early times the culture spread to other South American Countries and many varieties were developed. Today the peanut is grown worldwide in tropical and sub-tropical climates. Its culture is very important for the production of oil in which it’s very rich.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor025"
    }
  }), _vm._v("2.5.9 Carob Tree "), _c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Ceratonia siliqua")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer111"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-89.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer112"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Carob tree")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The Carob Tree ("), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Ceratonia siliqua")]), _vm._v(") is a permanent tree belonging to the leguminous family. It is native to the Mediterranean and grows all around and just to the Canary Islands and Iraq.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The tree can grow to some 15 meters, has a hemispherical form with a strong trunk with dark brown bark. It can live for about 500 years and takes 70 years to produce fruit.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The leaves are composed, alternate with 3 to 5 oval leaflets, the leaves are hard and of a dark green colour.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The male tree does not give fruit, the flowers are small reddish and are in a catkin-like support and the flowering takes place in autumn.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The fruit is a pod from 10 to 30"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm long and 2 to 3"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm large, it is green and turns to dark brown at maturity in July the next year.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The carob pod is widely used as animal food, it is particularly appreciated by horses perhaps because of its slightly sweet taste.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The wood is a dark red and is used by carpenters for furniture, in particular, for the powder of the carob pod is used as a substitute for cocoa powder and gives a different type of chocolate. It is often found in health food shops as it contains fewer toxins than normal chocolate.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The powder is also widely used in the food industry as an additive.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("A gum is extracted from the bean. This is used as a thickener for the food industry.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The carob powder is also used for baby’s bottles as a replacement for milk, it has a sweeter taste.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor026"
    }
  }), _vm._v("2.5.10 Tamarind "), _c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Tamarindus indica")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer113"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-90.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer114"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Tamarind tree")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This leguminous tree is indigenous to the tropical African forests where it grows wild. It is a long-lived bushy tree that can attain some 20 -25 meters high. The tree has very flexible branches which make it resistant to wind, these branches carry feathery type leaves with oblong leaves about 7.5 to 15 cms long. The tree produces yellow fruits which in their turn give drop-shaped fruits in heavy skin. The fruits dry into a pod containing a red to brown paste and the seeds.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The fruit is edible as are the leaves, the pulp from the pods and the seeds are very important to produce many condiments, sauces and additives for the food industry.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The tree has become very important and is grown worldwide in tropical and sub-tropical areas, from India to Asia to Southern Florida and most of Northern South America, and Northern Australia.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The plant is widely used in cooking either as a paste or dried particularly in India and Southern Asia.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor027"
    }
  }), _vm._v("2.5.11. Mesquite")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("A mesquite is a group of perennial shrubs and trees with contains some forty members of the leguminous family that are indigenous to the Americas. They are present from the Southern States of the USA, Arizona to Texas in the North all through Mexico and the whole of Central America down to the north of Chile and Argentine. Each species has its own territory and conditions, all produce edible beans, these trees have been used by local indigenous humans and as animal food. The trees are relatively quick growing, and the wood is used for cooking and smoking, and in some cases medically, the bark is reported to contain alkaloids. The trees and shrubs are very thorny and have dangerous thorns, to the extent that the Gaucho cattle herdsmen have their horses equipped with a front apron in thick leather to protect the horse’s fronts and the rider’s legs when they are herding.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Mesquite has always served as food for local inhabitants both for them and their livestock, the dry mesquite bean once ground gives a flour similar to wheat flour that can be used to make bread or tortillas.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-73",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-91.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Mesquite tree")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The following are the two most known Mesquites.")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table016"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Velvet Mesquite")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Prosopis velutina")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Honey Mesquite")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Prosopis glandulosa")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.11.1 Velvet Mesquite")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This rather strange leguminous tree grows in the deserts of California, Nevada and New Mexico, it is an important part of the desert ecology and favours the local vegetation and animal life. The deciduous tree grows to a height of 9-15"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("m and has a very strong taproot that descends to about 15 meters and the tree is fairly resistant to drought.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The young branches may be greenish to start with and develop yellow thorns of some 2.5 cms long, the leaves which are feathered are about 10 cms long with the alternate section placed in opposition. The leaves have the particularity they close up at night.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In the spring new leaves grow followed by the flowers which are yellow and about 10 cms long, the flower give rise to long pods that start with bright green like peas, but dry and bend containing several hard-brown seeds.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.11.2 Honey Mesquite")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This mesquite is indigenous to the Southern Eastern states of the USA, Mexico and parts of Central America. It grows as a tree or bush and in the tree, form is smaller than the Velvet Mesquite and reaches 6-8"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("m. The pods, seeds and vegetation are edible, it serves as a shelter for animals both domestic and wild. The mesquite wood is used for construction and is also popular in Mexico for making furniture.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor028"
    }
  }), _vm._v("2.5.12 Fenugreek "), _c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Trigonella foenum-graecum")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is an annual plant of the leguminous family, with leaves having three oval leaflets similar to clover and can grow to about 60"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm high. The flowers are white-yellow which give pods about 8"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm long and contain from 10 to 20 brown coloured angular grains.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Fenugreek when you use the leaves fresh or dry is classed as a herb, but when you use the seeds, it’s classed as a spice, having a characteristic sweet flavour.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The plant is of Mediterranean origin and was cultivated in Egypt. Today it is cultivated all over the world in the warmer climates, typically in Southern Europe, but mainly in the Indian sub-continent.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor029"
    }
  }), _vm._v("2.5.13 Liquorice "), _c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Glycyrrhiza glabra")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer116"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-92.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer117"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Liquorice")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a herbaceous perennial plant of the leguminous family; it grows to about 1 meter in height and has pinnate leaves 7-15"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm long with 9-17 leaflets. The flowers have a purple to white colour and produce a loose inflorescence. The root is heavy and is the part that is used for flavouring.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The plant is native to Southern Europe and also Asia, particularly India.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The extract from the root is used as a flavouring agent for tobacco and for making sweets.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor030"
    }
  }), _vm._v("2.5.14 Rooibos "), _c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Aspalathus linearis")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The genus"), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v(" Aspalathus")]), _vm._v(" has many species, particularly in South Africa red bush or rooibos in Africans ("), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Aspalathus linearis")]), _vm._v(") is one of the species and is a leguminous shrub that grows exclusively in the mountains North of Cape Town in South Africa. Attempts to grow it in a similar climate worldwide have been without success.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The reddish needle-like leaves of the red bush have been used for a long time to produce tea-like infusions all over Southern Africa, today the product is known worldwide. The plant grows to about 1.5 meters and is upstanding depending on the variety. The plant is harvested in the summer and either fermented or and then dried for use.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Rooibos is an infusion that has the advantage that it does not contain stimulants, unlike tea or cafe. Often called redbush.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor031"
    }
  }), _vm._v("2.5.15 False Acacia "), _c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Robinia pseudoacacia")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("A perennial deciduous tree of the leguminous family growing to 20-23"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("m, and originated in America, and now growing worldwide. They use the flower to make beignets that are very popular in the season.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor032"
    }
  }), _vm._v("2.5.16 Mimosa "), _c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Abacia dealbata")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer118"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-93.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer119"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Mimosa")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("A perennial tree of the leguminous family that can grow to about 20 meters. This tree has a bright yellow flower that is the national flower of Australia from where it was imported to Europe in 1867 by Captain Cook. It grows in Portugal, Spain, Southern France. Italy and Southern Mediterranean. The tree has a very beautiful yellow flower and is used as a decorative tree and also as a cut flower. Other uses are for its essence for perfumery and to make syrups, jelly, beignets and the flowers are crystalized for decoration by bakers for cakes.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("2.5.17 Animal Food and Fodder Leguminous Plants")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Note: These plants are detailed as they are important economically and for environmental farming equilibrium, but are outside the scope of this book.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This group of plants is very important historically and economically, as the different plants are present all over the world and represent the basis of animal food in different forms. There are four families of leguminous fodder plants: the clovers, the lucernes, the vetches and the vicia.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("All these plants can be used in different ways for animal food, for grazing, for making hats or as silage.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a herbaceous annual plant of the leguminous family, and the four contains some 140 species of flowering plants commonly known as vetches.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Some of these plants are very old since certain species are related to the ancestors of the broad bean and traces have been found dating from 9000 BC in the Middle East and from 5000 BC in the Balkans, and at about the same time in Thailand.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Plant of the species are present all over the world and are cultivated at the present time as animal feed or to support beekeeping as the flowers produce large quantities of pollen and nectar.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer181"
    }
  }, [_c('p', {
    staticClass: "Chapter-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor033"
    }
  }), _vm._v("Chapter 3\tIntroduction to the History of Peas and Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor034"
    }
  }), _vm._v("3.1\tPre-history of humans and plants")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This chapter is in no way a history lesson but simply offers a straightforward explanation to give a background to the history of leguminous plants.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Leguminous plants are very important in human history. After cereals, they are one of the most consumed foods.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The history of leguminous plants is complicated, as is the history of many plants and the humans who domesticated them. In order to explain in very general terms, the first part of the chapter covers the history of humans and their domestication of leguminous plants.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Our ancestors came from Africa. The first "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Homo sapiens")]), _vm._v(" appeared some 150,000 years ago and were a hunter-gathers who were able to hunt and eat large quantities of wild animals and birds.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("About 100,000 years ago, man left Africa for unknown reasons and gradually populated the rest of the world. We will describe this movement in time and then examine the movements of the migration and also the origin of leguminous plants.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor035"
    }
  }), _vm._v("3.1.1 The Big Migration")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The following image, Map 1, shows the general lines of human migration. The dates should be considered an indication only: the real dates are very complicated and difficult to interpret.")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 1: The big migration")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-74",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Our first ancestors with a certain resemblance to us lived in Africa; they were hunters and gatherers and roamed in search of food. They were called hominoids. After some 2.5 million years, they had evolved and we have the first appearance of "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Homo sapiens")]), _vm._v(", which had a closer resemblance to us. At this stage, man started to use fire; it was the beginning of the Stone Age. The use of fire brought many advantages: to be able to cook, to keep warm and to protect against wild animals. These "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Homo sapiens")]), _vm._v(" were still wanderers looking for food and hunting. There were at least two types of this species and, perhaps, more.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("At about this time, migration from Africa began, perhaps for climatic reasons or perhaps for others. The migration for those from the south was by the rift valley: what is now Egypt to the Middle East, either by the Red sea or by the Sinai; the west, towards Europe; the east, towards Central Asia and then to East Asia")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In the migration from Africa, the humans who left were not at all like the present-day Africans. They were smaller and lighter, more like the modern ‘Bushman’. The type of African that we know today evolved much later, it is thought in the Ethiopian, Nubian and Chad areas, before the beginnings of the Ancient Egyptian civilisation.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("When these Africans started to move around the world they evolved and started to search shelter cliffs, and particularly caves. From about 30,000 – 20000 BC there were cave dwellings all over the world, and in some of these cave’s that have resisted time we find artistic painting and rock etchings. Most of the paintings show scenes of hunting. These remains are of great value, both historically and archaeologically.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-75",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-02.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Cave drawing with hunting scene")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.1.2 Settlement and Domestication")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Following these migratory movements, humans slowly changed from a hunter-gathers to a partly and later totally sedentary race. This development was long and led to the creation of the early civilisations.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("For historians, civilisation is defined as a developed structure with an organised society with a hierarchy and early farming and artisanal activities to build houses and monuments. We are interested in the period before civilisation, during the early domestication of plants and animals, thus in the period during which the leguminous plants were developed.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In order to try and see this development, we will examine two periods, before Christ and in our time.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("The early period:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Numbered-list-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Mesopotamia, the ‘Fertile Crescent’")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Egypt and the Nile valley")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("India")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Early Mexican civilisation \t")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("East Asia")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("The Andes civilisations")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("The African continent (other than Egypt)")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Australasia and the Pacific")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("The Greek Empire")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Africa and Papua New Guinea are often neglected as they left no great monuments like the Pyramids. However, they are important, as domestication and developments were also taking place there.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("After this civilisation, the whole world developed slowly and major historical events changed the culture of the leguminous plant:")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("More recent history\t")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Numbered-list-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("The Roman Empire")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("The Arab Empire")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Medieval Europe")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Christopher Columbus and the discovery of the Americas")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Colonisation and the slave trade")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("British Agricultural Revolution and modern times")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Asia")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Table 1 below shows the general evolution in different parts of the early period")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Green represents – Early civilisation")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Orange represents – Big towns and movements")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Table 1: Domestication and civilisation")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table017"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("10,000")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("9,000")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("8,000")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("7,000")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("6,000")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Mesopotamia")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Jericho")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Egypt ")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("India")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("East Asia ")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Mexico")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Andes")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Africa")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Papua New Guinea, Australasia, Asia")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("South-East Asia")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("40000 BC")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("New Guinea ")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Europe")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Estonia")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Italy ")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Greece")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  })])])]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table018"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("5,000")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("4,000")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-2",
    attrs: {
      "colspan": "3"
    }
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("3,000")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("2,000")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("1,000")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Mesopotamia")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-4"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Erdu")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-5"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-6"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-7",
    attrs: {
      "colspan": "3"
    }
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-8"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-9"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Egypt ")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-4"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-5"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-6"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-7",
    attrs: {
      "colspan": "3"
    }
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Memphis")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-8"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Luxor")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-9"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("India")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-4"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-5"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-6"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-4"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-10 _idGenCellOverride-1",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Harappa")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-8"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-9"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("East Asia ")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-4"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-5"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-6"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-4"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-10 _idGenCellOverride-1",
    attrs: {
      "colspan": "2"
    }
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-8"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-9"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Mexico")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-4"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-5"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-6"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-4"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-5"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-6"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-4"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-9"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Andes")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-4"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-5"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-6"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-4"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-5"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-6"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-8"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-9"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Africa")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-11"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-5"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-6"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-4"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-5"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-6"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-4"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-6"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Papua New Guinea, Australasia, Asia")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-11"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-12"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-6"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-4"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-5"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-6"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-4"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-6"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("South-East Asia")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-3 _idGenCellOverride-2",
    attrs: {
      "colspan": "5"
    }
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Philippines ")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-9"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-8"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-9"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Europe")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-3",
    attrs: {
      "colspan": "3"
    }
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-4",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Spain")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-9"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-8"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Cadix")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-9"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Greece")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-3",
    attrs: {
      "colspan": "3"
    }
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-4",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Crete")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-9"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-8"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-9"
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.1.3 Geographical Origin of the Leguminous Plants")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The following table 2 and map 2 show the location of the first reported domestication of the leguminous edible plants developed by human selection. These plants were domesticated by selection progressive from wild plants.")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Table 2")]), _vm._v(" "), _c('table', {
    staticClass: "No-Table-Style",
    attrs: {
      "id": "table019"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Europe")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("India")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Asia")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("America")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Africa")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Pacific")])])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("1")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Peas")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("2")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Broad beans")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("3")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Chickpeas")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("4")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("5")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("6")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Lupini")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("7")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Peanuts")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("8")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Tamarind")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("9")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Fenugreek")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("10")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Liquorice")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("11")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Mesquite")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("12")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Rooibos")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("13")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("False acacia")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("14")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Mimosa")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })])])])]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 2: Origin of Leguminous Plants")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-76",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This type of early selection took place all over the world on all the continents. In the Americas, maize was domesticated and later beans in Meso-America and the Andes. Forms of early wheat in the Fertile Crescent (present-day Iraq) spread to Egypt, Europe and North Africa, and rice in China and India. As far as beans are concerned, apart from mung beans in India and one-eyed beans in Africa, all other beans are from the Pacific rim.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.1.4 The Result and Present Place of the Bean Family")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In the earlier part of the chapter, we described the migration of people from Africa. We will now consider what happened to these people and what they did, and how and when they domesticated plants and animals.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("It is generally thought that the Fertile Crescent was the origin of our civilisation. However, if we look at the world map of Neolithic settlements, we will see that in fact there were simultaneous settlements in the different continents at about the same time, and each of these started agriculture and animal domestication in very different ways, mainly as a result of the particular wild plants and animals present. Map 3 shows the Neolithic and Bronze Age settlements worldwide. Map 4 shows a more detailed view of Europe, North Africa and the Middle East. It should be noted that the dates shown are to be considered as an indicative guide, to give a general picture of the historical evolution.")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 3: Neolithic Settlement (BC)")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-77",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 4: Neolithic Settlements (dates in BC)")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-78",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.1.5 Effects of Domestications")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Today everyone can eat more or less anything, even out of season. However, the original possibilities of local food remain very present.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In Europe, the Middle East and North Africa, our food ways are influenced by wheat and barley in different forms. Wheat-based bread is present everywhere, often in different forms, followed by pasta and couscous. It is somewhat surprising that rice and beans took so long to come to Europe: rice came to Western Europe at the time of the Arabic invasions of Spain and Sicily in the eleventh century. Their consumption in these countries has been in many different ways, as in paella and risotto. On the other hand, beans came to Europe after the return of Columbus, although varieties were already known in West Africa and India.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In East Asia and India, rice was one of the first domesticated plants to be used and remains the base of most Asian foods. It took some time for rice to arrive in Europe. It was known to the Ancient Greeks, as Alexander the Great talks with admiration about a pilaf that he had eaten in Azerbaijan on his voyage to South Asia. However, it was not used in Greece for cooking but was considered a medical plant. To show the importance of culinary heritage, we can examine the case of South Korea. Japonica, or round rice, was first domesticated in the valley of the Yangtze River. The type of rice was used all over the north of China and then in Korea and Japan. Today, despite the fact that Indica or long rice could be cultivated in Korea, it is round rice that is used exclusively.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In the Americas, in pre-Columbian times, the basic foods that were available were maize, beans, tomatoes, peppers and yams, among others. Marinated raw maize gave a grain that was used to make tortillas in central America and tamale in the south. Beans were largely cooked with meat, tomatoes and pepper. This type of food spread all over the Caribbean. After Columbus and the slave trade, African rice, black-eyed beans and collard greens arrived in America. The slaves knew how to cultivate these plants and they became part of the national food, often called ‘soul food’. In more modern times, the African rice was replaced by Asian rice, which is more productive; however, African rice is more resistant to adverse conditions and continues to be cultivated in more difficult conditions. Today, the basic food in the Americas consists of beans and rice, mainly with maize in Central and Southern America and with wheat in North America. However, maize is still widely used in the southern states of the US.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In sub-Saharan Africa, the following foods were previously available: African rice, millet, white fonio, spelt and yams, collard greens and black-eyed beans, with other vegetables and fruits. Today, the main foods used are rice, couscous made with millet and other cereals.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Despite westernisation, many local breads are still made with local products like the typical tapalata bread in Senegal that is made from a mixture of cereals, wheat, maize and millet, containing 50% of local black-eyed bean flour.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1"
  }, [_vm._v("3.2 History of the Early Civilisations")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main ParaOverride-7"
  }, [_vm._v("The early civilisations were mainly river beds developments and the first were the following with their beginning dates:")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table020"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("1. Mesopotamia, The Fertile Crescent")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("9000 BC – 100 AD")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("2. Egypt, The Nile Valley")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("6000 BC – 300 BC")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("3. India")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("9000 BC – Present")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("4. East Asia, Chinese River")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("8000 BC – Present")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("5. Early Mexican Civilisation")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("8000 BC – 1521 AD")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("6. New Early Andean Civilisation")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("8000 BC – 1574 AD")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("7. The African Continent (other than Egypt)")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("4,000 – 1000 BC")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("8. Australasia")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("40000 BC")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("9. Europe")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("6000 BC – Present")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("10. The Greek Empire")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("750 BC – 366 AD")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The following map shows the implantation of these civilisations.")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 5")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-79",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-07.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The dates given are the dates of the established civilisation, but thousands of years of domestication and work were necessary to get to this point. This early period is obscure to an extent because there were no writings to record what happened. However, a lot of archaeological information is available.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("As an example, the town of Jericho was built in about 8500 BC, but before being built it was necessary to be sure that enough food would be available. For a town of that size, there is no way that hunting and gathering could achieve this; therefore, some type of organised farming must have existed. This would mean the preparation and storage of foods that could be dried: cereals and leguminous plants such as peas, broad beans, lentils and chickpeas. This system would need areas for drying and threshing and drying and other areas protected and dry for storage. The grinding of grains to make to flour could be done later. The farmers would need to be organised to produce the plants that could be stored as well as those that could be eaten fresh: cabbage, peas, broad beans and others. This same system would have taken a lot of years to prepare so the dates are difficult to imagine.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.2.1 Mesopotamia: the Fertile Crescent (About 9000 BC – 100 AD)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is what most historians consider as the cradle of civilisation: in the valley of the rivers Tigris and Euphrates, going west to the Jordan valley and the banks in the Mediterranean and touching the northern part of what is now Egypt (the Nile Delta).")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-80",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-08.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-81",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-09.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tFertile Crescent\tTower of Babylon")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Some 12,000 years ago, this area had a number of tribes: some who wandered, others who started to have temporary or permanent villages, where many activities were starting to evolve, sowing plants and domesticating animals.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("One of the earlier towns, a little apart from the centre, was Jericho, constructed on the West bank of the River Jordan (in modern-day Palestine). Jericho is believed to be the first town to be built in the Fertile Crescent. It was built in 8500 BC and fortified in 6800 BC.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The valley of the Euphrates and Tigris has very rich soil, fertilised by the large deposits of rich silt that allow agriculture, while the rivers can be used for irrigation. These valleys, flowing through a very arid area, are flooded regularly: once with the melting of the snow in the mountains in the spring, and irregularly due to the rains in the same mountains. For this reason, it was more difficult to organise the irrigation to provide food for the population. The first Sumerian town was Eridu, constructed in 5300 BC. This was a more developed structure than Jericho.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The development of the Fertile Crescent between and around the Euphrates and Tigris was made possible by extensive work to drain and irrigate. The delta between the rivers was a wet and rich area, but to be cultivated it needed to be drained. The drainage was carried out by digging ditches from sea level to the delta, starting at the lowest level and progressing, digging out the soil till you found the water flowing to the sea. Once drained and worked and the seeds were sown, it was necessary to bring fresh water for the plants to grow. This was achieved by creating dams higher up the river, bringing water from these reservoirs to the delta by constructing canals with dams to regulate the flow. This system is fairly complex and shows a high level of technology. Later, these techniques moved up the two riverbanks to give fertile plains. The structure was fragile and had to be remade after the big floods.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In 9000 BC, wild grains were being cultivated. The regular foods available in Mesopotamia were plant products, e.g. emmer wheat.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("4500 BC: barley oats, peas.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("6000 BC: lentils, chickpeas, cabbage, broad beans, onions, olives, almonds, dates, pistachios, pomegranates, radishes, carrots. For animal products: beef, wool-bearing sheep. ")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("5000 BC: goats, pigs.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Hunting provided fish and wild game.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The supply of food was a major problem, as indicated in some of the early Sumerian writings where the problems of food rationing were discussed.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Plants available:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Peas, broad beans, turnips, onions, radishes, cabbages, barley grain, emmer wheat, aubergine.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Fruits:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Apples, grapes, dates, pomegranates, melons.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Animals:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Cattle, sheep, goats, chicken, ducks.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Fish and wild game.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Food")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The principal food of Mesopotamia was barley, mainly to make soup or porridge or stew with the vegetables and meat available. Ground to a flour, it was made into bread or fermented to make beer. With many fruits available some of which could be dried for conservation.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.2.2 Egypt: The Nile Valley (6000 BC-300 AD)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The development of the Fertile Crescent probably started in the Jordan valley and then moved or was developed simultaneously in the Euphrates and Tigris valleys and delta. Later, it moved south to the Nile valley, north towards Turkey and then east towards the Caspian Sea.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-82",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-10.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-83",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-11.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tPyramids\tEgyptian plough")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The Nile valley is an ideal place for a river bed development, since the sources of the Nile are in the highlands of upper East Africa and have regular rainfall that produces regular flooding of the valley with rich silt which fertilises the surrounding arid land, while the regular flow of the river allows irrigation. This led to agriculture and development all along the river.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("At this time, Egypt was divided into Upper Egypt and Lower Egypt. The two kingdoms were unified by Narmer and led to the first dynasty; the capital was moved to Memphis in 2600 BC. Early development in Southern Egypt helped bring minerals and stones from the Western desert to produce ceramics and copper. Obsidian was coming from Ethiopia to make cutting tools such as primitive sickles to harvest grass or cereals.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Egypt was the first large-scale agricultural site due to the length of the Nile and the fact of its effective administration that controlled the population as everybody worked on the land of the state-owned farms, and Egypt prospered.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("By 2500 BC, the land was being worked with primitive ploughs drawn by oxen and irrigating was improved.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The following products were available:")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Vegetables and grains:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Emmer and other wheats, barley, onions, peas, broad beans, chickpeas, cabbages, leeks, radish, cucumber, carrots, turnips, aubergine, asparagus, olives, lupin, lentils, carob, garlic.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Fruits:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Melons, dates, grapes, apples.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Animals:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Cattle, sheep, goats, pigs, pigeons, quail, geese, bees (wild and domesticated).")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Fish and game from hunting.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Food:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The basis of Egyptian food was bread and beer. The bread and beer were accompanied by vegetables, either raw or cooked, and meat, generally cooked. The following types of cooking were used: boiling, stewing, grilling or roasting. The bread was made generally from emmer wheat flour, made into dough and raised with yeast made from the same flour.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The yeast made for bread was also used to ferment the beer. There were many types of baking methods used for the bread which changed during Egyptian history, the last being an oven similar to the Indian tandoori oven.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.2.3 India (9000 BC – Present)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Early Neolithic civilisation started in the different parts of India from about 9000 BC as small villages that started cultivating and breeding animals in and around the river beds. There are two main rivers in the north of India, the Indus to the west and the Ganges to the east. Development in the Indus valley was by indigenous inhabitants and influenced by the earlier development in the Middle East; on the other hand, the Ganges Valley was a little later. But it was influenced by South-East Asia and perhaps New Guinea for certain plants or seeds.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-84",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-12.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Geometric Structure in the Indus Valley")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Indus Valley")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The Indus valley starts in the Himalayas and Afghanistan. It has many tributaries and flows to the Arabian Sea, covering a large spectrum of climatic conditions. The Indus river separates what is today Pakistan and India. The Indus valley civilisation was very important and was the largest of the early civilisations, and had many towns and cities all along the course of the river. The towns and cities were very structured and built in a geometrical structure with right angles. They were built with a higher part fortified where the nobles, rulers and rich lived, while the lower parts were for the common people. The towns had a fairly sophisticated drainage system. Because of the large drainage basin, the river flooded regularly and probably often. Each flood would bring a layer of fertile silt, the flooding would be finished by November and the lands would start to dry. The seeds were sowed and harvested by about April, before the next floods.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Plants grown were the following: Indica rice (long rice), varieties of wheat and barley, oats, mung beans, broad beans, lentils, sesame, mustard, chickpeas, lupins, cabbage and cotton.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The animals domesticated were ox, buffalo, sheep and goats.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Camels and donkeys were used for transport; horses were little used. Elephants and rhinos were known.")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 6: Indian Rivers")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-85",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-13.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Trade was carried out with the rest of India as well as Mesopotamia, both by land and by sea.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-86",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-14.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Indian ceramic statues")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("Ganges Valley")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main ParaOverride-10"
  }, [_vm._v("The Ganges, the longest river in India, starts in the west and drains into the southern part of the Himalayas and the northern part of India, finishing in what is now Bangladesh and flowing into the Bay of Bengal. Some hundreds of years apart, the population moved from the Indus valley to the Ganges plains in north-west India and became the centre of civilisation there. The cultures and animals were more or less the same.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("At the time, nomadic tribal life in India was fairly easy because of the richness of the lands near the fertile rivers. As humans started a semi-nomadic life at the beginning of civilisation, many plants were available for domestication.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Products available:")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Plants:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Wheat rice, millet, sorghum, lentils, chickpeas, peas, onions, garlic, cotton, olives.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Fruits:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Lemons, oranges, mangos, dates, jujube, sugar cane, tamarind.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Animals:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Cattle sheep, pigs, goats, chickens, bees.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Fish and game.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Food")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The base of early Indian food was cereals and rice. A number of breads were made, the most important being chapatti. The dough was made from wheat flour made into a thin disc and cooked on a plate or dry pan with no oil.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Naan is a yeast-leavened bread from flour dough and yeast, made into discs and cooked in a tandoori oven.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Papad is a thin disc made from chickpea flour and water and cooked in the pan at the last minute.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("These different breads were eaten with cooked vegetables and meat. However, in about 3000 BC, the Hindus decided that cattle were sacred and that meat was not to be consumed; most people became vegetarians. Indian food was highly flavoured, using many herbs and spices.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Drinks made from milk and honey, often mixed with water or fruit juices, were the most popular. Wine was also made, but this was reserved for the rich.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.2.4 East Asia China (8000 BC – Present)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Early development in East Asia was around the three large river beds. The Yellow River runs through the northern parts of China and the south of Mongolia and ends in the Yellow Sea. The Yangtze River rises in the west, goes through the central part of China and ends in the China Sea. The Pearl River starts north of the Himalayas and finishes in the South China Sea. There is a lot of scholarly discussion about the order of development between the different rivers. While this discussion is interesting, for our use we are just concerned by a general picture of the development and not the details.")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 7: Main Chinese Rivers")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-87",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-15.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Products Available")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Vegetables and grains:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Numbered-list-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Asian rice (short-grained, Japonica) – Yangtze valley, 8000 BC – South Korea")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Chinese millet, North China yellow river, Central Asia, 5000 BC")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Soybeans, South China Yangtze valley, 6500 BC.")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Adzuki bean, North China, Korea, Japan.")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Wheat (from central Asia), 2000 BC.")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Sorghum.")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Hemp for fibre and cannabis.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Also: perilla, mulberry, cabbage, onions, garlic.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Fruits:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Peaches, Jujube, Sweet Oranges, Chestnuts.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Animals:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Cattle, Sheep, Goats, Pigs, Chicken and Bees.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Food:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("In central and southern China, the major food ingredient was rice, which was boiled in water or milk. In Northern China, millet and wheat were the main major foods, generally boiled to make porridge.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Tea was popular from 3000 BC. By 2000 BC, beer was being brewed from rice.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-88",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-16.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Great Wall of China")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.2.5 Early Mexican Civilisation (8000 BC – 1521 AD)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The early civilisation of Mexico, with the Teotihuacan, Maya and Aztec, was made possible by the early tribal domestication of plants using the grand biodiversity available. The land was fertile, and the climate was good; however, the geography, with large shallow rivers and lakes and very steep hills on each side, resulted in very small river banks for the culture. This problem was solved by the construction of the ‘floating islands ‘in the rivers and lakes and terraces on the hilly parts. The Chinampas are island fields created in the shallow lakes and river beds of the Mexico valley. They are generally small and rectangular and are made by fencing part of the shallow lakes and then filling the fenced part with stones, sand and rotting vegetable waste and soil until the island is above the water level. These fields were cultivated as normal land and often serviced using flat reed boats. Sometimes, the Chinampas used willow sticks, which grew and gave shelter to the plans being grown. The terraces were built by digging a flat on the slope, taking the rocks to the lake and filling the hole with soil, generally keeping the best soil for the surface. The construction of these walls was very difficult, and it required a lot of dexterity and practice to make the Chinampas.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-89",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-17.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Sketch of Chinampas river cultivation")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-90",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-18.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Irrigation terrace")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Organised dwellings were present on the Mexican eastern coast in 600 BC, near present-day Vera Cruz.")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer138"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-19.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Products Available:")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer139"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Maize")])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Vegetable Plants:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Maize (many species) \t\t7000 BC")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Beans (many species) \t\t8000 BC")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Squash \t\t\t\t8000 BC")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Tomatoes \t\t\t4000 BC")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Peppers (hot and sweet) \t8000 BC")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Potatoes \t\t\t8000 BC")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Also available: Peanuts, manioc, tobacco, cacao, sunflower seeds, rubber, cotton, sweet potatoes, cashews, cinnamon, vanilla.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Fruits:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Bananas, mangos, guavas, peanuts, avocados, limes and many other tropical fruits.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Animals for food:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Turkey, Muscovy duck, dogs.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Fish, rabbits and deer from fishing and hunting.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Food and drink:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The main food culture consisted of the ‘Three Sisters’: maize, beans and squash. In this culture, the maize was sown first. Once it had started to grow, the runner beans were sown or planted around the maize and later the squash as an outer ring. The maize was the support, the beans climbed the maize and fertilised the ground and the squash, with its large leaves, protected the soil and reduced evaporation. This system is still used by some gardeners. Maize could be used in many ways – fresh, boiled or grilled – but the major use was dried and ground to flour or very small grains, mixed with water to make a dough, rolled into thin discs and grilled to make tortilla or tamales. The tamales are generally small, thick pieces of maize dough wrapped in the shell of the maize grains, either fresh or dry. In early times tamales were cooked by burying them in the ashes of a fire.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-91",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-20.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Tamale")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Potatoes were the other main starch source. The tortilla or potatoes were generally served with meat and vegetables in a hot sauce using hot peppers. In the Aztec times, meals were often served with three tortillas to accompany the rest of the food.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-92",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-21.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Tortilla")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("A drink was made by mixing maize flour with chocolate, cinnamon and vanilla in water. Another drink was made by fermenting the syrup of agave (cactus) to make an alcoholic drink generally reserved for the priests and rich.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-93",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-22.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Sun Pyramid")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.2.6 Early Andean Civilisation (8000 BC – 1574 AD)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("There is evidence of human occupation in caves in high altitudes in 1200 BC.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The Andean civilisation goes from part of Colombia to the north of Chile and the Pacific Ocean. It includes parts of Ecuador, Bolivia and Peru. It is believed that the earliest civilisation took place about 5000 BC in the desert land near the Pacific coast. This is very arid but is surrounded by a land river that comes from the Andes mountains and flows most of the time. With irrigation using the water from these rivers, early tribes started cultivating, but because of the limited resources new populations had to move towards the mountain, where they found water easily. It was very difficult to live because of the geography of the land and the climate. However, these early Incas were able to survive by making terraces and shelters to adapt to the climate, and this was the beginning of the Inca civilisation. The Inca civilisation at the beginning was a patchwork of different tribes over a large area and climate spectra. The Andean area contained an amazing collection of botanic variety.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The following fairly recent photos shows the terraces on the Yska del sil in the Bolivian water of Lake Titicaca. These terraces were constructed some 3,000 years ago to feed the people of La Paz. They are still used today by the local population.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-94",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-23.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Old Inca terraces on Lake Titicaca")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The following different plants and animals were present:")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Vegetables and grains:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The principal plants:")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "Bullet-list-first"
  }, [_vm._v("Maize (many varieties)")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Potatoes (many varieties)")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Quinoa")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Peppers (sweet and hot)")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Tomatoes")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Sweet potatoes (many varieties)")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Also cotton, cocoa tobacco, maca, parsnips.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Fruit:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Pineapple, peanuts.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Animals:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Llama, alpaca, guinea pigs.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Many other fruits and vegetables used by the Incas remain unknown.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Foods")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The main basic food support was maize and potatoes. The maize could be eaten fresh, grilled, boiled or in soup. The dried maize could be conserved and used cooked alone or in stews, or could be ground to a flour consistency to make tortilla that could be grilled or cooked otherwise. The potatoes were eaten cooked, boiled, grilled, or in soups; however, the Incas had discovered the technique of freeze-drying and were able to keep potato powder during the winter seasons.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("As far as the meat was concerned, llama and alpaca were eaten on religious celebrations or by the rich. The basic meat for the population was guinea pig, which was bred everywhere. In fact, it is still bred in people’s backyards or in their houses. Otherwise, hunting and fishing were carried out in certain areas.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("For drink, ‘Chicha’, a beer, was brewed using maize flour.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.2.7 The African Continent other than Egypt (4000 BC – 1000 AD)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Africa was the original home of humans and after the grand migration some 150,000–100,000 years ago. The Africans who migrated were not the Africans of today; they were smaller, thinner, much lighter than the present-day Africans. This migration took place over a long period and was by the northern route by the Sinai or by the Red Sea to the Arabic peninsular. Many tribes or parts of tribes remained and evolved, each one continuing their own development. These developments took place progressively all over Africa.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In about 7000 BC, the modern type of African, the Nubian, evolved in the higher parts of the Nile Valley, in the Sudan and Ethiopia and migrated partly to Egypt where they were called Bantu, a name that has followed them till today.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-95",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-24.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Egyptian hieroglyphs for ‘BANTU’")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The Nubians were a civilisation of hunter-gatherers between 7000 BC and 400 AD, and their way of life was very dependent on water in rivers and lakes. They covered a large part of the Nile valley and other areas of north-eastern Africa.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In about 6000 BC, there was a much drier period and the level of the river and lakes was lowered, and the Nubians were looking for more favourable lands.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("At this period, the Nubians were cultivating millet, sorghum and teff (a grain cereal) and by 3000 BC had domesticated donkeys and cattle probably coming from Ethiopia. By 2500 BC, they were trading gold with Egypt in exchange for cotton and linen.")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 8 First Bantu migration")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-96",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-25.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("At this time, they started to move East, South and between the two, taking three different directions. The Eastern route took them through Chad, Niger and Mali and followed the rivers to North-west Africa. Those who went further South from Chad moved to the Congo basin. Those who went south took either the coastal route to Ethiopia and Kenya or the Rift Valley to Lake Victoria.")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 9 Second Bantu migration")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-96",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-26.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("On their way the Nubians met the local populations who remained hunter-gatherers. The local people had the choice of moving on or integrating with the Nubians. The majority decided to integrate, seeing the incomers’ agricultural knowledge and their iron tools and arms. Once arrived at the coastal area, the Nubians found a population of indigenous Africans and Pygmies in the rainforests. The locals integrated but the Pygmies moved deeper into the rainforest areas. These people lived on yam as vegetables with fish and game; guinea fowl were plentiful. The new arrivals discovered wild African rice which was domesticated, as was millet, sorghum and other cereals. These were plentiful and the population expanded rapidly. After some time, space became short and it was time to move. By now, the Nubian origin had disappeared and West Africa and West Central Africa had become the Bantu Homeland, and was followed by the occupation of the totality of Africa south of the Sahara.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-97",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-27.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("African beans")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.2.8 Australasia (40000 BC): Papua New Guinea, Australia, Vanuatu, New Caledonia, New Zealand")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The first human presence in this area is the arrival in 70000 to 50000 BC of humans coming from the earlier migration from Africa. These people probably arrived by the land bridges all over South-East Asia due to the low sea levels. In Papua New Guinea in 50000 to 40000 BC, there are human settlements with dwellings and agriculture in the coastal areas. This civilisation seems to have disappeared, perhaps by earthquake, tsunami or disease. The population moved to the highlands and continued a life of hunter-gatherers.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("At the same time, others of the same group moved to Australia, either via North or Western Australia or across the Straits of Torres to Northern Queensland. They moved around the Australian coast and Tasmania, which at the time still had a land bridge. They adapted to the very arable climates, going from the cold mountains of Tasmania to the tropics of the North. They were hunter-gatherers and lived on meat, fish, birds, snakes, grubs and insects; they also collected vegetables and fruits. These were different from what was available in other parts of the world.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("It has been established that there is a genetic link between these aboriginal peoples and those of Tamil Nadu in the southernmost part of India. It is believed that during their trip from Africa they passed centuries in Tamil Nadu, where it is believed that evolved humans were present 100,000 years ago.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The second settlement in the area was the population of the nearest Pacific islands, Vanuatu, New Caledonia and New Zealand in 2,000 to 1000 BC. This movement was very different as the settlers were Asian, thought to come from Malaysia or the Philippines. These settlers were more organised as they travelled by boat over long distances in deep water and carried with them provisions and plants, grains and animals to help settlement in much the same way as the pilgrims who left Europe for the New World.")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 10")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-98",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-28.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Australian and Papa New Guinea settlement and the first humans in Australia – "), _c('br'), _vm._v("Route of the Aborigines")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 11")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-99",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-29-new.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("The settlement in the closer Pacific Islands")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Vanuatu may have been populated by the same people as Australia by groups of the first arrivals, but then became inhabited in about 100 BC by the newcomers from Asia. This explains the difference between the Australian Aboriginal and New Caledonian Kanak and the New Zealand M"), _c('span', {
    staticClass: "accented-letter"
  }, [_vm._v("a")]), _c('span', {
    staticClass: "accent"
  }, [_vm._v("-")]), _vm._v("ori.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.2.9 Europe (6000 BC – Present)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Homo sapiens")]), _vm._v(" arrived in Europe in about 4500 BC and lived with the more primitive types of man for many thousands of years. Development was later in northern Europe due to the terminal effects of the last Ice Age.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The presence of cave dwellers in Southern Europe is illustrated by the southern French cave dwellings with interesting wall paintings in the Grote Lascaux, one of the departments of the Dordogne, and the Grote Chauvet in the department of the Ardèche. The habitation of these caves is dated about 30,000 – 20000 BC.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-100",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-30.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-101",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-31.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Cave paintings")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Development was earlier in the regions near the Middle East, since development and agriculture were already developed. There was migration from these areas to Europe either by sea or boat to the Danube valley. Europe was populated from Spain to Russia with a hunter-gatherer population, who under the influence of tribes from the Middle East were beginning to farmland and breed animals.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This period was one of massive tribal movements throughout Europe, which led to domination and exchange with new people like the European Indians who came through Anatolia and Turkey and who mixed with the local populations. It was the time of primitive agriculture and husbandry to feed the growing population and use the rich marshlands recently liberated from the ice.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The Bronze Age started about 3000 BC and was present in the Aegean area. The effect of metalworking produced early sedentary communities necessary for metal smelting and produced a certain organisation and the beginnings of social structure.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Iron was known in the Aegean in about 1000 BC but its origin is difficult to find. Its use spread slowly over Europe and mainly in Northern Europe in 5000 BC.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In 1200 BC, the Aegean people and the Greeks merged and created a force that developed quickly, becoming an important maritime power; however, this power only lasted for about 100 years and sobered into the dark Greek ages until 750 BC.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("With the disappearance of the Greek maritime power, the Phoenicians proceeded to occupy and create trading posts in Marseilles in France and Cadix (Cadiz) in Spain.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Some dates:")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "Bullet-list-first"
  }, [_vm._v("3600 BC \tMinoan settlement Crete, bronze tools")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("6111 BC \tStonehenge in England")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("1100 BC \tThe Phoenicians built Cadix")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("1000 BC \tMadrid founded")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("600 BC \t\tForum constructed in Rome")])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor036"
    }
  }), _vm._v("3.2.10 The Greek Empire 700 BC – 300 AD")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-102",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-32.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Greek monument")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 12 ")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-103",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-33.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("The full extent of the Greek (Macedonian) Empire")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The Greek Empire started in 700 BC at the end of the Greek Dark Ages. What little is known suggests that these ‘Dark Ages’ was a period of internal conflict.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The Greek Empire was very rich due to its abundant agriculture, with products that the Greek sailors could trade all around the Mediterranean in exchange for necessary supplies. The main products that Greece produced were wheat, both emmer and drum, barley wine from grapes and olive oil. With trading and colonisation, the Greeks spread development of agriculture around the Mediterranean and in Asia Minor.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The rise of the Greek maritime forces allowed them to capture Marseille from the Phoenicians and also to install themselves and create a trading post in Spain, near Gerome.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In Greece, land was not controlled by the state but was free, which led to the widespread development of smallholders. These smallholdings were often tiny, but competition was high and things worked well.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Most of the work in these smallholdings was manual, generally carried out by slaves using mainly wooden tools. Ploughing was by ox-drawn wooden ploughs, sometimes with iron tips.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The following crops were being grown for local use or for export.")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "Bullet-list-first"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Cereals:")]), _vm._v(" Wheat, both emmer and drum, with barley and millet in the wetter areas.")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("V"), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("egetables:")]), _vm._v(" Cabbage (three types), peas, broad beans, chickpeas, lentils, cucumber, onions, garlic, salads.")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Fruits:")]), _vm._v(" Apples, pears, pomegranates, quince, figs.")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Tree culture")]), _vm._v(": Olives, almonds, walnuts.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("As far as husbandry is concerned, the herds were small, generally family affairs. The following animals were being bred: sheep, goats, pigs, chickens and cattle. Horses, donkeys and mules were being used for transport.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In support of all this agricultural activity, many artisanal activities were being developed. A typical case is ceramic art. Ordinary pots were being produced for daily use, and large amphora and jars were produced for transporting oil, wine and cereals. For the rich tables, very fine and highly decorated table wear was made.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Between trade and colonisation, the more modern agriculture system spread around the Mediterranean and to Eastern Asia.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-104",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-34.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Greek pottery")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1"
  }, [_vm._v("3.3 Evolution of Agriculture and Plants Since A.D.0 1")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.3.1 Roman Civilisation")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Roman history is divided into three periods:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Roman Kingdoms \t\t753 – 500 BC")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Roman Republic \t\t500 BC – 27 AD")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Roman Empire \t\t27 – 470 AD")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-105",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-35.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Roman Bath")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("These periods correspond to different forms of government, but despite the internal problems the expansion of Rome was continued and very rapid but not continuous, as it was related to the ease of occupation of new territories, sometimes by consent and other times by war, and through constant combat with the barbarian invaders. Under Roman rule, agriculture and husbandry continued to develop to keep up with the rapidly increasing population necessary to feed the ever-increasing need for workers.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The city of Rome was founded in about 700 BC, and the kingdoms lasted until 500 BC when it was replaced by a Republic. At this time the Roman influence covered the whole of present-day Italy.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In 500 BC the Republic of Rome was created and they replaced the king with elected senators headed by a president. This period was a period of expansion and ended with the Punic Wars, then civil wars between leaders. At this time Julius Caesar arrived in Marseille and helped the local people to evict the Phoenicians, after which the local population helped Caesar to conquer some of his opponents in the Punic War. After this success, Caesar moved to the town of Arles and created the Roman colony with Arles as its capital in 49 BC and started his conquest of France.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("After his victory against Mark Antony, Julius Caesar’s adopted son Octavian, later known as Augustus, was made Emperor with total power. The expansion of Rome continued; its final extent is shown in the following map. At this time, it is thought that the population was about 90 million, a third of the world population.")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 13")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-106",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-36.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("The Roman Empire")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The Roman cities were important with imposing structures including generally, arena, amphitheatre, baths, forum and all the infrastructure necessary for the organised life of a city. Many artisanal activities were necessary to allow the city to function – buildings, stonemasons, foundries, metal workers, etc. Outside the town and in the rural area, large farms were important to feed all the people of the town. Water was brought to the towns from far away, with sophisticated aqueducts in stone, and was distributed in the town in lead pipes. The towns were also equipped with good water and waste evacuation systems.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In the Roman towns, the homes for the poor and the workers did not have kitchen or toilet facilities, as these activities were collective.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-107",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-37.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Pont du Gard Aqueduct for the town of Nîmes, France")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Food took an important place in Roman life. In Greece, the main activity was drinking; in Roman life, it was eating. Basic food for all was wheat, meat, vegetables and fruit. Naturally, for the rich, it would be white bread, good cuts of meat, vegetables and fruit. The poorer and working classes had enough to eat and their diets were more or less based on whole-grain bread or a porridge made from wheat and other cereals.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The foods available was meat from cattle, goats, sheep, chicken and fish. The cereals were bread wheat, durum wheat, spelt barley, oats and rye. Milk was made from cows’ milk for the poor, whereas the rich preferred milk from sheep and goats. Many types of vegetables were available: peas, broad beans, cabbages, lentils, chickpeas and root vegetables.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.3.2 The Arab World 700-1200 AD")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This period is very important in agricultural development, with the mechanisation of irrigation and early methods of large-scale agriculture to provide for the rapidly increasing population. It was possible partly to Arab traders, who had access to a large land area, from the Iberian Peninsula to parts of Asia.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("There are a lot of academic discussions between historians as to what extent this was not a development of Roman technology. The information below is just for interest.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("At the time of the Arabian empire, the following plants were being cultivated, principally: durum wheat, sorghum, rice, sugar cane, cotton, olives and other vegetables, peas, broad beans, chickpeas, lentils, different cabbages, spinach and other root vegetables, with dates and some citrus fruits. The size of the empire and the traders allowed many exchanges.")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 14 ")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-108",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-38.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("The Ottoman Empire")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The agricultural methods were improved with primitive rotation, fertilisation and a lot of development in irrigation. The norias were improved and installed all over; the sakia or animal-powered water wheels were developed in Islamic Spain and then all over the Old World.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-109",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-39.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Noria")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Rice was introduced to Europe by the Arabs, first into Spain in Valencia in the eleventh century and later to Sicily. In Valencia, the rice paddies were established around the lagoon and the Arabs taught the Spanish how to grow and cook rice. In Sicily, rice was cultivated by levelling the ground to produce rice paddies, using sophisticated irrigating that was installed. Again, the Sicilians were taught how to grow and cook rice. This rice was the basis for the paella dish, which came from Valencia. In Italy, the rice-growing moved to the Po Valley, and this is where risotto came from.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-110",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-40.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Sakia")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.3.3 Medieval Europe")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The Middle Ages in Europe were the time of the creation of monasteries in many places. These monasteries were the home of knowledge and agricultural technology and helped to spread knowledge and make exchanges with Arab and Asian scholars. They also helped local landowners to control the labour force. They helped in the exchange of crops and techniques and introduced summer irrigation to improve the output of the land and development.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The development of iron smelting allowed the realisation of iron tools: blades for spades, hoes and for ploughshares. With the adoption of the chisel-type ploughs, the heavy and wet ground of Northern Europe could be tilled.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("These monasteries took a very active part in the development of agriculture. They carried out plant improvement by selection and crossing of favourable plants. Equally, they developed methods of cultivating with rotation and also with methods of harvesting, drying and storing. Each monastery worked with the local climate, depending on local needs.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Equally they employed crop rotation with a fallow year between, and made use of leguminous plants, peas, broad beans and lentils to fertilise the land.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Waterwheels invented by the Romans were improved and used for milling flour or processing flax and wool. The principal crops were wheat, barley, oats, peas, broad beans, cabbage and vetch, used later as animal food and as a leguminous plant for its nitrogen-fixing ability.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-111",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-41.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Modern village showing medieval structures")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.3.4 Christopher Columbus and the Discovery of the Americas")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Columbus was probably not the first European to cross the Atlantic, as it is reported that Vikings and Brittany sailors had knowledge of the land, but he was the first to realise the importance of what he had discovered. His voyages were to trigger new development of trade, exchanges, war, colonisation and slavery.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Columbus discovered the products and techniques of Aztec and Inca agriculture. Among other things, he discovered beans, which he brought back to Europe. Some went to the Spanish king and others to the Pope. The Pope gave the bean seeds to the Medici family and Catherine de Medici brought them to the French court when she married into it. These developments led to the early introduction of beans to Europe, followed by selective culture to produce new varieties: for instance, the tarbais beans were very popular in south-western French cooking, notably for cassoule; in northern France in the town of Soissons, they preferred a very large white bean and the famous flageolet, and later the borlotti bean became popular in northern Italy.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-112",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-42.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Christopher Columbus Caravels")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Other products that came from the New World included potatoes, tomatoes, squash, maize, peppers, chillies, sweet potatoes and vanilla. The impact of these plants was very important in Europe, where these plants had been unknown; they were to represent a major part of European food.")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 15 Route of Christopher Columbus’ maiden trip")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-113",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-43.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.3.5 Colonisation and the Slave Trade")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("After the discovery of the New World by Columbus in the 1500s, the next century was an explosion of discovery and colonisation. The first to do this were the Spanish with the conquest of ‘El Dorado’ and the acquisition of the Inca and Aztec gold and other goods. The Spanish were quickly followed by the Portuguese, the British, the French and the Dutch.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The colonies were very rich in products not available in Europe: minerals, spices, wood and other things. There was a very important maritime exchange between the colonies and their owners and settlers were departing to the colonies to make new lives. In India and the Far East, there was no problem in obtaining labour; however, in the Americas and the Caribbean the local inhabitants either died due to disease brought in by the Europeans to which they were not tolerant or they disappeared inland to live their own life. Soon in the Americas there was a need for labour, for which the solution was slavery.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The organisation of the slave trade was somewhat complex as it had to fit into normal trade routes. The solution found was to take goods from Europe to the African coasts that could be exchanged or sold to buy slaves. These slaves were taken to the coasts of the New World to be sold. The boat then took on goods that could be sold in Europe. There was no special boat for slave transport, and all types of commercial trading boats were used, from a capacity of 20 slaves to 100; however, the general boat would carry 60 slaves for a crew of 40, the crew being more important than usual for the trip across the Atlantic with slaves.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The trips were difficult to organise as once the boat arrived in Africa, they had to buy the slaves, the boat had to be equipped for the crossing, irons and chains were installed to hold the slaves and they had to make provisions for the food and drink necessary for the crew and the slaves.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Water was transported in barrels so these had to be made or repaired. The food was mainly barley and rice as a base, with dried vegetables and preserved meat. There was the inevitable conflict between the need to deliver the slaves in good condition and the cost of food and water.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-11",
    attrs: {
      "lang": "fr-FR",
      "xml:lang": "fr-FR"
    }
  }, [_c('span', {
    staticClass: "CharOverride-7",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-114",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-44.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Despite all the difficulties, the system functioned, despite leading to atrocious conditions for the transport of many slaves. The whole round trip took from 13 to 16 months, depending on the pickup and delivery points.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The arrival of these slaves was to have a long-term influence on the dietary habits of the Americas. The rice taken to feed the slaves was African, and the leftover rice was left with the slaves or new owners. This was the first rice cultivated in the Americas, which was possible due to knowledge brought over from Africa. The slaves also adopted the products of the New World that they were quick to use. Following their knowledge of making rice bread, they adapted their technique to make bread from hominy (maize flour) to make the cornbread now famous all over the Americas.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The three maps that follow (maps 16-18) shows the general routes taken by what was called the triangular trade. The European traders left mainly from their home ports in Spain, France, Portugal, the United Kingdom, Holland and Belgium to a first destination in Africa – generally West Africa and in certain cases East Africa. In this first stage (see map 16: Slave Trade Triangle, Stage 1), the cargo was manufactured goods, arms, ammunition, trinkets, all destined to be sold or traded to African chiefs or bandits in exchange for slaves.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The next stage (see map 17: Slave Trade Triangle, Stage 2) would deliver the slaves to the new areas of colonisation, mainly Brazil, and then to the Caribbean areas and the southern states of the present United States.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The third stage (map 18: Slave Trade Triangle, Stage 3) was the return to Europe with wood, minerals and other raw materials.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Later the Americans joined the slave traders, but their trips were solely transatlantic.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("All these maps show typical routes, but this is only an indication.")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 16: Slave Trade Triangle, Stage 1")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-115",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-45.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 17: Slave Trade Triangle, Stage 2")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-116",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-46.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 18: Slave Trade Triangle, Stage 3")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-116",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-47.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.3.6 Asia 0-2000 AD")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This period in Asia represents a large-scale development of agriculture to meet the increase in population. This meant gigantic expansion, employing farm workers to produce the terraced rice paddy fields and large irrigation projects.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("It was a period of development of derived leguminous products, generally beans in China, Japan and Korea.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The following sub-products were made: soy milk, soy wine, tofu, fermented bean paste, soy sauce, miso, sweet adzuki bean paste and cellophane noodles.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-117",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-48.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Example of bottles used for soy products")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Soy Milk")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Soy milk is made from ground soybeans and water and is a substitute for animal milk. The first date of its utilisation is largely disputed but is probably between the first and fourth centuries AD.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Soy Wine")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Soy wine was first reported in about 350 AD. This is a fermentation of soybeans that gave an alcoholic drink. Later, beans and rice were fermented together and gave higher alcohol content. Later still, rice was used alone, with an even better result.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Soybean Sprouts")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("These were first eaten by the Koreans in the tenth century, at the time of the Three Kingdoms.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Tofu")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Tofu is made by curdling soy milk to give curds and whey. These are then used in much the same way as animal milk is used to make cheese.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Fermented Bean Paste")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Fermented bean paste is generally made from yellow soybeans, which are cooked until soft, ground to a paste, mixed with salt and sugar and then fermented by a complicated procedure for about one year. There are dozens of types of fermented beans, going from very light to almost black, depending on the type of bean and the other products added. They are used all over Asia to make sauces to flavour dishes. The first reported bean fermentation was Chinese black bean fermentation in about 165 BC.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-118",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-49.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Soy Sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Soy sauce is a liquid with a taste of meat and aromas coming from the degradation of vegetable proteins by fermentation. There are hundreds of types of soy sauce, going from light brown to almost black, and many types of different tastes. In China, where they were produced initially from about 700-900 AD, they were made from soybeans and roasted wheat. The method of production is fairly complex. The sauce spread all over East Asia and in each country it was modified or adapted.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Miso")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Miso is a Japanese culinary preparation with the texture of peanut butter, coloured from light brown to chocolate,. It is used to perfume soups and dishes and to make sauces, and also as a condiment to serve with starter dishes. It is made by fermenting soybeans with twice the weight of rice. The procedure is somewhat complex and can take from weeks to years, according to the specific requirements.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Sweet Adzuki Bean Paste")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("This paste is made by soaking adzuki beans and then cooking them with sugar to give a jam-type paste that then forms the base to make bread or pastry. This is used all over East Asia.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Cellophane Noodles")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Cellophane noodles or Chinese vermicelli are transparent noodles made from starch and in China from ground mung beans.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.3.7 European and American and Modern Times")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This period is important as the time of the great agricultural revolution. During the period there was a greater need for food for the increasing population at the beginning of the industrial revolution. Up to this time, agriculture was based on a system that deprived the land of its natural richness and typically land was left fallow every few years to recover some of this richness. One of the most important factors to improve productivity was the introduction of the Dutch rotation method. In this rotation, there are four crops that are grown in rotation – wheat, barley, clover and turnips – where the use of a leguminous plant, clover, allows the land to keep its nitrogen content, while the turnips make use of lower levels in the soil and improve the structure. ")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The other major change was the development of the enclosed land method of farming. Up to this time, fields were left open and used by others than the owner due to the popular grazing rights of village shepherds. Later came changes in the social structure of farmers and the development of markets and transport, mainly by the canal system. At this stage, there was a large movement of the population from rural areas to the towns to work in the emerging manufacturing factories in the towns. The agricultural changes allowed an improvement in productivity and with improved transport enough food to be produced to meet the increasing need.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Mechanisation")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Animal-drawn ploughs have been known for all of recorded history. The Mesopotamians and Egyptians used them; these were wooden and were improved over the ages. In the mid-1600s, the Dutch improved the Chinese plough, and other animal-drawn tools were improved. In 1700 an Englishman developed a new plough with a cast iron frame and improved mouldboards and shares, which gave a better result. This plough was named the ‘Scots plough’ and was used for many years. Most work could be carried out with horse-drawn tools. This even includes threshing machines using equipment invented by the American McCormick in the 1800s but only used much later.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("At this period, work had started on selective breeding based on the work of Mendel. Animals with desired characteristics were selected for breeding: these techniques produced animals with more useful specialisations, for instance, finer wool, increased weight or better resistance to diseases.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-119",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-50.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-120",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-51.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption ParaOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Single mouldboard and share plough          Light harrow")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Motorisation")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The first replacement of animals as a power source started in the 1820s with the first steam-powered tractor. These machines were inspired by railway locomotives; they were heavy and hard to use, either in direct pulling or in cable hauling, which was introduced in about 1850. They allowed the use of larger tools and improved production.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-121",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-53.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Steam power tractor")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The first tractor with an internal combustion motor appeared in 1892. The first successful model was introduced in 1902, and this was the beginning of powered tractors all over the world.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In 1918 the first power take-off (PTO) was introduced. This means that it allowed the power of the tractors to be transferred to the attached tool via a driveshaft mechanism.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In 1935, the company Ferguson introduced the three-point hitch. This allowed the tractor to be coupled to the tool and the tool to be lifted vertically for road transport onto the field and put to the correct working height. This technology was adopted by Ford in 1939 and is used by most tractors manufacturers today. The three-point hitch was hydraulically powered by the oil pressure from the tractor’s hydraulic pump. It was possible to use this oil pressure to operate hydraulic pistons on the tools, and typically to turn double share ploughs or open cover crops.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The end of World War I saw the rapid increase in the need for food for the growing population. The industrial companies that had been making tanks and other military materiel turned to agricultural machinery tractors and tools, while others that had been making explosives and propulsive powder turned to synthetic fertilisers, herbicides and pesticides.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Today, ploughs with up to 20 mouldboards and shares are available for very extensive farms.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("The Dust Bowl")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("This was a major agricultural catastrophe, between 1900 and 1930 in the south-western US states of Oklahoma, Kansas and Texas. This was due to intensive cereal farming involving deforestation. The destruction of the woodlands led to drought conditions, and the land was overexploited without consideration. This led to soil erosion and massive dust storms, and the area was abandoned. It took many years to try to return to a normal state. This was made possible by the planting of millions of trees by the US government. This catastrophe made the US government create a service of land protection and control. This made other countries aware of this problem and some followed suit.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Modern Agriculture")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Modern agriculture has become highly mechanised and very chemical-dependent, using genetically modified plants that allow the plants to resist the herbicides that are used to avoid invasive weeds, and industry has partly taken control of farming methods.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-122",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-52.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Modern tractor with a six-furrow reversible plough")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1"
  }, [_vm._v("3.4 Historical Dates of the Leguminous Plants in Early Civilisations")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Towards the end of the Stone Age and the beginning of the Bronze Age, the activities of man started to get organised. Already in the Stone Age, part of the population became less nomadic and with the knowledge they already had, they could go back to the known areas to pick plants that were ripe or catch fish that would be there at that time. This represented an evolution in the way of thinking and organising. This was the first settlement the tribes would stay in one place and start to cultivate in a primitive way whilst others would hunt in the area.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("Knowledge of Food Plants at the End of Early Civilisations")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("This is a global view, with the world divided into three groups, Asia (1), the Americas (2) and Europe, the Middle East and Africa (3).")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("1. PLANTS KNOWN")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("1.1 Asia")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Japonica rice in China, Indica rice and mung beans in India, soy and adzuki beans in China; cabbage, onions, millet, wheat, mustard, radish, turnips, wasabi, perilla.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("1.2 The Americas")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Maize, tomatoes, squash, potatoes, quinoa, beans, peppers.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("1.3 Europe, Middle East and Africa")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Peas, cabbage, broad beans, chickpeas, wheat, oats, barley, onions, collard greens.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2. PLANTS NOT KNOWN")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("2.1 Asia")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("European crucifers.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("2.2 The Americas")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Cabbage, peas, broad beans, wheat.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("2.3 Europe, Middle East and Africa")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Maize, rice, tomatoes, beans, potatoes, squash, Chinese crucifers, peppers.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Major geographical transfers:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Rice was being cultivated by the Arabs who took it to Spain and Italy in their invasion of Europe.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Beans, maize, tomatoes, potatoes and squash were brought to Europe by Columbus and other Spanish boats in the eighteenth century and the Europeans took, cabbage, peas, broad beans, rice and chickpeas to the Americas.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1"
  }, [_vm._v("3.5 List of Plants and their Geographical Origin")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In this section, we give the details and estimated dates of the presence of the different leguminous plants and historical dates of other detail, methods of cooking.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.5.1 Peas")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("3.5.1.1 Green Peas and Mangetout")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Peas were first domesticated in Syria, Turkey and parts of Egypt. The following traces have been documented:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Turkey\t\t\t6500 BC")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Nile Delta \t\t4800-4000 BC")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Upper Egypt \t\t3000 BC")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Indus Valley \t\t2000-1700 BC")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Ganges Valley \t\t2000 BC")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-123",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-54.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Pea flowers")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Peas were cultivated by the Romans, but wild peas were still collected by Roman soldiers to improve their rations. Peas, broad beans and lentils were the staple food in the Middle East, north Africa and Europe during the Middle Ages. In the seventeenth century, mangetout was developed, and at about this time it became the habit to cook fresh green peas.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("3.5.1.2 Indian Peas")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("This pea is indigenous to southern Europe, northern India and the Horn of Africa and has been cultivated from Neolithic times. It is the oldest known vegetable.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("3.5.1.3 Kudzu Peas")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Kudzu peas are indigenous to Japan, Korea, China, Nepal and Bhutan. They seem to have been domesticated in about 3000 BC.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("3.5.1.4 Pigeon Peas")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Pigeon peas are a perennial plant that is indigenous to India and was domesticated in 1500 BC.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.5.2 Broad Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Remains of broad beans have been found in the Egyptian pyramids, and the plant had travelled as far as North Italy by the Bronze Age. They were known all over the Eastern Mediterranean from 6000 BC and very early on were used as a cover top to protect the land from soil erosion, as they give a green cover during the winter and fertilise the soil. They can be used fresh or dry after soaking. They are very popular in the Middle East, where they are used in many ways.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.5.3 Chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The origin of chickpea is in Turkey, the Middle East and India, in about 7500 BC. However, remains have been reported in South-East France in 6700 BC, so wild chickpeas must have been present all around the Mediterranean and east towards India. Today, chickpea grows all around the Mediterranean, South Asia and India. Generally, it is the dry seeds that are harvested. In India during the cultivation season, fresh green chickpeas are available. These are very good but unfortunately they are not available in most countries because of the high cost of harvesting. However, you can grow them in your garden.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.5.5 Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This group of plants is somewhat more complicated as they were absent from the traditional home of the Mediterranean and the Fertile Crescent of the Euphrates. There were separate origins for different bean types.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("3.5.5.1 American Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The origin of the American beans would seem to be the following:")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table021"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Tepory Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Mesoamerica")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Runner Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Mesoamerica")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Lima Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Andes")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Common Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Andes and Mesoamerica")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Trailing Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Mesoamerica and Canada")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Tam Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Mesoamerica")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Jicama")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Mesoamerica")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Goityo")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Brazil, Amazon")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Ahipa")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Anes")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Beans were domesticated in America in two distinct areas, first in the South American Andean area going from north Chile to the southernmost part of Central America, the second being from Central America to the south of what is the United States today.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The following table shows the continental distribution of the leguminous plants.")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Table 3: Continental (World) distribution of the leguminous plants")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table022"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('thead', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Europe")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("India")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Asia")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("America")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Africa")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Pacific")])])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Peas")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Broad Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Chickpeas")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Lupins")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Peanuts")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Tamarind")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Fenugreek")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Liquorice")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Mesquite")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Rooibos")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("False Acacia")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Mimosa")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("3.5.5.2 Indian Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Here we are talking about the Mung bean, which was first domesticated in the Indus valley in 2500 BC and in the south of Kerala in India in 2000 BC.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-124",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-55.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Mung Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("3.5.5.3 East Asian Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Here, we are concerned with the soybean and remains have been found in:")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "Bullet-list-first"
  }, [_vm._v("China \t7000 BC")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Japan \t6000 BC")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Korea \t1000 BC")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("For information, Chinese legend states that from about 250 BC the following plants are sacred: beans, rice, wheat, barley and millet, which would allow us to imagine that these plants were already domesticated.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("3.5.5.4 South-East Asian and Pacific Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Hawaii Island was the home of some 50 species of beans. Some of these beans are now cultivated worldwide:")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "Bullet-list-first"
  }, [_vm._v("Rice beans")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Cowpea (beans)")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("The Winged bean from New Guinea is also cultivated in Africa and Asia")])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("3.5.5.5 African Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The following beans are from tropical Africa:")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "Bullet-list-first"
  }, [_vm._v("Guar beans")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("One-eyed beans")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Velvet beans")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("There is some confusion between the origins of Africa and Pacific beans, probably due to trade movements. So, there may be some errors about origin.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("3.5.5.6 Beans in Europe")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Beans are not indigenous to Europe but came to Europe in the 1500s after the return of Columbus following his discovery of the Americas. In fact, on his first trip, Columbus did not get to the mainland of the Americas but ended in the Caribbean islands, in particular in Cuba, where he found beans and many other vegetables that had been cultivated thousands of years ago in Mesoamerica and the Andean part of South America. The vegetables included maize, potatoes, tomatoes and squash.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Before this time, beans were present around the Pacific rim and in the Hawaiian islands, in India and in tropical Africa.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("It is easy to understand that the beans did not come across the Atlantic to Europe. However, it is surprising that this did not involve the popular commercial connections between Asia and Europe transversal voyages, particularly the Silk Road, which brought many products from Asia to Europe.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("On his return, Columbus gave the beans to the King of Spain and to the Pope who in turn gave the beans to the family Medici. Catherine de Medici bought the beans to the French court on her marriage to the King of France, after which beans spread very quickly all over Europe where they are cultivated in most places.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor037"
    }
  }), _vm._v("3.5.6 Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Lentils were known in Eastern Mediterranean, Syria and Turkey area from 13,000 to 9,999 years ago. In the Bronze Age, deposits were found in Switzerland (Lake Biel).")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor038"
    }
  }), _vm._v("3.5.7 Lupins")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Lupins were known to the Egyptians and were found in the pyramids, dating from 2000 BC, and were cultivated in the Empire. Later it was cultivated by the Romans, who spread them through Europe and particularly in the south and Mediterranean areas.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Lupin was also known in the Andes, and evidence has shown it to have been present in about 700 BC in what is now Peru.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Both the European and Indian lupins are bitter due to the presence of alkaloids. These bitter elements can be dissolved by soaking in water or salted water and cooking. Despite these difficulties, lupins have continued to be grown and used as street food all over Southern Europe, North Africa and the Eastern Mediterranean.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("A low-alkaloid lupin was developed in Germany and Poland in the early 1830s. Trials were made, with average success. Due to wars, these trials were never finished.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In the 1980s, there was a major breakthrough in Australia with the development of a sweet lupin that had a minimum of bitter alkaloids. This project has continued successfully, and today sweet lupin, flour, flakes and beans are available. The main obstacle for the development of this product is where the risk of cross-pollination with non-alkaloid free or wild lupin is high. This means the culture must be carried out in an area with a weed-free zone. This is possible in such countries as Australia, Canada or the United States, but is very difficult in Europe and other neighbouring countries.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-125",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-56.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Wild Lupins")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor039"
    }
  }), _vm._v("3.5.8 Peanuts and Groundnuts")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("There are three origins in this group, coming from different areas:")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("3.5.8.1 "), _c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Vigna Subterranea")]), _vm._v(" (Groundnut, Bambara bean)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("This is the West African groundnut; it is an annual leguminous plant that originated in the area of Mali and Nigeria.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("3.5.8.2 "), _c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Arachis Hypogaea")]), _vm._v(" (Peanut)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("This annual leguminous plant is a hybrid of a rare type that originated somewhere between Bolivia and the north of Argentine. It was subsequently domesticated in a number of surrounding countries: Argentine, Peru, Ecuador, Brazil, Paraguay and Uruguay. In each of these countries a specific sub-species was developed each being different and botanically identified.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("3.5.8.3 "), _c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Apios Americana")]), _vm._v(" (Indian potato, Potato bean)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("This plant is indigenous to North America, from southern Canada to the southern states. It is an annual leguminous plant and grows wild was collected and domesticated by the native American Indians; it was a lifesaver like chestnut for early pilgrims and help them to pass the first winters. The genetic material of these plants has been used to produce the peanuts of today. The name Indian potato was given by The American Indians.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor040"
    }
  }), _vm._v("3.5.9 Carob Tree (St John bread, Locust bean "), _c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Ceratonia siliqua")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is an evergreen flowering shrub or tree of the leguminous family and is widely cultivated for its edible pods. It is indigenous to the Mediterranean area, its limits being the South of Europe to North Africa and from the Canary Island to Iran.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor041"
    }
  }), _vm._v("3.5.10 Tamarind ("), _c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Tamarindus indica")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a tree of the leguminous family indigenous to tropical Africa and India.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor042"
    }
  }), _vm._v("3.5.11 Mesquite")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer177"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-57.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer178"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Mesquite")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Mesquite is a family of leguminous deciduous trees and shrubs that grow in hard conditions from Central America to the north of South America. It has some forty family members of very different sizes that have been present from the Pleistocene and wood has been found from 1000 BC. The pods were used by indigenous populations as food for themselves and for livestock.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor043"
    }
  }), _vm._v("3.5.12 Fenugreek ("), _c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Trigonella foenum-graecum")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Fenugreek is an annual leguminous plant originating in the Middle East and India, which reached the Channel Islands.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor044"
    }
  }), _vm._v("3.5.13 Liquorice ("), _c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Glycyrrhiza glabra")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Liquorice is a perennial leguminous root plant indigenous to Southern Europe and the Asian plains.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor045"
    }
  }), _vm._v("3.5.14 Rooibos ("), _c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Aspalathus linearis")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Rooibos is a leguminous shrub growing on the hills around Table Mountain in South Africa. It was first used, it is believed, by the local population some three hundred years ago to make a tea-like infusion. Its international commercialisation started in the 1930s.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor046"
    }
  }), _vm._v("3.5.15 False Acacia")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("False acacia is a leguminous tree origin in North America. It is now grown all over temperate climates. Its flowers are used for making beignets.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor047"
    }
  }), _vm._v("3.5.16 Mimosa")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer179"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-58.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer180"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Mimosa flower")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Mimosa is a leguminous tree indigenous to Australia. It was brought to Europe by Captain Cook and now grows in many parts of Portugal, Spain, Italy and parts of France.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Its bright yellow flowers are used in many ways. To make syrups, jellies, crystallised fruits, and the whole flower can be used to make beignets. In Italy, they give a bouquet of Mimosa flowers to celebrate International Woman’s Day. This was chosen by the Italian Women Association on 8 March 1946.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer194"
    }
  }, [_c('p', {
    staticClass: "Chapter-head"
  }, [_vm._v("Chapter 4\tLeguminous Plants and Folklore")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1"
  }, [_vm._v("4.1 Expressions")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer182"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-4-01.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer183"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Early beans")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("OLD BEAN: a word of welcome for a friend.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("HAVEN’T GOT A BEAN: broke, no money.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("GOTTA COUNT ME BEANS: better check my money.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1"
  }, [_vm._v("4.2 Fairy Tales and Legends")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.2.1 Jack and the Bean Stalk")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is an old English fairy tale that first appeared under the title of "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("The Story of Jack Spriggins and the Enchanted Bean ")]), _vm._v("published in 1734. Since then, it has been re-written, changed and modified many times as a book, pantomime, and plays for children, films, video and games.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The following is a summary of the tale.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Jack, a young lad, lived with his widowed mother in a small farm cottage with a cow, Bess, who was their only source of income. One day the cow had no more milk and the widow said to her son, “Go to the market and sell the cow.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Jack took the cow to the market, but on the way, a wizened old man said to Jack, “Hello, Jack. Where are you going this morning?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Jack, rather surprised that the old man knew his name, said, “I am going to the market to sell the cow.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The old man walked around the cow to make sure that all was well and said to Jack, “Look in my hand: I have some magic beans, and I will exchange them for the cow.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Jack looked at the beans and was in a quandary to know what to do, so he asked the old man, “What is magic about these beans?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The old man explained to Jack that if he planted the beans that they would grow overnight to the size of a tree and lead him to the treasure. The old man, seeing that Jack was bewildered, said that if it did not work, the old man would return cow in exchange for the beans. Jack, thinking that this was a fair deal, took the beans in exchange for Bess. When Jack got home, he explained to his mother the deal he had done with the old man. She was furious and sent him to bed without any dinner.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The next morning, when Jack woke, he saw a shadow on the bedroom window and opened it and saw that the bean had grown overnight and the stalk seemed to disappear in the clouds. Without hesitating, Jack climbed the beanstalk that took him through the clouds, where he saw an enormous castle. Jack left the beanstalk and walked up the windy road to the castle as he walked into the kitchen. He found a woman cooking. She asked what he was doing and he told the story of the old man. The woman said that it was very dangerous as her husband the giant would be back soon and might kill him: “Come and hide into this copper pot. He will be here soon for his breakfast, you hide and since he has a nap after breakfast and once he snores you can get away.”")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-126",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-4-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("A few minutes later the giant arrived with much noise:")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-first"
  }, [_vm._v("“Fee-fi-fo-fum,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("I smell the blood of an Englishman.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Be he alive, or be he dead,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("I’ll grind his bones to make my bread.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("“Nonsense,” said his wife, “go and get washed; your breakfast is nearly ready.” ")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The giant left and came back to eat noisily; once finished, he said to his wife, “Bring me the white hen and the singing harp.” He poked the white hen and said “lay” and the hen laid a golden egg that he put in a sack under the table. He took the golden harp and started to strum and a beautiful woman’s voice sang a lullaby. The giant fell asleep and started snoring.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Jack climbed out of the copper pot and tiptoed across the room and as he passed the harp, there was a whimper: “Take me with you. I can’t stand it here.” Jack hesitated, bit his lip, picked up the white hen and the golden harp; as he was leaving the castle, the hen cackled and woke the giant. Jack realised that he was in trouble and ran as fast as he could to reach the beanstalk.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("He heard a growl as the giant came out of the castle and started chasing after him. Jack started to climb down; when he was some way down, he felt the stalk shake as the giant started to climb down. He moved quickly and when he got nearer to the ground, he cried, “Mother, mother, bring the woodchopper quickly.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("When Jack was able to jump down, he gave the hen and the harp to his mother and started to chop the stalk. The axe was sharp and Jack was used to chopping wood and when the giant got near, there was a crunch and the beanstalk fell, killing the giant.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The white hen continued to lay golden eggs and Jack rebuilt the farm, re-purchased old Bess. Jack, his mother, the white hen, the singing harp and old Bess lived happily thereafter.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.2.2 The Beans of Soissons")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Soissons is a town in the north-east of France well known for its large white beans that is well known for their very good taste. The bean has a number of legends of its origin: all of them are interesting. A few examples are as follows.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("FIRST LEGEND")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("During hundreds of years of war between the French and the English during 1337-1453, the town of Soissons had an epidemic of plague and those who could abandon the town did so, often leaving part of the provisions of grains and animals along the road. When they returned, they found along the river and canal a very surprising harvest of wonderful white beans. Since this time, they have been called Soissons beans.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("SECOND LEGEND")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("In the town of Soissons, there is a street called rue de la Paix, ‘Peace Street’, after a peace conference that was held in Soissons in 1728 to host a European conference which went on for several months on the future of Gibraltar. Spain was represented by the Marquis of Santa Cruz. The Spanish diplomat became friends with Jacquot, the gardener of the Saint Léger Abby, for whom he had great respect. The negotiations carried on for too long and The King of Spain recalled the Marquis. Before leaving Soissons, the Spanish diplomat made a present to Jacquot of a leather sack of Cordovan leather. When Jacquot opened the sack, he found beans much larger than the beans that they usually cultivated. He cooked some and found them excellent and planted them the year after. The crop was good, and from that time everybody who had a garden cultivated these beans that were called the ‘real Jacquot’.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("THIRD LEGEND")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("In the late 1800s, the Soissons watchman called Le Paon never left his watch. He watched over the town for fires, at the same time continuing his profession as a cobbler. This gave him a lot of pleasure but did not completely satisfy his curiosity. He occupied the rest of his time by sowing beans in boxes around the protective walls of the watchtower, and they grew to cover the tower with greenery, which everybody was pleased to see.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("“It’s the true Soissons,” he told his visitors, but added, “not as pleasant as described by the naïve poet,” and quoted: “God created the flower said, ‘Be Rose’, created the bean and said, ‘Be Sois Sons and go in peace’”. He wrapped his beans in cloth bags and gave them to the visitors. There was a confectioner who had a shop near the cathedral and he made a mould to make boiled sweets in the same form as the beans and coloured the same beige. He sold the sweets in cloth bags like the cobbler. It was a success, and he shared the profit with the cobbler.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("These three legends are still maintained in the town of Soissons, and every year in September there is a festival of ‘The Soissons Bean’, with many celebrations throughout the town.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.2.3 Lyrics")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("4.2.3.1 Beans, the Musical Fruit")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("There are many rhymes about the musical bean; see below a few examples.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-first"
  }, [_vm._v("Beans beans, the musical fruit,")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer185"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-4-03.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("The more you eat, the more you fart.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("The more you fart, the better you feel,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("So, we have beans at every meal!")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Or")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-first"
  }, [_vm._v("Pinto beans are good for your heart,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("The more you eat, the more you fart.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("The more you fart, the better you feel.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Or")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Stephen King in "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("The Dark Tower")]), _vm._v(": “Beans beans, the musical fruit, the more you eat, the more you toot.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Or")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The cartoon "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Camp Lazlo")]), _vm._v(" has a censored version:")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-first"
  }, [_vm._v("“The more you eat,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("the more you sit on the toilet seat”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In fact, the fart may have a musical context. I remember, when I was a young boy at boarding school in a rehearsal of a Gilbert and Sullivan operetta ("), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Pirates of Penzance")]), _vm._v("), that at the line ‘a cat’s footfall could be distinctly heard’, one of the boys let out a fart. Everybody was trying not to laugh. The choirmaster rapped his stick and said. “We will start again.” At the end, nothing was said, but baked beans were no longer served on music days.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.2.4 Lyrics: Beans and Cornbread")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer186"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-4-04.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("These are the lyrics of a song written by Louis Jordan:")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-first"
  }, [_vm._v("Beans and Cornbread,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Beans and Cornbread had a fight,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Beans knocked Cornbread out of sight.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Cornbread said, “Now that’s alright, meet me on the corner tomorrow night.”")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("“I’ll be ready. I’ll be ready tomorrow night.”")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("That’s what Beans said to Cornbread. “I’ll be ready tomorrow night.”")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1"
  }, [_vm._v("4.3 Music")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("People and groups that have adopted beans in their name or personal bean details.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.3.1 Beans, an American Rapper")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The American Robert Edward Stewart (the Second) was born in New York on 3 July 1971; his professional name as an underground rapper was Beans. He was a member of the Antipop group and he was the founder of Tyga Rawwest Records. He produces a number of what was called chunky psychedelic electro-hop. Beans performed on the same stage as performers like Radiohead and Kool Keith.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.3.2 Louis Armstrong’s Creole Beans and Rice")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Louis Armstrong was well known for his love of beans and rice and as we have mentioned signed his letters ‘Beans and ricely’. After his death, his own personal recipe was found in his papers. This recipe is often served at jazz festivals.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-127",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-4-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.3.3 Red Beans & Rice Jazz Band")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer188"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-4-06.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Red Beans are a group based in Tel Aviv. They play swing music, also known for the tap-dancing that goes with the music. Their music style is from 1920s traditional New Orleans jazz right through to the 1940s; this was very popular in Harlem in New York. They played in famous clubs like the Savoy Ballroom and Cotton Club.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.3.4 Beans on Toast")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Beans on Toast is the stage name of British folk singer Jay McAllister, born 1 December 1980, from Essex, England. The group’s music includes folk, alternative rock, with antifolk topics like politics, drugs and love. Beans on Toast opened the Glastonbury Festival one year. They supported Kate Nash in 2008. One of their traditions was to release an album on McAllister’s birthday; from 2009 to 2018 they did this.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.3.5 Les Haricot Rouges (The Red Beans)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Les Haricot Rouges were a French jazz band, formed in 1963 by a group who all came from the Rodin School in Paris. They played New Orleans jazz and Dixie. They sold one million albums worldwide. In 2013 they celebrated their 50 years as a group with a new album, ‘French Melodies’. They were very popular.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.3.6 Black Beans and Jazz")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Black Beans and Jazz were a group formed to play jazz music with themes by famous Guatemalan groups. It was published for Margarita Tejada House. Black Beans and Jazz support the work of the Margarita Tejada Foundation, which supports the work of Down syndrome.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.3.7 Bread and Beans Line Dancing")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a very popular song for line dancing:")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-first"
  }, [_vm._v("“Bread and beans and yellow cheese.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Having no idea of what’s going on.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("With our friends, with our dews was it right or wrong. I was gone.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The above is just to give you an idea of the lyrics. The original song was from Ernie Oldfield, from the CD "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("I Got What I Am")]), _vm._v(" sung by Peter Jordan.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This song is very popular worldwide. See one example, “The Rodeo Girls ‘from South Africa. If you want to listen to this, go to the following website: Rodeo Girls. Bread and Beans (Line Dance).")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-128",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-4-07.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1"
  }, [_vm._v("4.4 Comic Strips and Films")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.4.1 Beano")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("The Beano")]), _vm._v(" is an English comic magazine for children. It was first published by D. C. Thompson and Co. in 1938 and has continued to the present. It is published weekly on Wednesdays and dated the following Saturday. Today it is published by John Anderson. It remains very popular and contains the adventure of Dennis the Menace, Minnie the Minx, The Numbskulls and many others. It is also published in the form of an annual.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-129",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-4-08.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Street mural showing Dennis the Menace (and his dog Gnasher)")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.4.2 Peanuts")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Peanuts")]), _vm._v(", also called "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Snoopy and the Peanuts")]), _vm._v(" or just "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Snoopy")]), _vm._v(", is a comic strip created in 1950 by Charles M. Shultz, an American cartoonist. Mr Shultz started his career as a cartoonist in his home town of St Paul, Minnesota with the famous ‘Li’l Folks’ that appeared in his home town by Pioneer Press Publisher 1947-1950. In 1950, he moved to New York and started a saga with two principal characters: George Brown, a young man, clumsy, without a chance and depressed, and his dog Snoopy. "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Peanuts")]), _vm._v(" was a great success in the United States and worldwide. It was published in many countries and in many languages and continued until the death of Shultz in 2000.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-130",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-4-09.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Charles M Shultz drawing his most famous character, Charlie Brown")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.4.3 Mr Bean")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Mr Bean")]), _vm._v(" is a British television series created by Rowan Atkinson and Richard Curtis and produced by Tiger Aspect Productions. It is a family-type comic with 14 episodes, produced from February 1990 to December 1995. Each episode is about Mr Bean and his toy bear Teddy and their surprising adventures. The role of Mr Bean is played by Rowan Atkinson himself; the films are almost without words and take "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Mr Bean")]), _vm._v(" into a series of impossible situations, where he is able to create extraordinary situations, like getting people to fight to gain a few places in a queue. Rowan Atkinson has extremely visual abilities and offers a sort of exercise in non-verbal communication. The series has been a success and is shown worldwide.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.4.4 Tintin")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Tintin is a fictional character in "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("The Adventures of Tintin")]), _vm._v(", created in 1929 by Belgium cartoonist Hergé. Tintin’s dog was called Snowy. The family dog was called Mangetout, and his grandfather was always trying to train the dog in vain.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1"
  }, [_vm._v("4.5. Other Uses")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.5.1 Carat")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The carat, a unit of measure for gems, is derived from the carob seed, the seed being used by the Greeks, Romans and Arab as a measure. For jewellers, the seed of the carob has a diameter of 6.5 mm and this is the diameter of a 1 carat, ‘brilliant cut’ diamond. The value of the diamond carat is not the same as for other gemstones. This carat is not to be confused with the carat of goldsmiths, where it is a measure of purity.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.5.2 Michael Lotito (Monsieur Mangetout)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Michael Lotito was a French entertainer, born in Grenoble in 1950. He was famous for eating indigestible objects like metal, glass and rubber. He broke the objects into small pieces then ate the pieces, washing them down with mineral oil. A Cessna 150, a small plane, was one of the most famous things he ate. This took several years. This is why he became known as Monsieur Mangetout, translated to Mr Eat-All.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.5.3 Peashooter")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Peashooter comes under lots of categories. Here are a few examples.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("4.5.3.1 Boeing P.26 Peashooter Fighter Aircraft")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-131",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-4-11.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The Boeing P.26 Peashooter was the first American aircraft built all in metal. Designed and built by Boeing in 1932, it was used by the American Air Force, the Republic of China, the Philippines and the Guatemala air forces.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("4.5.3.2 Peashooter: a version of the blowgun or blowpipe")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The peashooter is a toy version of the blowgun or blowpipe. It’s a long tube that you blow down to shoot the dried peas out. There are lots of different sizes and versions. I can remember when I was a young girl that most of the boys had small ones and the girls were the targets. There is a World Peashooting Championship in England, in the village of Witcham. It’s carried out in the same way as archery.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("4.5.3.3 Peashooter: the nickname for a pistol")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The peashooter is a name for a small hand with low efficiency, i.e. 22 calibre. It is also the nickname of a lot of small handguns.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.5.4 Blowgun or Blowpipe")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The blowpipe or blowpipe goes way back in history. It’s the same principle as the toy peashooter.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Many cultures used these weapons. The indigenous people of South-East Asia, the Amazon and the Guiana regions of South America, Central America and Guatemala were best known for using blowguns. These blowguns were used for hunting small animals. They were very effective. You can see evidence of painting of blowguns on pre-Columbian pottery, also in many Mesoamerican mythologies. Today the blowgun is used more for tranquillising dangerous wildlife. Sometimes to control the numbers and sometimes so that they can tag the animals to be able to monitor their whereabouts. The history of this is very interesting.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-132",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-4-12.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Man with peashooter in Beaubourg, Paris")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("We had a lot of fun putting this chapter together, and hope you will enjoy reading it!")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer229"
    }
  }, [_c('p', {
    staticClass: "Chapter-head"
  }, [_vm._v("Chapter 5\tCooking and Recipe Codes")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("5.1.1 Codes")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer195"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-01.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer196"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("White bean soup")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This chapter is not a cookbook, but an overview of the vast possibilities in cooking the different leguminous. The number and diversity of the leguminous fruits and vegetables are quite astonishing and gives cooks, dieticians and food industries great scope. Another aspect of the leguminous is that they are gluten-free which today is very important for many people who cannot tolerate gluten or do not want gluten. Some of the leguminous contain slow-releasing sugars which may be useful for certain diets.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("To be able to find what one is looking for we have the following numbering system:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The recipes will have the first number 6, to refer to the chapter number.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Then we have the numbering of dishes, which will be the second suffix in the number code: ")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("For instance, 3 = Main dishes, so the main dish headings will be numbered 6.3.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The five dish codes are as follows:")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table023"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("1")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Soups and Consommés")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("2")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Salads, Starters, Snacks, Bread and Pancakes, and Sauces")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("3")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Main Dishes")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("4")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Side Dishes")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("5")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Sweet Dishes and Drinks")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Below we have the vegetable codes. This means, for example, that the main chickpea dishes have the heading number 6.3.3: in other words, 6. (Chapter number) + 3. (Main Dish) + 3 (Chickpeas).")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main ParaOverride-7"
  }, [_vm._v("The numbers of the ingredients (the third set of digits) are as follows:")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer197"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-02.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer198"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Sweet pea flowers")])])]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Numbered-list-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peas")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list ParaOverride-13"
  }, [_vm._v("Broad Beans")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Chickpeas")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Fresh Beans")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Dry Beans")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Lentils and Pulses")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Lupins")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Peanuts")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Carob Tree")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Tamarind")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Mesquite")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Fenugreek")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Liquorice")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Rooibos")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("False Acacia")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Mimosa")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In the different recipes, we have adopted the following conventions for the weight.")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table024"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("1 tsp")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("heaped teaspoon (about 5.0g)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("½ tsp")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("level teaspoon (about 2.5)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("tbsp")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("heaped tablespoon for dry ingredients, level for liquids.")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("All weights and volumes are in metric values:")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table025"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("g")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("grams")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("kg")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("kilograms")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("ml")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("millilitres")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("dl")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("decilitres")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("l")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("litres")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("When quoting volume for measurement, this is what we mean: 1 volume of white rice to 2 volumes of water. The word ‘volume’ refers to the same amount.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In different recipes we talk about a certain number of spices. The following are some of the details.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("Herbs de Provence")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer199"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-03.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer200"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Bunch of Herbs de Provence")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a mixture of herbs used in Proven"), _c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("ç")]), _vm._v("al cooking and is a mixture of herbs. This is a mixture which varies depending on the taste you desire or on the cook. It can also be found in shops. The following is the mixture that we use. We make it ourselves from herbs that we collect in the countryside. The herbs are collected and dried, then the leaves are separated from the stalks and passed through a coffee grinder to give a usable, heavy-grained powder.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main ParaOverride-7"
  }, [_vm._v("Our mixture is:")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("2 tbsp thyme")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("1 tbsp sage")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("1 tbsp rosemary")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("5 bay leaves")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("½ tbsp ")]), _vm._v("savoury")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("½ tbsp marjoram")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("We also refer to two Indian spice mixtures. We make these ourselves.")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Garam Masala: Made with cumin, coriander, fenugreek, mustard, turmeric and gloves. Without chilli powder.")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Garam Masala with chilli: the same ingredients, but we add chilli.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Saffron is a crocus plant that produces red pistils and is used to colour and perfume dishes. False saffron comes from a flower called safflower, which gives a red flower, perfumes and coloured dishes. It is used as a substitute for saffron. It’s a lot cheaper, but does not have quite the same taste.\t")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("When we refer to sprouted beans, this means seeds that have been germinated.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("5.1.2 Notes on the Use of Leguminous Plants and their Cooking")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.2.1 Peas and Mangetout")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer201"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-04.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer202"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Green pea")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Green peas and mangetout are generally eaten cooked, but they are very good raw. Very young mangetout is excellent in a salad. Otherwise, they are generally cooked in water or can be cooked in a soup or dish.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Both peas and mangetout can be tinned or frozen.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Dried peas can be found in green, yellow or split forms, the last being when the pea is skinned and opened. All the dried forms are normally soaked before cooking.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Flour can be made from both green and yellow peas and is used in cooking. This is very good for people that are gluten intolerant, e.g. for pasta.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.2.2 Broad Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Broad beans are generally eaten cooked, but when young they are very good raw and in this form are very popular all around the Mediterranean. They can be cooked in their pod when young but are generally shelled before cooking, which can be done if they are to be eaten on their own or in a stew or dish.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Once dried and after soaking, they can be cooked on their own or in a dish. In Egypt, they are cooked in their skins and once cold they are skinned and used to make hummus or falafel.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Flour can be made from dry broad beans and is used in making bread. There is about 3% broad bean flour in the dough used to make traditional baguettes.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.2.3 Chickpeas")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Chickpeas are normally eaten cooked and are available dried or in pots and tinned. However, in the growing areas before harvest, they are picked like fresh peas. They can be found all around the Mediterranean and in central India, where green chickpeas are sold on markets and in the street. The green chickpea is very tasty and can be served alone or in salads or as a starter. Of course, this is not practical in Europe or the USA, as the harvesting of green chickpeas is very labour-intensive.")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer203"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-05.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer204"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Chickpea pods")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Dry chickpeas need soaking before use but today most people use either pots or tinned chickpeas. They can be used on their own or in salads or dips. They are very important to the cuisines of the Middle East, North Africa and Spain.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Chickpeas are used to make flour which is widely used in cooking. It was particularly popular in Genoa in Italy to make a popular type of pancake known as farinata. This was carried all around the Mediterranean and even to South America, where it is still present on both sides of the Rio de la Plata.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Chickpeas can be used for sprouting.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.2.4 Fresh Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Fresh beans are eaten cooked. They are available fresh almost all year round, with products coming from all over the world. They are also available frozen and canned. These beans are generally cooked in salted water, the minimum to conserve vitamins and taste.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The cocoa bean is an exception as it is harvested when the bean is developed but is not dry; this bean is shelled and cooked in water or in a soup.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Another exception is the edamame bean, which belongs to the soy species and was known in Japan as far back as the sixth century. This bean resembles the broad bean and is harvested at an immature stage, cooked in its pods in salted boiling water. When young they can be eaten with the pods on; when they are old, they will need podding. In Japan, edamame is often served as an aperitif with beer, much like the traditional lupin in Spain and Portugal.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Beans are used to produce bean sprouts, which are beans that have been allowed to sprout. The sprouting takes about seven days and gives a sprout that is more nutritious than the mother bean. Bean sprouts are used widely in cooking and salads.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.2.5 Dry Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The dry beans grow in a large variety of sizes, colours and forms; however, almost all dry beans are toxic raw, as they contain toxic alkaloids. These alkaloids are unstable, and the beans can be made nontoxic by boiling: 10 minutes in boiling water is sufficient. This does not mean the beans are cooked, however.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The dry beans are normally boiled in unsalted water, as the salt makes the boiling time longer. The beans can be boiled directly or can be soaked in advance. The soaking operation reduces the boiling time and generally gives a better product. As an example, the adzuki bean will take one and a half hours to boiling without soaking but if they are soaked for 24 hours, then the boiling time is about half an hour. Then you can cook them. The cooking time of the bean will depend on the type and on age; it is better to consult the label on the packet. The beans should be cooked slowly to avoid destroying the structure. A good simmer is ideal.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Some beans can be sprouted. This way has become very popular.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("As far as flour is concerned, it is complicated to make flour due to the alkaloids present in raw beans; flour can be made but the bean or flour must be treated thermally before it can be used.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.2.6 Lentils")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Lentils come in many varieties and different colours; they are eaten cooked in many ways. The cooking times vary according to the variety and age. With lentils the most important thing is to cook them very slowly in a minimum of water by adding water as necessary, thus avoiding the possibility that the lentils break. The lentils can be served on their own or to make salads, soups or dishes.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Typical cooking times are in minutes:")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table026"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Beluga Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("15 - 20")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Brown Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("30 - 50")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("French Puy")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("30 - 40")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Green Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("20 - 25")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Red Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("15 - 25")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Split Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("10 - 15")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Lentils can be sprouted and used alone or in a salad or in a dish.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.2.7 Traditional Lupin and Sweet Lupins")])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("Traditional Lupins")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Both European yellow lupin and South American lupin have been eaten for centuries. However, these lupin seeds contain very bitter alkaloids that have to be removed before eating.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The method of removing the bitter elements requires very long soaking and subsequent boiling to produce an edible lupin. These lupines are served as an aperitif all round the Mediterranean and particularly in Spain and in Poland.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Flour is not made from the traditional lupins because of this bitterness.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("Sweet Lupins")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Sweet lupins have been developed by genetic research. This produced lupin plants whose beans have very low bitter alkaloid content. This work started in Germany in the late 1920s and has continued worldwide. Australian agricultural workers were responsible for major development in the 1950s. Sweet lupin beans are available commercially. Sweet lupin flour and sweet lupin flakes are also now available.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Both flour and flakes can be used in cooking as a complement to other products. They’re both useful, but the flakes are about twice the price of the flour and are therefore less attractive.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The use of lupin products made from sweet lupin flour or flakes is very interesting from a dietary aspect as the lupin has is very low in calories and its use alone or mixed with other leguminous or with cereals will give a low-carb product. Typically, if you replace 30% of cereal or leguminous plants, you will reduce the carb content by about 20%, which is very interesting. In the recipes that follow we will illustrate the types of dishes that can be prepared.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("It should also be noted that lupins, like peanuts, can be dangerous for people who have tree nut allergic syndrome.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.2.8 Peanuts and Groundnuts")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Peanuts and groundnuts can be eaten raw or cooked. In Europe and the United States, they are generally eaten raw as an aperitif or snack, raw or often roasted, or ground into a paste called peanut butter. In Africa and Asia, they are eaten raw and often cooked as part of a dish.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-133",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-06.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Peanuts")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.2.9 Carob")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The carob tree is an evergreen tree originating in the Middle East that give pods similar to broad beans which become brown at maturity. Carob powder is made from the dried fruit that is used in cooking. This powder has a chocolate-type taste and contains sugar. It has the advantage of not containing caffeine. Carob powder is widely used for cakes, sweets and drinks.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.2.10 Tamarind")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The Tamarind fruit is the pod of the tamarind tree. It contains seeds and a pulp that is bitter but becomes sweeter as the fruit matures. This pulp is used to make sauces and chutney and is an ingredient in many Indian and Thai dishes.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.2.11 Mesquite Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The velvet mesquite tree gives yellow pods that contain beans. These pods and beans were part of the staple diet  for American Indians for many centuries. Today the pods are ground to produce mesquite flour, which has a much healthier value and is used to prepare, breads, desserts and cakes.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-134",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-07.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("All spices")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("B.5.1.2.12 Fenugreek")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Fenugreek is a green plant that gives perfumed grains. It is cultivated in India as a vegetable giving grains that when crushed gives a particular odour.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Fenugreek is also used as a medicinal plant. The grains can be sprouted and used in salad or to cook.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.2.13 Liquorice")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Liquorice is a leguminous plant that produces roots that contain a powerful odour. The liquorice extract is obtained by soaking the chopped roots in alcohol for a few weeks followed by filtering. The extract is used for making sweets, cakes and drinks.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.3.2.14 Rooibos")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Rooibos is a shrub that grows in the Cape of South Africa and its dried leaves are used to make a tea that has the advantage of not containing caffeine. Very popular today.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.3.2.15 False Acacia")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The flower of false acacias is used to make beignets all over the world.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.3.2.16 Mimosa")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The mimosa flowers are used to make beignets, while individual flower balls are crystallised to decorate cakes.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("5.1.3 Use of Leguminous Derived Products")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("There exist many leguminous plant-derived products. The following text gives a brief description of their uses. There are few houses or flats around the world where there is not a bottle and or pot of a product containing soy sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.3.1 Leguminous Flours and Flakes")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Many of the leguminous grain or pods are used as flours or flakes:")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "Bullet-list-first"
  }, [_vm._v("Green or yellow pea flour")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Chickpea flour")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Soybean flour")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Lentil flour")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Lupin flour or flakes")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Carob powder or flour")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Mesquite ground or flour")])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.3.2 Soy Milk")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer207"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-08.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer208"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Soybeans")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a milk substitute made from dried soya beans, ground with water. It has been known from the Han dynasty 200 BC-50 AD. It can be used as a substitute for cow’s milk and is very important in Asia. Soy milk can be used alone as the replacement for dairy milk or to make other hot drinks or in cooking.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.3.3 Soy Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Soy generally is made by emulsifying soy milk with an oil and often sugar or syrup and flour or thickener. It can be used alone or in cooking like dairy cream.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.3.4 Soy Yoghurt")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Soy yoghurt is made by fermenting soy milk in a similar way to dairy yoghurt using the same type of starter; in fact, you can make soy yoghurt by using a pot of dairy yoghurt as a starter, as in the case of dairy yoghurt. The small amount of dairy contents disappear quickly.")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer209"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-09.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer210"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Soybean paste")])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.3.5 Fermented Soybean Paste")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("This is a fermentation of ground soybeans in brine to give a salty paste. It is widely used in Asiatic cooking. Its origin is in about the 1300s in China. Each country or each area has their own particular method of making bean paste.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-135",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-10.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Tofu")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.3.6 Tofu")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Tofu is a form of curdled soy milk that has a soft cheese-like texture and is used after treatment to dry or to season to give a diversity of different products.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.3.7 Soy Sauce")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer212"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-11.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer213"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Soy sauce")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Soy sauce is made by fermentation of ground soybeans in a brine solution. It probably originated in China between 900 and 1100 AD. It is very widely used in Asia and today all over the world. It is available in many forms: light, heavy and thick or with other tastes such as oyster or mushrooms when the fermentation is carried out.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.3.8 Miso")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Miso originated in Japan and is a fermentation of soybean mixed with double the quantity of either rice or barley. Its colour ranges from milky coffee to chocolate. It is widely used in Asian cookery.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.3.9 Soybean Oil")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Soybean oil is extracted from the soybeans. This is done by crushing the beans and adjusting the humidity, followed by pressing and then removing the oil with hexane. The result is a liquid that is distilled and refined to give the pure oil. Soybean oil is one of the most used oils in cooking. It can be converted into a margarine-type cooking medium. It can also be used as biodiesel and for many industrial applications.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.3.10 Soybean Meal")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Soybean meal is the residue after oil extraction and is a very rich food for animals. It is heated and treated to remove any inhibitors that could interfere with protein digestion.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.3.11 Adzuki Bean Sweet Paste")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("This is a sweet, jam-like paste made from adzuki beans and is widely used in Asia to make bread and cakes.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.3.12 Cellophane Noodles")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer214"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-12.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer215"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Cellophane noodles")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Cellophane or glass noodles are starch noodles. In China, they can be made from mung beans.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.3.13 Guar Gum")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Guar gum is extracted from the guar or cluster bean by grinding and washing with water. The gum itself after refining is a half-white, free-flowing powder and is used widely in the food industry as a thickener and in many industrial applications.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.3.14 Carob Chips/Powder")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Carob chips and powder are made by roasting the carob and pulp and then grinding into chips or powder. Carob has the appearance of chocolate and is used as a substitute; however, the carob does not contain chocolate but another chocolate-like flavour and a sugar substitute, and is used to make types of sweets and biscuits. The carob has the advantage of not containing caffeine and is widely used in the alimentary industry as an additive.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.3.15 Mesquite Powder")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Mesquite powder exists all over Central and Southern America and the Southern parts of the USA. The powder resembles the carob powder but comes from different parts. The taste and use are different. The powder can be used as a sweetener. In other areas, it is used in tortillas.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.3.16 Tamarind Paste")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer216"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-13.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer217"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Tamarind")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Tamarind paste is made from the pulp of the unripe tamarind pod and is generally sold in the form of cakes. It is used in cooking and in the preparation of chutneys and sauces, particularly in Worcester sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.3.17 Kudzu Beans (Japonese Arrowroot)")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The kudzu bean has a very large root that contains a lot of starch. The root is dried and ground to give a powder called Japanese arrowroot that is used to replace cornflour to thicken sauces and dishes.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("5.1.4 Sprouting Grains of Leguminous Plants")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.4.1 Generalities")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer218"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-14.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer219"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Korea’s Three Kingdoms (Goguryeo, Baekje and Silla)")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space ParaOverride-14"
  }, [_vm._v("Sprouted grains of lots of different plants have become very popular worldwide. Many grains can be sprouted and are available in many shops an. At since the time of the Three Kingdoms, 57 BC to 668 AD, Korea was much bigger and included part of Manchuria, parts of the People’s Republic of China and of the Russian Federation. This period was very rich in the development of agriculture, culinary art and artisanal activities, particularly in jewellery.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Bean sprouts have been used in East Asia for centuries and are generally made from green mung beans, the larger yellow soybeans or soybeans.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Many plants can be germinated for consumpion, including cereals, crucifers, carrots and leguminous plants. The action of germination has a number of advantages: it makes the bean more nutritious, by increasing proteins, vitamins; it makes the bean easier to cook; and gives a different taste. For instance, wheat grains do not contain vitamin C but the sprouted wheat grain does.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The leguminous plants have a very important place in the sprouted grains. The following leguminous plants can be sprouted: peas, chickpeas, mung, soy, adzuki and kidney beans, lentils and fenugreek, as well as two forage plants, clover and alfalfa.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-136",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-15.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-137",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-16.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tSprouting mung beans\tSprouted soybeans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Sprouted vegetable grains can be eaten raw, in a salad, stir-fried or in a dish. Today they are available everywhere and even tinned in lots of stores.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.4.2 Method of Sprouting Grains")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The principle of sprouting is to soak the grains for a certain length of time, followed by keeping the grains warm and allowing germination to continue. This takes about two to seven days, in the dark.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Special equipment exists for sprouting but it can be done simply with ordinary kitchen equipment.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The following description is for soybeans and is representative of the process, but for smaller or larger grains the times will vary.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The following is a detailed description of the sprouting process:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Numbered-list-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Before starting, the grains should be stored for 24 hours in the refrigerator. This is to stimulate sprouting.")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("The grains should be sorted to eliminate any debris or damaged grains and then washed again carefully in clean water. Wash the grains to eliminate any residues.")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Place the grain in a bowl, cover with cold water and soak for the indicated time on the packet. Should this be for more than 12 hours, the grains should be washed after 10 hours.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The next stages are carried out in a germination container as shown in the following photograph.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-138",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-17.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Germination container")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Numbered-list-spaice",
    attrs: {
      "value": "4"
    }
  }, [_vm._v("The rinsed beans are placed in a layer on the wet paper towel. The germinator is covered with a black cloth and a towel. Then you leave it for 24 hours.")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("In the next stage, the germinator is opened and the beans are washed and returned to the clean pot and covered with the cloth and left to cool.")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("The next day the operation is repeated and continued for six days. This will depend on the type of seeds you use.")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("The sprouted beans are washed, and the sprouts removed carefully and sorted.")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("The sprouts are ready for use and can be stored for up to four days in the refrigerator.")])]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-139",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-18.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Picture showing how beans are grown in soil")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("5.1.5 New Nutritional Values, Diet and Health")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.5.1\tNutritional Values")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Leguminous vegetables and derivatives of plants and trees have been consumed and used both for human and animal food from the earliest times, peas, broad beans, chickpeas and lentils were available over most of the world except The Americas. In Europe, beans came after the discovery of The Americas. Today, the leguminous vegetables are one of the principal foods used worldwide. They are particularly interesting as a source of vegetable proteins and thus interesting for vegans and vegetarian people. In some countries like India where the population is largely vegetarian, leguminous vegetables with rice, millet or wheat are the principal food.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Leguminous plants are rich in protein, vitamins and minerals and are gluten-free. The following tables give the nutritional value of:")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("5.1.5. Table 4: Leguminous vegetables")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table027"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('thead', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Product")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Carbs")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Fat")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Protein")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Water")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table",
    attrs: {
      "colspan": "5"
    }
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Weight in grams per 100g of product")])])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Green Peas")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("14.8")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("0.4")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("5.4")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("79.8")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Dry Green Peas")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("60.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("1.9")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("25.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("13.0")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Mangetout")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("18.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("0.7")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("8.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("73.0")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Chickpeas")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("61.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("6.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("19.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("13.0")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Green Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("17.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("0.1")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("4.3")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("90.0")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Dry Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("63.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("1.8")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("21.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("1.9")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("63.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("1.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("24.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("32.0")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Lupins")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("13.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("12.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("43.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("32.0")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Peanuts")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("16.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("49.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("26.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("0.0")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("5.15. Table 5: The nutritional value of soybean-derived products")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table028"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('thead', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Product")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Carbs")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Fat")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Protein")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Water")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table",
    attrs: {
      "colspan": "5"
    }
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Weight in grams per 100g of product")])])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Soy Oil")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("0.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("100.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("0.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("0.0")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Soy Meal")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("40.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("2.4")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("46.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("11.6")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Soy Milk")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("6.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("1.6")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("3.3")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("89.0")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Tofu")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("1.9")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("4.8")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("8.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("85.3")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Soy Sauce")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("4.9")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("0.6")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("8.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("86.9")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("5.1.5. Table 6: The nutritional value of common foods")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table029"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('thead', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Product")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Carbs")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Fat")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Protein")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Water")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table",
    attrs: {
      "colspan": "5"
    }
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Weight in grams per 100g of product")])])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Dairy Milk")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("4.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("4.1")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("3.2")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("88.6")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("White Rice")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("80.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("0.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("7.4")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("12.6")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Wheat")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("71.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("1.5")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("12.6")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("18.9")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Maize")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("18.7")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("1.3")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("3.2")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("77.8")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Millett")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("72.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("4.3")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("11.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("13.7")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Potatoes")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("17.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("0.1")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("2.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("80.9")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Beef")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("0.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("16.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("26.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("37.0")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Chicken")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("0.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("6.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("25.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("69.0")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("Please note that these figures are indicative and if required for any serious work should be confirmed, as the real value can vary widely depending on the variety, the type of soil, the geographic location and the climate.")])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.5.2 Toxicity")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Most raw beans are toxic as they contain bitter molecules. These molecules are alkaloids, which are thermolabile so can be destroyed by heating. Dry or soaked beans need to be cooked in boiling water for at least 10 minutes. There have been accidents in which people have died after eating falafel made with beans that have not been sufficiently cooked.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Raw lupins cannot be eaten uncooked and require soaking for a long time; they then need to be cooked to remove the bitter taste. Today sweet lupins are available but still require cooking.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.5.3 Gluten")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Leguminous vegetables and derivatives are interesting for people with gluten problems since they contain no gluten. Derived leguminous products can be used in the place of gluten-containing foods. Some examples given in our book include: ")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "Bullet-list-first"
  }, [_vm._v("Green pea flour for making pasta")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Chickpea flour with maize for making polenta")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Lupin flour and flakes can be used for making bread cake")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Chickpea fries or socca")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Soy milk")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Tofu.")])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.5.4 Dietary Considerations")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Leguminous vegetables are free from gluten but they have a fairly low carbohydrate content and are useful for low-carb foods.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Chickpeas have been used for centuries around the Mediterranean to prepare street food and substantial meal bases. The often part-cooked chickpeas or dry beans are mixed with oil and water to make the famous falafel. In the more western parts, chickpea flour is mixed with water and used to make la farinata in Italy, which moved around the Genovese sailors to become socca in France and North Africa. In the south of France and particularly in Marseille, there is a street food called panisse. The chickpea flour is cooked in salted water, then poured into a mould, then left to cool. Once cold, it can be removed from the mould, then cut into chip shapes, and fried and sold like chips. It has a good taste and fewer carbs than French fries.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.5.5 Dairy Milk Intolerance")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("People who are intolerant to dairy milk can use soy milk for drinking or for making bread, cakes and desserts. Today soy milk is available everywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.5.6 Chocolate Intolerance")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("This intolerance can be solved by using carob powder or carob flour. In case of lactose sensitivity, a milk chocolate substitute can be made using soy milk and carob.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.5.7 Allergy")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Peanuts are well known to be allergic to certain people. Lupin is also known to be allergic. These two products have derived products that should be avoided by allergy sufferers.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.5.8 Animal Food")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The use of leguminous products and derived products is very important. The production of soy oil leaves a very rich residue that has changed cattle feeding worldwide. Leguminous grains like chickpeas, lentils and lupin now take a large part of the protein source in dog and cat food.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("5.1.6 Evolution of the Use of Leguminous Grains and Gluten-Free Food")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("1. Human Food")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("In the past 10-20 years, the use of leguminous plants in Europe and America has changed, partly because of the increased intolerance to gluten and the increase of vegetarian or vegan ways of eating. Generally, most people have a more sedentary way of living, which means we burn fewer calories, bringing about an overweight population. This is a big problem all over the world. Generally, the use of vegetable protein and a reduction of carbohydrates can be helped by eating leguminous products that are free of gluten, are rich in vegetable protein and have a lower carbohydrate content than cereals or potatoes.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In India, for centuries, leguminous plants are one of the staple parts of food because most Indians are vegetarian and their basic food is rice and leguminous foods, which gives a very well-balanced diet.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("What we have seen is a replacement of cereals by leguminous products in our traditional foods. This means the replacement of cereals in pasta, breads and cakes. This is not totally new; for example, chickpea flour has been used for a very long time to make poppadums, a type of non-leavened bread. In Italy, chickpea flour was used to make socca, panisse and pudding and these foods spread all over the Mediterranean and even to South America.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("We will review very briefly the general position today:")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("Galette and Pancakes")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("These products can be made easily with the most leguminous flours.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("Fresh Paste")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Most leguminous flours can be used alone or combined with wheat bread flour. The method is more or less the same as with flour and eggs.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("Dried Pasta")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The leguminous flours can be used alone or cut with durum wheat flour.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-140",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-19.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-141",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-20.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tFresh green pea pasta\tCoral lentils penne")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("Breads and Bread Dough")])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-5"
  }, [_c('span', {
    staticClass: "CharOverride-13"
  }, [_vm._v("Unleavened Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Unleavened bread can be made with a lot of leguminous flours. Typically in India, unleavened bread is made from chickpeas, lentils or other leguminous flours. This can be also mixed with wheat flour or other flours. So, there is a choice of gluten-free or low gluten.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-5"
  }, [_vm._v("Leavened Bread")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("In the case of leavened bread, the case is a little more difficult, as if the bread needs to be leavened by yeast it will need gluten to rise, so in general yeast-leavened breads are low gluten made with a mixture of wheat or other gluten-containing flour and a leguminous flour or cooked seed. In general, for leavening and physical consistency it is important to keep to a little more than 50% cereal flour.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The other alternative is to use baking power to raise the dough and, in this case, it is possible to have only leguminous flour or products and obtain a gluten-free bread or dough.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In the majority of cases, it is difficult to obtain a good consistency, but this can be corrected by using products like cassava or arrowroot.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-142",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-21.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Lupin cake")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("2. Animal Food")])]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-143",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-22.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Typical soy meal for cattle")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The leguminous forage plants, lucerne, vetch and clover, have been used for thousands of years to feed livestock; however, they are out of context here. Soy meal derived from the production of soy oil is very rich and has taken a very large place in dairy and beef production. The leguminous grains, chickpea, beans, lentils and lupin have taken an important place in dog and cat food.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-144",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-23.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Cat or dog food")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer369"
    }
  }, [_c('p', {
    staticClass: "Chapter-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor048"
    }
  }), _vm._v("Chapter 6\tIndex for Recipes")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-1-first"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor049"
    }
  }), _vm._v("6.1 Soup and Consommé Recipes")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2-first"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor050"
    }
  }), _vm._v("6.1.1 Pea and Mangetout Soups")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor051"
    }
  }), _vm._v("6.1.1.1 Green Pea Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-145",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-001.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("600 g Shelled peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Shallot")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Leek")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("800 ml Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("30 g Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Bunch of mint")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cut the shallot and leek finely and fry in butter in a large saucepan until soft.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add salt and pepper, add the peas and the chopped mint. Keep some of the mint back to sprinkle on the soup before serving. Cover with the stock, bring to a boil and simmer slowly until the peas are soft. Cook for about 10 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Allow to cool and pass through the blender.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Reheat and check the seasoning before serving. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor052"
    }
  }), _vm._v("6.1.1.2 Green Pea and Shrimp Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-146",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-002.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Green peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Shallots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 ml White wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Masala without chilli")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l  Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Dried shrimps")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the dried shrimps for about 20 minutes and then boil for 10 minutes and drain. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop the shallots and garlic finely.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a saucepan, heat olive oil on medium heat and add shallots and garlic. Cook chopped shallots until soft. Add the white wine.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When the wine has evaporated, add the chicken stock. Bring to a boil, then add peas and masala. Simmer for 10 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Allow the peas to cool and then pass in the blender to obtain the required consistency. Return to the saucepan, heat and add the shrimps before serving. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor053"
    }
  }), _vm._v("6.1.1.3 Split Pea Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Split peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Pork shanks")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Large onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium carrots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Bunch parsley")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Ground pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel the onion and carrots, chop the onions and dice the carrots. Peel and crush the garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the peas and water in a heavy saucepan, bring to the boil and cook for 2 minutes. Remove from the heat, cover and leave for 1 hour.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the two pork shanks, chopped onion, garlic, ground pepper and vegetable stock to cover, then simmer for 11/2 hours, or until the peas are tender.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Remove the pork bones and allow to cool. Trim off the fat and discard. Remove the meat and cut into small pieces.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Return meat to the pan with the diced carrot. Check seasoning and simmer for ½ hour or until the carrots are tender. Sprinkle with parsley and serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor054"
    }
  }), _vm._v("6.1.1.4 Mangetout Soup with Garlic Bread")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("650 g Mangetout")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Small turnips")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Large onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1.2 l Vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Handful mint")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Slices of wholemeal bread")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Remove the ends and string from the mangetout, cut the onion, cut the turnip into small pieces, chop the mint leaves.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the vegetable stock into a large saucepan, add mangetout, onion, turnip and mint. Bring to the boil and simmer for 15-20 minutes until the vegetables are soft.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cool and adjust the seasoning, pass through the blender to obtain a smooth texture.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel the garlic, toast the bread and when cold rub both sides with garlic and cut into small squares.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve the soup sprinkled with garlic bread.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_vm._v("6.1.1.5 "), _c('a', {
    attrs: {
      "id": "_idTextAnchor055"
    }
  }), _vm._v("Pease Pudding")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer232"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-003.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is an interesting dish that comes from very early times. It was very popular in medieval times and comes from the earliest human civilizations of hunter-gatherers. It is made from marrowfat peas that are green or yellow peas that have been allowed to mature and dry on the plant and then harvested. Once harvested, they can be used directly or be milled or rolled to give split peas.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Pease pudding is the subject of a nursery rhyme:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Pease porridge hot, pease porridge cold,")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Pease porridge in the pot, nine days old;")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Some like it hot, some like it cold,")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Some like it in the pot, nine days old.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("(Songwriter(s) Unknown.)")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor056"
    }
  }), _vm._v("Making Pease Pudding")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This dish can be made with either green or yellow split peas.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Split peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Chopped mint")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Chopped parsley")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Chopped marjoram")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the peas for 8-12 hours.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Drain and wash the peas, cover with water and cook for a least 1 hour or until the peas are soft.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Drain the peas and place in a bowl. Add a bit of water, mint, parsley, marjoram, half of the butter and the other ingredients and blend to obtain a smooth paste. To control the consistency, add more butter or water to obtain the consistency desired.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve with boiled meat and bread. When used on its own, it can be served with a dollop of fresh cream. Season to taste.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor057"
    }
  }), _vm._v("6.1.2 Broad Bean Soups")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor058"
    }
  }), _vm._v("6.1.2.1 Broad Bean Soup with Harissa")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-147",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-004.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Harissa")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("800 g Shelled broad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("600 ml Lamb stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Spring onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Lemon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cumin powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Harissa")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop spring onions and garlic. In a saucepan add olive oil and heat. When hot, add onions and garlic. When they start to soften, add the cumin powder, lamb stock and broad beans. Cook for about 10 minutes. Check to see if the broad beans are cooked.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve in bowls with harissa and lemon quarters as an accompaniment.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.1.2."), _c('a', {
    attrs: {
      "id": "_idTextAnchor059"
    }
  }), _vm._v("2 Dry Broad Beans with Lamb Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200 g Dried broad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Lean lamb")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Ground paprika")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Bay leaves")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ l Vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the beans overnight, drain and place the beans in a saucepan cover with water, add salt and peppers, 1 tbsp olive oil, bay leaves and simmer until the skins can be removed. Drain and remove the skins.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop onions and garlic. Slice lambs into strips. Heat a saucepan, adding olive oil, and fry the onions and garlic until they start to soften. Then add lambs, paprika and herbes de Provence. Seal the lamb then add the beans, then add enough stock to cover the lamb and broad beans.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook for a further 10 minutes. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor060"
    }
  }), _vm._v("6.1.2.3 Cream of Broad Bean Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("2 kg Broad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 g Smoked ham")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer234"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-005.jpg"
    }
  })])]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Remove the broad beans from their shells and the light green skin.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop the onions.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the olive oil in a heavy saucepan, and cook the onions without colouring them. Once soft, add the beans and the herbes de Provence. Cook for 1 minute and add the stock. Cook for about 30 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Chop the smoked ham into small squares and roast in a dry pan until coloured. Dry on absorbent paper.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Mix the liquid and sieve. Reheat and serve in bowls sprinkled with the smoked ham. Season to taste.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor061"
    }
  }), _vm._v("6.1.2.4 Broad Bean and Potato Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 kg Shelled Broad beans. (If using old broad beans remove the outer skin.)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Salted pork belly")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Ground sumac")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 bunch of fresh coriander")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and paprika")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer235"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-006.jpg"
    }
  })])]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Blanch the beans in boiling salted water for 3 minutes and cool in cold water. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and cut potatoes into squares.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel the onions and garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the pork into thin strips.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the oil in a saucepan, add onions and simmer. When soft, add garlic and pork and cook for 2 minutes. Add beans, herbes de Provence and sumac. Heat and turn for 2 minutes, add stock, potatoes and simmer for 30 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Check the salt and add if necessary.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Chop the coriander.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve in bowls and sprinkle with coriander and paprika.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor062"
    }
  }), _vm._v("6.1.2.5 Broad Bean and Courgette Soup")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer236"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-007.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Shelled broad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium courgettes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 ml Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Coriander powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 Single cream")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Slices of bread")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop the onions, cut courgettes into slices.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat oil in a saucepan, cook the onions. When they start to soften, add courgettes, herbes de Provence and coriander powder. Cook for 5 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the broad beans, cover with the stock. Cook until soft then add the cream, keeping a little back. Salt and pepper to taste. Cook for a few more minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Toast the bread then cut into little squares.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve in bowls pour and little of the cream in each bowl. Sprinkle the squares of toast over the top. Serve warm.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.1.2.6"), _c('a', {
    attrs: {
      "id": "_idTextAnchor063"
    }
  }), _vm._v(" Broad Beans with Red Peppers and Rice Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Shelled broad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Red peppers")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 g Long grain rice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Paprika")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 Slices of bread")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Clean and de-seed peppers then cut into strips. Peel the garlic. Pre-heat oven 180°C. Roast red peppers in the oven for about 20 minutes, until a bit crispy.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a large saucepan add water, 3 times the volume of rice, add salt. Bring to the boil then add the rice and paprika. Cook for 10 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the shelled broad beans and roasted peppers to the rice. If necessary, add a bit more water. Cook for a further 5 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Toast the bread. When toasted, rub with garlic, then cut into four.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve in bowls with garlic toast.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.1.2.7 Cream of Broad"), _c('a', {
    attrs: {
      "id": "_idTextAnchor064"
    }
  }), _vm._v(" Bean Pod Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-148",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-008.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is an interesting recipe as it shows the use of broad bean pods that generally go into the bin or compost.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("20 Broad bean pods (very young pods)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Small new potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6-8 Mint leaves")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash the pods, remove the string and cut into small pieces. Peel and crush the garlic. Place the broad bean pods in a saucepan covered with water. Add garlic and olive oil. Bring to the boil and simmer for about 5 minutes. Drain and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Scrub the potatoes and cut them into small pieces. Put the potatoes in a saucepan cover with water, add mint. Cook for 15 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Drain the potatoes. Make sure you keep back some of the liquid. Then mix the potatoes and beans together. Season to taste, serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor065"
    }
  }), _vm._v("6.1.2.8 Syrian Foul Soup with Dried Fava Beans (Broad Beans)")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 kg Dried broad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 ml Vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Ground cumin")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Ground ginger")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Cloves garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 ml Lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 ml Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium red onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium ripe tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Small bunch of parsley")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 Pita breads")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper to taste")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak dried broad beans overnight. Then drain and rinse.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop onion and garlic. Cut the tomato into cubes, chop parsley.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat a frying pan. When hot, add the onions and garlic. When the onions are soft, add the tomatoes and cook for 5 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the beans in a heavy pan and cover with the vegetable stock.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add garlic, ginger, cumin, salt and pepper and bring to a boil. Then add the onions and tomato mixture.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("With a potato masher, partly break the beans and cook over medium heat for 10 minutes. Then add the lemon juice. Serve hot with Pita bread.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Note: Today this soup is often made with other beans as the preparation of the dried broad beans is long, but worthwhile. Typically, the soup can be made with a mixture of canned broad beans and kidney beans. It should be noted that dried broad beans are very popular all over the Middle East and particularly in Egypt where they are used to make hummus and falafel, in place of chickpeas.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-149",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-009.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor066"
    }
  }), _vm._v("6.1.3 Chickpea Soups")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor067"
    }
  }), _vm._v("6.1.3.1 North African Chickpea Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Large ripe tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Sticks celery")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("600 ml Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("400 g Cooked chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Harissa")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cumin Powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Bunch of fresh coriander")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Juice of 1 lemon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Flatbreads")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop the onions and garlic. Cut the celery and tomatoes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the oil in a saucepan. Cook the onion, garlic and celery until the onions are soft. Add the chopped tomatoes, herbes de Provence, cumin and harissa. Add half the stock and cook for about 10 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add salt and pepper to adjust the seasoning. Add the rest of the stock and the chickpeas. Cook for another 10 minutes. Serve hot, with a sliver of lemon juice and with Arab-type flatbread. Sprinkle with coriander.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("N.B. Harissa is a spicy paste made from red pimento mixed with cumin and coriander. It comes from North Africa and is very popular for couscous and other dishes.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("N.B. Arab flatbread is a yeast-based bread paste with olive oil and a mixture of flour and fine couscous. After raising it is rolled onto a cake type rounds about 1 cm thick and cooked in an iron pan.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-150",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-010.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Flatbread")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor068"
    }
  }), _vm._v("6.1.3.2 Chickpea Soap Served with Spare Ribs")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This cheap and easy soup is very popular in Southern Italy where it is generally prepared with the local black chickpeas.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("800 g Lean spare ribs, separated")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Branches of celery")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium carrots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Tomato Confit")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1.5 l Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1.2 kg Pre-cooked chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ Hot red pimento")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Basil leaves")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and freshly ground pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and cut the carrots into chunks, then cut the celery into chunks.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the olive oil into a large saucepan and heat. When it’s ready, add the spare ribs. Cook on both sides until well brown.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the chicken stock, carrots and celery. Bring to a boil and simmer for 1 hour.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Remove scum and surface fat.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the drained chickpeas, the sliced pimento and the basil. Continue cooking for 30-40 minutes. Season to taste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Season with salt and pepper and serve with olive oil.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor069"
    }
  }), _vm._v("6.1.3.3 Chickpea and Onion Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("An easy soup ideal for quick lunch on a winter sports holiday.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 kg Large onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("800 g Precooked chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Cloves garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Masala with pimento")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Tomato paste")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 ml White wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Dried breadcrumbs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Grated cheese")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 lemon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and cut the onions into thin slices, peel garlic and crush. In a saucepan add oil and heat. Cook until the onions are soft then add the crushed garlic, herbes de Provence, Masala and tomato paste. Add the white wine, stir and cook for 5 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add salt and pepper to the washed and drained chickpea, cover with water and bring to the boil. Check the seasoning and pour into soup bowls. Cover with breadcrumbs and grated cheese, then put under the grill for 10 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve with a squeeze of lemon.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor070"
    }
  }), _vm._v("6.1.3.4 Mexican Chickpea Soup")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer240"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-011.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is an amusing dish with the fried egg put into the soup at the last minute.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("4 tbsp Vegetable oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Chopped mint")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("750 ml Beef stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Dried chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 Eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the chickpeas in cold water for 24 hours, drain and rinse well. Cook them in water until soft, for about 1 hour. Drain and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel onions and garlic, then chop them.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put 2 tbsp of oil in a saucepan. When hot, add the chopped onion, garlic and mint. Cook until the onion is soft, put through the blender with 250 ml stock, and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the cooked chickpeas through the blender with 300 ml of water.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the two mixtures into a pan, add salt and pepper to taste. Add the rest of the stock and mix together for about 5 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Fry the eggs in the remaining oil.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("To serve, pour the soup into the bowls and slide a fried egg into each bowl. Serve warm.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor071"
    }
  }), _vm._v("6.1.3.5 Chickpea Soup for Good Thursday")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In several Catholic countries, it is the tradition to ‘eat lean’ on the eve of and on Good Friday. Generally, meat is replaced by chickpeas. This soup is very popular all over Italy and in Corsica.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Dried chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Cloves garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Coriander powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Slices of toast")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak chickpeas overnight. Drain the chickpeas, rubbing the chickpeas between your fingers to remove as much of the skin as you can. Peel and crush the garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the chickpeas in boiling salted water, adding garlic, oil, coriander and herbes de Provence. Cook for 20-25 minutes. Season to taste with salt and pepper.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve in bowls with toast. (It used to be served with stale bread.)")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor072"
    }
  }), _vm._v("6.1.4 Fresh Bean Soups")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Fresh bean soups can be made with young green, yellow or black beans or with mature but not dried beans like fresh flageolet beans or coco beans. In the case of young beans, they can be served just boiled, in which case, as for green peas, they should be boiled at a  minimum to conserve consistency, taste and vitamins. On the other hand, mature beans, whet fresh or dried, often contain toxic constituents which are thermolabile and can be destroyed by cooking; for this reason, mature beans should be cooked for a minimum of 10 minutes before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor073"
    }
  }), _vm._v("6.1.4.1 Green Beans Fresh Dill Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 8 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("750 g Green beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("5 Large Potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 ml Chopped fresh dill")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 ml Skimmed milk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Large white onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Sour cream or yoghurt")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-151",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-012.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Remove the string and ends from the beans and cut them into 2 cm lengths, peel the potatoes and cut into cubes, peel the onions and garlic then chop.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cover the potatoes with water and boil until they are soft. Remove half and mash with a fork and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Take a heavy-bottomed pan, heat the oil and cook sliced onions and crushed garlic until they start to soften. Cook for a further 4-5 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add onions, garlic and beans to the potatoes. Salt and cook until the beans start to soften (about 10 minutes), reduce the heat add the milk and the mashed potatoes with the chopped dill. Check seasoning.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve in hot bowls with ½ tbsp of sour cream or yoghurt on top of the soup.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor074"
    }
  }), _vm._v("6.1.4.2 Fresh Shelled Beans Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("600 g Shelled fresh coco beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium carrot")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Stick of celery")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Salted pork belly")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Ground cumin")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel the onions, carrot and garlic. Slice the onions, crush the garlic and dice the carrots. Chop the celery into slices. Slice finely the salted pork belly.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Take a heavy-bottomed saucepan and heat the oil. Fry the chopped onions and pork until soft. Add chopped garlic and diced carrot. Cook for 5 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the herbes de Provence, ground cumin, coco beans and the celery. Simmer slowly until the beans are cooked; the time will depend on the freshness of the beans.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Check the seasoning and serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor075"
    }
  }), _vm._v("6.1.4.3 Fresh Flageolet Bean Soup")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer242"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-013.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Fresh flageolet beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium leek")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Celery branch")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1.5 l Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Fresh single cream")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g slices of salted pork belly")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Grated hard cheese")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel onions, potatoes. Slice the onions and cut the potatoes into cubes. Chop the celery and leek finely.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a heavy pan, heat the oil. When it’s hot, add the onions and leek. Cook for 5 minutes. Then add the beans, potatoes, celery and stock. Cook slowly for 1 hour. Check seasoning.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the pork belly in a dry pan until well browned.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Mix the soup, add the cooked pork. Cook for another 5 minutes, then add the cream. Serve hot and sprinkle with the grated cheese.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor076"
    }
  }), _vm._v("6.1.4.4 Pesto Soup with Pesto Sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-152",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-014.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a late-summer autumn soup that originated in Genoa and was carried from over to the Mediterranean by Genoese sailors and traders. Since that time, the recipes have evolved; at the present time, the pesto in Genoa, Nice or Marseilles are much the same, but each is different, so today there is no real pesto soup. We will give a typical recipe.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients (for 8 people) for the soup:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200 g Lean salted lard")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("800 g Fresh green beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Fresh white coco beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 g Fresh red coco beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Medium potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2  Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Medium carrots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium courgettes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Leeks")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1.5-2 l Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for the pesto sauce:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("Large bunch of basil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Pine nuts")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cut the lard into thin strips about 2 cm long.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and dice the onions, potatoes and carrots. Cut the onions, potatoes and carrots into squares. Clean courgettes and leeks and then slice them. Shell the white and red coco beans. Cut fresh beans into about 2 cm slices.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put all the prepared ingredients into a heavy saucepan cover with water. Add salt and pepper and bring to the boil and cook for 30 minutes. Check the cooking: if sufficient, set aside; if not, cook a little more")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("For the pesto sauce, coarsely chop the basil with the stalks left on. Peel the garlic. Place the chopped basil, garlic, pine nuts and pepper and salt into a blender. Blend and gradually add the olive oil to obtain a nice texture. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve the soup in bowls and put a spoon of the pesto sauce on top.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor077"
    }
  }), _vm._v("6.1.5 Dry Bean Soups")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor078"
    }
  }), _vm._v("6.1.5.1 White Bean and Red Pepper Soup")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer244"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-015.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Dried white beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Red peppers")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Bay leaf")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Paprika powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("800 ml Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the bean for 24 hours in cold water. Drain and rinse well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop onions, clean de-seed peppers and cut into small squares. Peel and crush the garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pour the oil into a heavy strong pan. When hot, add the onions and cook until soft. Add the peppers and cook while stirring for 5 minutes. Add the chicken stock, drained beans, bay leaf, herbes de Provence and spices. Bring to the boil and cook for about 40 minutes. Check cooking.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("If the beans are cooked, remove bay, add garlic and paprika. Check seasoning and serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.1.5.2 Black"), _c('a', {
    attrs: {
      "id": "_idTextAnchor079"
    }
  }), _vm._v(" Beans and Mushroom Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Tinned black beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Spinach")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Boletus")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Red pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("800 ml Vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop onions and garlic. Clean and de-seed red pepper and slice into small sticks. Cut the mushrooms into slices. Wash the spinach, drain and cut finely.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a large saucepan, add olive oil. Cook the onions and garlic until they start to soften, then add the red peppers, herbes de Provence and cook for a further 2 minutes. Then add the sliced mushrooms. When they are cooked, add black beans and spinach. Cover with the stock. Bring to the boil. Cook for a further 15 minutes. Make sure the black beans are warm.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Season to taste serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.1.5.3 Cream"), _c('a', {
    attrs: {
      "id": "_idTextAnchor080"
    }
  }), _vm._v(" of White Bean and Boletus Soup")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer245"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-016.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200 g Dry white beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Boletus mushrooms")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 ml Vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 ml Double cream")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Grated Pecorino cheese")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Mace powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Chopped parsley")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the white beans overnight. Drain and rinse well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop onions. Clean boletus and cut them into slices.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the white beans in a saucepan, add salted water. Bring to a boil and simmer for 10 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a frying pan, heat olive oil and cook the onions. When they start to soften, add the boletus and mace powder. Cook until the mushrooms are nice and brown.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Drain the white beans and return them to the saucepan, then add the cooked onions and mushroom. Cover with the vegetable stock. Season to taste cook for a further 4 minutes. Add the cream then just heat through.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve in bowls sprinkled with the chopped parsley and grated Pecorino. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor081"
    }
  }), _vm._v("6.1.5.4 Mexican Chilli Bean Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-153",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-017.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("70 g Plain flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Chilli powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("700 ml Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Bell pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Tinned kidney bean")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop onion and garlic. Clean and slice the bell pepper.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a saucepan, add the olive oil. When it’s hot, add the onion, garlic and bell pepper. Cook until the onions are soft. Add the flour slowly, stirring all the time, till you get a smooth paste, then add the chilli powder and water.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Drain the kidney beans and wash well. Then add this to the saucepan and cover with water. Season to taste and cook for 20 minutes. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.1.5.5. Japane"), _c('a', {
    attrs: {
      "id": "_idTextAnchor082"
    }
  }), _vm._v("se Napa Cabbage and Tofu Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-154",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-018.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("For the soup")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Cooked chicken")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Cellophane noodles")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ Small Napa cabbage")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Spring onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("600 g Tofu")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("For the broth")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1.5 l Fish stock, made with dashi powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("160 ml Mirin (favoured sake)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 ml Heavy soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("60 ml Sake")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Chopped coriander and spring onions for garnish")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Press and drain tofu cut into cubes. Chop spring onions and slice Napa cabbage into thick slices.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("For the broth, combine all the ingredients in a large pan and bring to the boil. Simmer for 5 minutes, add the cellophane noodles sliced and Napa cabbage, then simmer for 5 minutes and then add cubed chicken pieces and cook for a further 2 minutes. Make sure it’s cooked through.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the tofu and spring onions in the bottom of the soup bowls and cover with the broth. Serve warm. Sprinkle with coriander and spring onions.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor083"
    }
  }), _vm._v("6.1.5.6 Bok Choy and Shrimp Soy Milk Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-149",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-019.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("100 g Bok choy")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("750 ml Soy milk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Plain flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("180 ml Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 g Dried shrimps")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Fish sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Masala with pimento")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Coriander powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak shrimps in warm water for at least ½ hour. Then drain the shrimps. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and cut onions and garlic. Wash the Bok choy and cut roughly.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a frying pan, heat of the butter. Cook the onions and garlic until they start to soften. Then add the shrimps and Bok choy. Fry for another 3 minutes, then set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a saucepan, melt the rest of the butter, gradually adding the flour. Make sure it does not go lumpy. Then add the chicken stock slowly and add soy milk, coriander powder, masala and fish sauce. Bring to the boil and simmer for 3 minutes, Season to taste with pepper (normally you should not need salt, as the fish sauce is very salty).")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add to the sauce the onions, garlic, shrimps and Bok choy. Cook for a further 2 minutes. Serve hot in bowls.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor084"
    }
  }), _vm._v("6.1.6 Lentil Soups")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-155",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-020.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor085"
    }
  }), _vm._v("6.1.6.1 Red Lentil Soup")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer250"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-021.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("800 ml Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 Coral lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium carrot")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Egg yolks")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 ml Milk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Slices of bread")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and slice the onions and carrots.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the onions in 1 tbsp butter. When cooked, add carrots, coral lentils, salt, pepper and stock, then cook for 30 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Check the cooking: if tender, pass through the blender and return to the pan.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the bread into squares and fry in the rest of the butter.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Beat the egg yolks in the milk in a bowl.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Check the seasoning of the lentils, bring to a boil, add the eggs yolk mixture, stirring all the time, and serve sprinkled with herbes de Provence and toast. Serve immediately.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_vm._v("6.1.6.2 Lentil C"), _c('a', {
    attrs: {
      "id": "_idTextAnchor086"
    }
  }), _vm._v("oconut Milk and Lemongrass Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Coral lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Tinned coconut milk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Lemongrass springs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 mm Piece of ginger")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Jasmine rice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Kaffir leaves")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Lime")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Chopped coriander")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash the coral lentils, and drain peel and chop the onion. Cut the lime in half. Squeeze the first half with the rest cut into thin slices. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a large saucepan, add the vegetable stock, then the coral, lentils and onions. Bring to the boil and simmer for about 15-20 minutes. Check the lentils are soft.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel garlic, lemongrass and ginger, slicing them into thin strips. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("While the lentils are cooking, cook the rice in boiling salted water for about 11 minutes. Drain and set aside, keeping it warm.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add to the lentils, the coconut milk, lemongrass, garlic, ginger, kaffir leaves, lime juice and sugar. Mix well and cook for a further 2 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In six bowls, place a good spoon of the rice. Then pour the lentil soup over. Garnish with the sliced lime and coriander. Serve warm.")])]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-156",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-022.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Lemongrass")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor087"
    }
  }), _vm._v("6.1.6.3 Egyptian Red "), _c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("Lentil Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 8 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium carrot")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cumin grains")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Coriander powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Chilli powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("5 Medium tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("450 g Red lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Yoghurt and Lemon for garnish")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel onions, carrots and garlic. Crush the garlic. Slice onions, carrots and tomatoes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the butter in a large saucepan and heat. When hot, add onion, carrots and garlic. Cook until soft (about 5 minutes), add cumin grains and coriander powder and cook for 3 minutes. Add tomatoes and cook until soft (about 2 minutes), add lentils and cook until soft, about 10 - 15 minutes. This does depend on the lentils. Season with salt.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve in bowls with yoghurt and lemon. Sprinkle with the chilli powder.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor088"
    }
  }), _vm._v("6.1.6.4. Lentils and Swiss Chard Soup")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer252"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-023.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Brown lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Swiss chard leaves")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium Potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Chopped fresh coriander")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Concentrated tomato")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 ml Lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 ml Vegetable oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Water")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash and check the lentils. Peel the onion, garlic and potatoes, cut the onion into fine slices, crush the garlic. Cut the potatoes into squares. Cut the chard leaves into strips.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the water into a saucepan. Add the lentils and cook until they soften, then add the chard leaves and simmer for 15 minutes. In another saucepan, cook the potatoes in boiling salted water, for about 15 minutes. Drain the potatoes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook onion, garlic, concentrated tomato and coriander and when cooked add this to the lentils, then add the potatoes. Add lemon juice and cook for another 5 minutes. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor089"
    }
  }), _vm._v("6.1.7 Lupin Soups")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor090"
    }
  }), _vm._v("6.1.7.1 Sweet Lupin Pumpkin and Sweet Potato Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Sweet lupin flakes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Large onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1.5 kg Pumpkin")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("650 g Medium sweet potato")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("350 g Medium potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1.5 l Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tsp Medium curry powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("20 cl Cream")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Grated cheese")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-157",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-024.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat oven 180°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel onions, sweet potatoes, potatoes and pumpkin. Chop them all into small pieces. Roll the vegetables in 2 tbsp of olive oil and place on a baking tray. Roast for about 40 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a saucepan, add the rest of the olive oil; when it’s hot, cook the sweet lupin flakes, stirring constantly to get a nice grilled look. Take them out of the saucepan and set them aside. Keep some cooked flakes back for decorating the soup.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a saucepan, add the chicken stock, the roasted vegetables, curry powder and lupin flakes. Season to taste. With a blender, blend the mixture to get a smooth paste. Cook for a further 3 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pour the soup into the bowls. Drizzle the cream over the soup pour a bit of cream into each bowl. Sprinkle the grated cheese over the cream and sprinkle the grilled flakes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor091"
    }
  }), _vm._v("6.1.8 Peanut Soups")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor092"
    }
  }), _vm._v("6.1.8.1 Equatorial Peanut Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-102",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-025.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("50 g Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("125 g Freshly roasted peanuts")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Large potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("750 ml Beef or chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("135 ml Fresh single cream")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and freshly ground pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Chopped chives")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop onions and potatoes. In boiling salted water, cook the potatoes for about 15 minutes. Drain and set them aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat half the butter and cook the onions until soft.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the onion and butter in the blender with the peanuts, potatoes and a little of the stock. Blend into a smooth paste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the paste into a saucepan with the rest of the stock. Stir and simmer covered for 15 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the cream, season with salt and pepper and heat until hot. Sprinkle with chives and serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor093"
    }
  }), _vm._v("6.1.8.2 Ghanaian Peanut Butter Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("2 Large onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("400 g Lean pork")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Ripe large tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("400 g Tinned tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Shallots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Creamy peanut butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 l Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Red chilli paste")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Mushrooms")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop finely the onions, garlic and shallots. Wash and slice the mushrooms.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Blanche the tomatoes in boiling water, then drain. When cold, remove the skins, chop the tomatoes and blend to a paste with the tinned tomatoes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the lean pork into small squares. Mix with garlic, shallots and onions.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the olive oil in a frying pan. When hot, add the pork and garlic, shallots and onion. Cook for about 10 minutes. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put 11/2 l of boiling water in a bowl. With a wooden spoon, carefully add the creamy peanut butter to give a creamy paste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add to the creamy paste meat, tomatoes, red chilli powder and mushrooms. Place this in a saucepan and bring to a boil, then simmer for 20 minutes and serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This soup is generally served with feta, or a cassava flour dumpling.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor094"
    }
  }), _vm._v("6.1.8.3 West African Peanut Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-158",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-026.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("800 ml Vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Leaves of Collard greens")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 tbsp Peanut butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Tin of tomato purée")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("30 g Crushed peanut")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Chilli powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop onions and garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Remove the stems from the collard greens, discard the stems, cut the leaves into 3 cm squares.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a saucepan, add 400 ml of stock, onions, garlic and salt. Simmer for 20 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the tomato purée, peanut butter, and chilli powder into a blender. Blend until smooth. Add this to the rest of the stock.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Then add the collard greens and simmer for 15 minutes. Serve in bowls with the crushed peanuts sprinkled on top.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.1.8.4 Indian P"), _c('a', {
    attrs: {
      "id": "_idTextAnchor095"
    }
  }), _vm._v("eanut Chaat")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer256"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-027.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Raw peanuts")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("¼ tsp Turmeric powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 cm Cucumber")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Ginger, chopped finely")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Green chilli")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Cumin seeds")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1/8 tsp Red chilli powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("¼ tsp Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Mango chutney")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Put the peanuts in a pan with 500 ml water and salt. Cook on medium heat for about 25 minutes until the peanuts are cooked. Drain the peanuts and allow them to cool.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Mix all the ingredients except, tomatoes, cucumber and lemon juice.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut tomatoes into four and de-seed. Cut the cucumber in thin slices.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Mix together tomatoes, cucumber and lemon juice, then add peanuts and toss with the sauce.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve cold.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor096"
    }
  }), _vm._v("6.1.10 Tamarind Soups")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor097"
    }
  }), _vm._v("6.1.10.1 Fish Soup with Tamarind")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-159",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-028.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("800 g Pollock fillets")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Small potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Tamarind paste")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1.2 l Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Place the tamarind paste in a cup and cover with warm water. Cover and set aside. This should be done at least an hour before you start cooking, if possible.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel potatoes, onion and garlic, chop onion and garlic. Cut potatoes into rounds. Cut the Pollock fillets into bite-sized pieces.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a saucepan, heat the olive oil and fry the onions and garlic until they start to soften.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add potatoes and water. Drain the tamarind; only use the water the tamarind was soaked in. Bring to the boil and cook for 15 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the pollock fillet pieces and cook for a further 8 minutes until tender.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Season to taste with salt and pepper. Add sugar. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor098"
    }
  }), _vm._v("6.1.12 Fenugreek Soups")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.1.12.1 Pumpkin Sou"), _c('a', {
    attrs: {
      "id": "_idTextAnchor099"
    }
  }), _vm._v("p with Fenugreek and Alfalfa Sprouts")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 Medium Pumpkin")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp. Fenugreek seeds")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("650 ml Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Handfuls of alfalfa sprouts")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cut the onions into thin slices. Peel the pumpkin and cut into small squares.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the oil into a pan and heat then cook the onions until softened. Add pumpkin, fenugreek seeds, salt and pepper and cook until the pumpkin is soft. Mix to the consistency required and add the alfalfa sprouts. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-160",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-029.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-1"
  }, [_vm._v("6.2 Salads, Starters"), _c('a', {
    attrs: {
      "id": "_idTextAnchor100"
    }
  }), _vm._v(", Snacks, Breads and Sauces Recipes")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2-first"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor101"
    }
  }), _vm._v("6.2.1 Peas and Mangetout")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor102"
    }
  }), _vm._v("6.2.1.1 Green Pea Salad")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Fresh peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 ml Mayonnaise")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Dijon mustard")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Grated horseradish")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Paprika, salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Blanche the peas in boiling slightly salted water for 2 minutes. Pour into cold water and drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Dry the peas and place in a salad bowl. Add the mayonnaise, Dijon mustard, horseradish and season with salt and pepper. Sprinkle with paprika and refrigerate before serving. Serve cold.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor103"
    }
  }), _vm._v("6.2.1.2 Mangetout Salad")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-161",
    attrs: {
      "alt": "C:\\Users\\Mr STRIBLING\\Desktop\\Nouveau dossier\\PIC_0344.JPG",
      "src": "image/Stribling-6-030.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 2 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Mangetout")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 tbsp Vinaigrette")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Remove ends and string from the mangetout. If very young, use as they are. If slightly hard, blanch for 2 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Dry the mangetout, add vinaigrette, mix and serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor104"
    }
  }), _vm._v("6.2.1.3 Green Pea and Bacon Salad")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer260"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-031.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people;")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Young fresh peas or frozen peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("8 Slices of lean bacon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Large red onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 tbsp Vinaigrette")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("For the frozen peas, put them into cold water and allow them to thaw. Put the defrosted peas in a saucepan and cook in boiling salted water for 5 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Fry the slices of bacon in the oil until slightly crisp. Allow them to cool. Slice the bacon finely.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Slice the onion very finely.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the peas into a salad bowl, add the bacon, onions and vinaigrette, then stir well. Check the seasoning. Be careful, as the bacon is salty.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor105"
    }
  }), _vm._v("6.2.1.4 Green Peas and Vegetable Salad")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Fresh shelled peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Medium Potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Medium Carrots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Bunch of parsley")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 tbsp Mayonnaise")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and slice the potatoes and carrots, then cook for 15 minutes in salted water: they need to be just cooked – not too soft. Drain and allow cool.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the potatoes and carrots into small cubes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Chop the parsley and mix with mayonnaise.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add all the vegetables to the mayonnaise and mix. Adjust seasoning to taste.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor106"
    }
  }), _vm._v("6.2.1.5 Mangetout, Beetroot and Orange Salad")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Mangetout")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Cooked beetroot")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Large sweet onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Orange")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cut the ends and remove the strings from the mangetout. Cook lightly in salted water for about 5 minutes: they should stay crispy. Drain and allow to cool.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel the beetroot and cut into small strips.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel the onion and slice into fine slices.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Make a sauce with salt, pepper, lemon juice and olive oil. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel the orange, separate the segments and remove the skin. Mix all the ingredients together. Serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor107"
    }
  }), _vm._v("6.2.1.6 Erbswurst German Green Pea Flour and Sausage Meat")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-162",
    attrs: {
      "alt": "C:\\Users\\Mr STRIBLING\\Desktop\\Nouveau dossier\\PIC_0344.JPG",
      "src": "image/Stribling-6-032.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Erbswurst")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a survival food developed in Germany during the French-Prussian war. The German army requested Heinrich Gruenberger to find a replacement for the pea and pork soup generally served to troops as this was messy and difficult to keep. Gruenberger came up with Erbswurst, which is a saucisson made from dried pea flour and meat. This product was adopted by the Prussian army with a lot of success. The product was later developed and sold by Knorr, a German food and drink company. It is still very popular with hikers, climbers and sailors as survival food, and is also used by householders as a snack or as a quick base to make soup or a dish. Erbswurst is easy to make at home and can be conserved for a long time in the fridge. This is a typical recipe:")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("350 g Fresh pork belly")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Pork fat")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("400 g Pea flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("18 g Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 g Pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Large onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 g Ground nutmeg")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 g Thyme")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("5 Wax paper tubes")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Slice pork belly and pork fat into 5 mm cubes. Cook slowly in a frying pan until just golden brown. Set aside. Cut onions very finely and fry in fat slowly until slightly browned.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the pork and onions together. Cook this for about 15 minutes; it must be well cooked.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the pea flour with the other ingredients, stirring continuously, till you obtain a stiff paste. Keep warm to avoid setting.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Take a wide-mouthed sausage funnel and fill the casing with the paste, using a wooden dowel to push the paste into the casing and to remove all air. Once filled, tie with string and allow to set. The casing can be artificial sausage or waxed paper tubes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This can then be kept in the fridge and used either cut into slices and served with a salad or vegetables. But it is mainly used in soups again cut into slices and put into the soup.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor108"
    }
  }), _vm._v("6.2.1.7 Fresh Pasta with Green Pea Flour")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer262"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-033.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Green pea flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Extra flour for working")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("In a bowl lightly beat the eggs. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the green pea flour and salt in a salad bowl and mix together. Gradually add the oil. Make a well in the middle of the flour and pour in the eggs. Stir gradually so that it does not go lumpy, making sure the pasta has a firm consistency.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Flour the work surface and knead the pasta to obtain an elastic ball. This must be well kneaded, or else you will have problems when you put it through the pasta machine. Then wrap it in cling film, place it in the fridge and leave it overnight.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Work the pasta by hand, or by machine if you have one, to produce tagliatelle. Keep it covered to keep the moisture, as it tends to dry out quickly.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the pasta for about 2 minutes in salted boiling water and serve with your choice of sauce.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor109"
    }
  }), _vm._v("6.2.1.8 Arancini: Rice Balls Stuffed with Bolognese and Green Peas")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("An Italian street food popular in Sicily and southern Italy.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-163",
    attrs: {
      "alt": "C:\\Users\\Mr STRIBLING\\Desktop\\Nouveau dossier\\PIC_0344.JPG",
      "src": "image/Stribling-6-034.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Ingredients for the Bolognese")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Minced beef")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Thick slice of Bacon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1/3 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1/3 tsp Paprika powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1/3 tsp Coriander powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 ml Red wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("125 g Tomato coulis")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Frozen peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Ingredients for the rice")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Arborio rice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Pinch of saffron")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 pkt Spanish paella spice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Egg yolk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("25 g Grated Parmesan")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Ingredients for coating")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Beaten egg")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 g Dried breadcrumbs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Oil for frying")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("For the Bolognese")])]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop onion and garlic. Cut the bacon into small squares.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the olive oil into a heavy pan and cook the bacon until brown. Add onions and cook for 5 minutes, then add garlic. Cook until soft.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add minced meat and cook until browned. Add spices and herbs, salt and pepper, plus the red wine, and cook until the wine has evaporated. Add the tomato coulis and cook very slowly for about 1 hour until you have a thick sauce. Check from time to time to see if it needs any more water.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the peas and cook for a few minutes until the peas are cooked. Set aside.")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("For the rice")])]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Use a rice cooker, add twice the volume of water to the arborio rice, with a pinch of salt, the saffron and Spanish paella spices. Cook and allow to cool.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When the rice is cool, add egg yolk and grated Parmesan and mix together well, getting a nice pasta texture.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When cold, place in a bowl. Cover with cling film and place in refrigerator.")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("To finish")])]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("With the cold rice pasta, roll into balls. Place the ball into your hand and make holes in the middle. Fill each hole with Bolognese sauce and cover with more rice paste and form into a ball. Set the balls aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat up a deep fat fryer. Place the beaten egg in a bowl and the breadcrumbs on a plate.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Dip the balls first into the beaten egg and then in the breadcrumbs to coat. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When all the balls are covered, cook them in very hot oil until golden brown. Remove and put onto absorbent paper.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve hot with the rest of the Bolognese sauce.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor110"
    }
  }), _vm._v("6.2.1.9 Grass Peas and Tomatoes on Drum Bread Toast")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This dish comes from the poorer areas of central and southern Italy and was the staple food for many.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Dried grass peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 Small dried tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Chilli powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Slices of durum wheat flour bread")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Parsley and mint")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash the grass peas and soak overnight. Drain and rinse well, then cook in slightly salted water for 2 hours. Drain and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Slice the dried tomatoes. Peel and chop the garlic. Chop up the parsley and mint.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the oil then fry the dried tomatoes, chilli powder and garlic until soft. Add drained peas, half the chopped parsley and mint and a little hot water to obtain a thickish consistency, like pasta. Cook on low heat so that it does not stick.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Toast four slices of the durum flour bread. Spread the grass pea pasta onto the toast and serve warm. Sprinkle with the rest of the chopped parsley and mint.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor111"
    }
  }), _vm._v("6.2.1.10 Green Pea and Chickpea Fritters")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("125 g Chickpea flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 ml Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Green peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Paprika")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cumin seeds")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Preheat oven at 180°C. Line a square baking tin with greaseproof paper.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a bowl, mix together the chickpea flour, paprika, cumin seeds and half the salt. Then gradually add a little of the water to obtain a nice paste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the peas in boiling salted water for about 5 minutes, then drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the rest of the water in a saucepan, then heat it. When it reaches boiling point, gradually add the chickpea flour mixture, whisking all the time to avoid it going lumpy and gradually getting a nice pourable paste. Add the cooked peas. Mix together well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pour the mixture into the baking tin. Make sure you spread it evenly. Cook for about 15 minutes. When it’s cold, cut into 3-cm squares. Serve warm.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("You can also prepare this in advance and keep the squares in the fridge. To use, heat olive oil in a frying pan. When hot, fry on both sides till brown. Serve warm or cold.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor112"
    }
  }), _vm._v("6.2.2 Broad Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor113"
    }
  }), _vm._v("6.2.2.1 Young Broad Beans and Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This recipe must only be used with very young and immature broad beans, which in general means from your own garden, or from a very good greengrocer. In this case, the beans should be served along with a little salt and olive oil.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor114"
    }
  }), _vm._v("6.2.2.2 Broad Bean Salad")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-164",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-035.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200 g Shelled broad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Small tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 ml Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Sumac")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Juice of lemon")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cut the tomatoes in half. Peel and crush the garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a bowl mix together olive oil, sumac, crushed garlic and lemon juice.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a salad bowl add the shelled broad beans tomatoes and sauce. Mix together well and serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor115"
    }
  }), _vm._v("6.2.2.3 Broad Bean Dip")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer265"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-036.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 1 bowl:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 kg Dry broad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the dried broad beans overnight. Wash and drain them well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel onion and garlic; do not cut.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the broad beans in a saucepan, then cover with water and bring to a boil. Cook until soft, but not too soft. Drain leave to cool. When cool, remove the skins.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a food processor, place broad beans and all the other ingredients. Then blend to make a sauce. Check seasoning, adding salt and pepper to taste.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor116"
    }
  }), _vm._v("6.2.2.4 Grilled Broad Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 kg Broad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Juice of one lemon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Preheat the grill. Coat the non-shelled beans with a small quantity of olive oil, then place them on a grilling rack. When the grill is hot, place the broad beans underneath.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Turn them now and then until blackened all over. Remove from the grill and allow to cool.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Remove from the shell before they get a too cold. Season with olive oil, lemon juice, salt and pepper, and serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor117"
    }
  }), _vm._v("6.2.2.5 Fried Dried Broad Beans")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer266"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-037.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("A popular Mediterranean aperitif snack, particularly in Portugal.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for one bowl:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 kg Dried broad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Vegetable oil for frying")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the beans for 2 days. Rinse with fresh water each day.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Drain and wash the beans, put them into 4 litres of slightly salted water and cook for 1 hour.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Drain and allow the beans to cool. Remove the outer skins and separate the two halves.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Dry the beans. Heat the oil: when hot, fry the beans until browned. Put onto absorbent paper to remove oil. Season with salt and pepper and serve. Note the fried beans can be stored in jars.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor118"
    }
  }), _vm._v("6.2.2.6 Stir-Fried Fresh Broad Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Shelled fresh broad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Hot Sichuan pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Rice wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp White wine vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Red bean paste")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Sesame seeds")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cook the beans in boiling salted water for 4 minutes. When you drain the broad beans, keep a cup of the water the broad were cooked in for later use. Let the broad beans cool, then remove the outer skin of the beans.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat olive oil in the wok, add broad beans and toss for 1 minute. Add all the ingredients, except sesame seeds, and continue tossing for 2 minutes. Add 2 tbsp cooking water and continue tossing 2 minutes over high heat.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Just before serving, sprinkle with sesame seeds.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor119"
    }
  }), _vm._v("6.2.3 Chickpea")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-165",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-038.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Chickpeas have been a street or finger food for eternity. Known in Greece and Rome, they have always been used as a snack. Some 2000 years ago, in Genoa, it was found that the chickpea flour mixed with water and cooked generally by frying gave a delicious dish. This was the origin of fried chickpea paste. This came in many different forms, which were transported all around the Mediterranean and even to South America by the Genoese sailors and traders. We will see the modern plants derived from these old ideas.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor120"
    }
  }), _vm._v("6.2.3.1 Socca, Farinata, Chickpea Pancake")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer268"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-039.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("(La Farinata in Italy, Socca in Southern France)")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("900 ml Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 g Chickpea flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("In a bowl, add the chickpea flour. Gradually add the water to get a nice smooth paste and set aside and cover. Leave for 24 hours.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the oven to 220°C. Pour olive oil into a flat paella-type oven dish and heat. When hot, add the flour mixture and cook for 30 minutes. At the end, move to a heated grill to brown the top of the dish. Serve hot with ground pepper and Genoese pesto. See recipe below.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor121"
    }
  }), _vm._v("6.2.3.2 Genoese Pesto Sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("60 ml Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Grated Parmesan")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Grated Pecorino")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Pine nuts")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Basil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop garlic, crush pine nuts and chop basil. Place these ingredients into a bowl.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Gradually add the olive oil, mixing into a smooth paste, then add the grated Parmesan and Pecorino cheese. Make sure it’s all mixed together well. Season to taste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Refrigerate before serving.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This can be served with pasta, or on toast – I like it served with jacket potatoes!")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor122"
    }
  }), _vm._v("6.2.3.3 Chickpea Fries (Panisse)")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer269"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-040.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is typical street food on the Mediterranean coast from Genoa to Marseilles.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Chickpea flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Pinch of Sriracha or paprika powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and oil")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel the garlic. Put the water into a large saucepan, add garlic and bring to a boil.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Remove from the heat. Add the chickpea flour gradually, stirring all the time. Once the flour is well mixed, add a pinch of sriracha then return the saucepan to the heat and continue cooking for 10-15 minutes until the pasta has thickened.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pour the pasta into a mould and allow it to cool.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the moulded Panisse into suitable forms and fry in olive oil until browned.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In Marseilles, the Panisse is normally sold in the form of chips in the street but can be cut into other forms for use as a side dish, as seen below")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor123"
    }
  }), _vm._v("6.2.3.4 Chickpeas Polenta Fries")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a variation of the Panisse, popular in Liguria in Italy. It is a mixture of chickpea and polenta. It has a different taste and is more consistent in texture.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people (Measures are given by volume for ease):")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 vol Chickpea flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 vol Polenta, small-grained")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("7 vol water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Put water in a saucepan. Add salt and stir in the chickpea flour. Once incorporated into the liquid, bring to the boil whilst stirring. Continue stirring for 3 minutes and then add polenta. Keep stirring for another 3 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pour the paste onto a greaseproof paper, cover with a second sheet of paper, roll to the desired thickness and allow to cool.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Once cool, the pasta can be cut into desired shapes and fried in olive oil. This is cooked in the same way as the chickpea fries.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor124"
    }
  }), _vm._v("6.2.3.5 Chickpea and Chestnut Crackers")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for a dish:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("100 g Chickpea flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Chestnut flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("80 ml Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Sesame seeds")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Masala with chilli")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1/ 2 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Preheat oven at 170°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a bowl mix together the chickpea flour, chestnut flour, Herbes de Provence, masala and salt.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Make a well in the middle of the bowl. Gradually add the olive oil, then water, arriving at a nice dough-like texture that can be rolled out.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat a frying pan: do not add oil. When it starts to smoke, add the sesame seeds, tossing all the time. This will be very quick. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the paste on greaseproof paper and cover with a second sheet of paper. Roll out the paste to the thinness you want. Remove the top paper, sprinkle with sesame and replace the paper to make the sesame seeds penetrate.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Transfer paper to an oven plate. Cut the paste into, say, 4 cm cubes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook in the oven for about 15 minutes. The real time will depend on the oven; you must watch when cooking it for the first time.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor125"
    }
  }), _vm._v("6.2.3.6 Bread Rolls with Chickpea Flour")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 12 rolls:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250"), _c('span'), _vm._v("g Chickpea flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("159 g Wheat flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Pots of yoghurt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("5 tsp Backing powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp White vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 ml Whey or water")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Preheat the oven to 250°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a bowl, mix the chickpea flour, wheat flour, salt and baking powder together.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Beat the yoghurt with the vinegar and add to the mixture. Add the water, mixing progressively to obtain a paste that is supple but does not stick. Knead until homogeneous.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the paste onto greaseproof paper. Roll into a cylinder and divide it into 12 pieces. Roll each piece into a ball.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the greaseproof paper on a baking plate. Slightly flatten each roll, cut across with a sharp knife and loosen the top. Put it into the oven and cook for about 15 minutes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Note, these rolls can be made gluten-free by replacing the wheat flour with rice flour or chestnut flour.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor126"
    }
  }), _vm._v("6.2.3.7 Fresh Pasta with Chickpea Flour")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer270"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-041.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("300 g Chickpea flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Lightly beat the eggs together, one at a time.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the flour and salt in a salad bowl and mix together. Gradually add the oil. Make a well in the middle of the flour, pour in the eggs and mix together to make a homogeneous paste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Flour the work surface and knead the paste to obtain an elastic ball. Wrap in cling film and keep in the fridge for 30 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Work the paste by hand, or by machine if you have one, to produce tagliatelle. Keep covered, so that it does not dry out.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the pasta for about 2 minutes in salted water and serve with your choice of sauce.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor127"
    }
  }), _vm._v("6.2.3.8 Chickpea Crackers")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200 g Chickpea flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Paprika")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Sesame seeds")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Poppy seeds")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Warm water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Chickpea flour for working")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-166",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-042.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Preheat oven at 170°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Mix the chickpea flour, salt, herbs, and spice in a salad bowl. Keep the sesame and poppy seeds for later.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add olive oil and incorporate. Add the water to obtain a paste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the paste on a lightly floured work surface and knead. Add flour if the paste is too sticky. Once the paste is homogeneous and supple, roll progressively. Sprinkle the flour to keep the paste from sticking.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Once the required thickness is ready, roll between sheets of greaseproof paper. Remove the upper sheet and dampen with water very lightly with a brush. Sprinkle with half the sesame and poppy seeds. Cover roll to insert the grain. Return and repeat on the other side.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Remove the upper sheet and cut into desired shapes. Put the paper onto a baking plate and cook for 15 minutes. Allow it to cool in the oven with the door open.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor128"
    }
  }), _vm._v("6.2.3.9 Hummus (Chickpea Dip)")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-167",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-043.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Hummus is a chickpea dip. It was once used all over the Middle East, but today all over the world. In Egypt, it is made from boiled dried broad beans.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("300 g Tinned chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ Lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Tahini")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("A mixture of olive and sesame oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("A few sprigs of coriander")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash and drain the chickpeas. Peel and crush the garlic. Keep a few chickpeas back for decoration.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the chickpeas, garlic, lemon juice and tahini in a blender. Turn slightly and progressively add the olive and sesame oil to obtain a very thick paste. Place in a bowl.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Decorate with the springs of coriander and whole chickpeas.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve with Arab bread.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor129"
    }
  }), _vm._v("6.2.4 Fresh Bean Salads and Starters")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("All types of fresh beans are of different shapes and sizes. Some young beans can be eaten raw; as they get older, they have to be cooked. In the case of certain beans like coco beans these would have to be cooked first for at least 10 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor130"
    }
  }), _vm._v("6.2.4.1 Fresh Slender Green Beans and Basil Salad")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer273"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-044.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Fresh green beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Red onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Bunch fresh basil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Wine vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cut the ends of the green beans and remove the string. If necessary, cook the beans in slightly salted water until softened but still crunchy. Drain and allow to cool.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel red onions and garlic. Crush the garlic, slice the onions very finely. Chop the basil. Place the green beans and sliced onions in a salad bowl.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Make a vinaigrette sauce with garlic, salt and pepper with the wine vinegar and olive oil. Add the basil, mix well, then pour it over the beans and onions.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Leave this for about 10 minutes. This help to take the fire out of the onion, but if you like the strong onion flavour, don’t leave for 10 minutes. Serve cold.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor131"
    }
  }), _vm._v("6.2.4.2 Fresh Yellow Bean, Red Peppers and Anchovy Salad")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Fresh yellow beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Red pepper confit")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Desalted anchovies")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Dijon mustard")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("A few leaves of basil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cut the ends off and check beans. Cook in salted water for 2-3 minutes, drain, cool in cold water and dry.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and crush garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Once the beans are cold, place the cold beans and add the peppers and anchovies. Mix together well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Make the vinaigrette sauce with olive oil, vinegar garlic, Dijon mustard, salt and pepper, mix together well, then add the basil. Pour this over the beans.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor132"
    }
  }), _vm._v("6.2.4.3 Flat Green Bean and Feta Salad")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer274"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-045.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Flat green beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Feta")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Sweet onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Sesame oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Balsamic vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Mustard")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Take off the ends of the beans and remove the string, if necessary, cut into 2 cm lengths and cook in salted water for about 3-4 minutes, drain then rinse in cold water and dry.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the feta into small squares.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop the onion and garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Make the sauce with mustard, sesame oil and balsamic vinegar. Season.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the beans and onion into the salad bowl, add the vinaigrette and mix.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the feta and incorporate, taking care not to break the cheese. Serve cold.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor133"
    }
  }), _vm._v("6.2.4.4 Salad of Fresh Cranberry Beans, Cockles and Mussels")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Fresh cranberry beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Mussels")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Cockles")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 ml Dry white wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Celery stick")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Sprigs of dill")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Lime juice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Sherry vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 ml Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8",
    attrs: {
      "lang": "fr-FR",
      "xml:lang": "fr-FR"
    }
  }, [_c('span', {
    staticClass: "CharOverride-7",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("A few green salad leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Put the cranberry beans in a large pan with half the herbes de Provence. Cover with water and cook for 20-35 minutes. Drain and leave to cool. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Wash the cockles and scrape the mussels. Discard any cockles or mussels that are broken. Put them into a large saucepan with the wine and the other half of the herbes de Provence, cover, and heat rapidly to open, shaking the pan often. Drain the shellfish, keeping 100 ml of the juice back. Discard any cockles or mussels if they have not opened.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the tomatoes, celery into small cubes. Chop the dill. Put into a salad bowl with the drained beans, the olive oil, the lemon juice from the shellfish and the sherry vinegar. Mix and season with salt and pepper. Add the shellfish. Turn and serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor134"
    }
  }), _vm._v("6.2.4.5 Green Bean and Bacon Bundles")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-168",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-046.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Green beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("10 Slices of thick-cut bacon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("¼ tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("¼ tsp Pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat the oven at 180°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Wash trim and check the green beans, season with salt and pepper. Peel the garlic and slice thinly.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Make 10 bundles of the beans, then wrap the bacon slices around the green beans. If need be, use a toothpick to hold them together. Grease a non-stick oven plate with olive oil. Place the bundles on the non-stick plate with the joint down to avoid opening.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a small saucepan, add the butter, heat, then add the sugar and garlic. When hot, brush the mixture over the bundles.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cover the bundles with aluminium foil and cook for 35 minutes. Remove the foil and cook for a further 15 minutes. This can be served hot or cold.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor135"
    }
  }), _vm._v("6.2.4.6 Edamame Soybean Aperitif")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The edamame bean belongs to the soy genus and was known in Japan as long ago as the AD 600s. It resembles a broad bean but is a soybean type. It is popular in Japan as an aperitif dish in a similar way to the yellow lupins in Spain and Portugal,")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("To prepare, blanch beans in salted boiling water and then drain. Make a mixture of salt and sugar. Toss the beans in the salt and sugar. Heat a hot plate or a frying pan. Cook the beans. When the plate is very hot – just for a few minutes – serve.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor136"
    }
  }), _vm._v("6.2.5 Dry Bean Salads")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Most dry beans are interesting for making salads. However, virtually all dry beans contain toxic alkaloids. These molecules are thermolabile and are destroyed by cooking. It is therefore important that dry beans be soaked and cooked before using. It is also possible to make salads with bean sprouts from most beans. Germination of beans sprouts is dangerous as the germination takes place in the ideal conditions for microbial development. Therefore, unless one has some serious experience, it is better to buy the beans sprouts from an authorised dealer.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor137"
    }
  }), _vm._v("6.2.5.1 White Bean and Green Pepper Salad")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200 g Dry white beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Green peppers")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Hard-boiled eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Dijon mustard")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the beans overnight in water. Drain and rinse well. Then cook in lightly salted water for about 2 hours until soft. Drain and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop onions and garlic. Clean and de-seed peppers and cut into strips.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Make a vinaigrette with salt, pepper, garlic, vinegar, olive oil and Dijon mustard. Peel and chop the eggs.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the beans, onion and peppers into a salad bowl. Add vinaigrette and mix. Place the chopped eggs on top and serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor138"
    }
  }), _vm._v("6.2.5.2 Black Bean and Sweet Corn Salad")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-169",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-047.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Tinned black beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 g Tinned sweet corn")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Red pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Ripe avocado")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 Spring onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("A few springs of coriander")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("For the dressing")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Juice of a lime")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("¼ Cayenne pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Open and drain the black beans and sweet corn. Rinse very well. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Clean and de-seed red pepper and cut into long strips. Wash the tomato and cut into quarters. Slice the spring onions finely. Cut the avocado into two, then twist it: this makes it easier to remove the stone. Peel the avocado and slice. Chop the coriander roughly.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Place all the ingredients into a salad bowl, mix together well, making sure you do not break the avocado slices up.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Peel and crush the garlic. In a small bowl, add all the ingredients for the salad dressing and mix together well. Then pour over the salad and serve.")])])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor139"
    }
  }), _vm._v("6.2.5.3 Red Bean, Rice and Shrimp Salad")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("300 g Basmati rice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 g Tinned red beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Skinned shrimps")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Sesame oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Rice vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Wasabi")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("In a saucepan, add water and salt. Bring to the boil and add the basmati rice. Cook for 9 minutes, stirring now and again. Drain and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Make the sauce with the sesame and olive oil, rice vinegar, soy sauce and wasabi, seasoning with salt and pepper if necessary. Put the sauce in a salad bowl")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add beans, rice and shrimps to the sauce and mix.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor140"
    }
  }), _vm._v("6.2.5.4 Sushi with Mung Bean Sprouts Salad")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-168",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-048.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 Packet sushi sheets")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Round rice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("¼ tsp Rice vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 tbsp Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Spinach")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Cucumber")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Piece pickled daikon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Mung bean sprouts")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("5 tbsp Soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("51 tbsp Nuoc mam")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Wasabi paste")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Sunflower oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cook the rice in the rice cooker with a pinch of salt, or in boiling salted water for 10 -15 minutes, till cooked. Drain. Then place in a bowl and add the rice vinegar and sugar. This will help the rice to stick together.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Blanch the spinach in boiling salted water until it’s soft, then drain. Make sure it’s well-drained. Then cut into strips.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("To make the omelette: in a bowl, beat the eggs, adding a little water and salt. In a frying pan add the sunflower oil. When it’s very hot, add the egg mixture. Cook until golden. Place on a plate and let it cool down. When the omelette is cold, cut it into 1-cm strips.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the cucumber and daikon into strips about 5-mm square, the same length as the seaweed sheets.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Wash the mug bean sprouts and bring to a boil in salted water. Turn off the heat and leave for 2 minutes. Drain and press to remove water.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Prepare the sushi as instructed on the packet with a layer of rice covered with a small layer of bean sprouts, a strip of omelette, a strip of cucumber and a strip of daikon. Seal with water and place the joint on the bottom of the dish.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the sushi into 5 cm lengths. Then place in bowls the soy sauce, nuoc mam and wasabi. Sometimes I serve it with lettuce leaves. Any rice left over, serve in a bowl.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor141"
    }
  }), _vm._v("6.2.5.5 Korean Style Mung Bean Sprouts Salad")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer278"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-049.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("350 g Fresh mung bean sprouts")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Sesame oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Bunch of spring onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel garlic and clean spring onions. Chop them both finely.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Rinse the mung bean sprouts in water, drain, and put in the water with the salt. Bring to a boil and cook for 2 minutes. Drain and rinse under cold water. Dry them.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the mung bean sprouts into a bowl. Add onion, garlic soy sauce and sesame oil. Mix together well. Check seasoning and add salt if necessary. Serve cold.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor142"
    }
  }), _vm._v("6.2.5.6 Salad of Coco Beans with Cockles and Mussels")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-170",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-050.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Fresh white coco beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Mussels")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Cockles")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 ml White wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Bouquets garni")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Shallots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Branch of celery")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Branches of dill")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Juice of 1 lime")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("A few leaves of green salad to decorate")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Put the white coco beans in a saucepan with one bouquet garni and cover with water. Bring to a boil and simmer for 30-35 minutes, until tender.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Wash the cockles and scrape the mussels. Put the cockles and mussels in a cooking pot with the white wine and the other bouquet garni. Cover with a lid. It will not need a lot of cooking, about 5 - 7 minutes. Just check to see if they are open. Heat the pot on the stove to open the cockles and mussels, shaking the pot during the cooling. Drain the mussels and cockles, keeping 100 ml of the juice. Remove the shells.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Wash the tomatoes and dry them, cutting them into small pieces. Peel and chop the garlic and shallots. Cut dill finely. Put all into a salad bowl with the shellfish with the drained beans. Add lime juice, olive oil and vinegar, dill, salt and pepper, and mix all.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the shellfish and the cooking juice. Mix and serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor143"
    }
  }), _vm._v("6.2.5.7 Peppers Stuffed with Black Beans")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer280"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-051.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("8 Peppers (mixed colours)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("400 g Cooked round rice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("400 g Tinned black beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Chicken breast")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cumin")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Cayenne")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 ml White wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat oven at 180°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the chicken into squares. Peel and chop finely onions and garlic. Drain the black beans and rinse well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Remove the top of the peppers, then clean out the insides, removing all seeds and fibres. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a frying pan, heat olive oil. Fry onions and garlic until they are soft, then add chicken pieces. Cook until the chicken is golden. Then add herbs and spice and glaze with the white wine. Then mix this with the cooked rice and black beans.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Stuff the peppers with this mixture. Then place the stuffed peppers on a baking tray. Add a little water. Cover with foil and cook for 20 minutes. Take off the foil and cook for a further 20 minutes. Check with a knife that the peppers are cooked. Serve warm.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor144"
    }
  }), _vm._v("6.2.5.8 Tofu")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-171",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-052.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients to make one block of tofu:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("2 l Soy milk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Magnesium chloride")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("In a large saucepan, bring the soy milk to boil, then allow to cool.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Dissolve the magnesium chloride in a little water then gradually add this to the cooled soy milk.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("The curds will start to appear. Allow to stand for 30 minutes. Line a square baking tin with sides with cheesecloth, making sure that the cheesecloth is big enough to cover the whole baking tray. Then pour the mixture through a colander into the lined baking tray. Then cover the top with the cheesecloth. Place some weight on top of the cheesecloth. Then allow to stand for about 30 minutes in a cool place.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Remove the tofu block from the cheesecloth. It is now ready for use. You can cut cubes or slices as you wish to use. You can keep the rest in the fridge ready for use another time. It must be kept in water.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor145"
    }
  }), _vm._v("6.2.5.9 Grilled Tofu and Vegetables")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer282"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-053.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 Block of tofu")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Tomato")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Baby tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Heavy soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Hot black fermented paste")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Vegetable oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and slice the onion in round rings. Slice the 1 tomato into slices. Leave the 3 baby tomatoes whole.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Choose a block of tofu that is nice and firm. Cut onto slices of 4 mm.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Take an iron griddle and put it on the heat.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Coat the grill with a little oil and start by grilling the tomatoes and onions. When they start to get soft, add the slices of tofu and grill on both sides. Make sure the tofu slices are nice and crispy.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a small pan, add a little water and the hot black fermented paste. Serve with the hot black fermented paste mixture and heavy soy sauce in small bowls.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor146"
    }
  }), _vm._v("6.2.5.10 Soy Sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-172",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-054.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Making soy sauce is a very long and smelly process. But the results are wonderful. You can buy the fermenting agent Koji on the internet.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1.200 g Soybeans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1.200 Wheat flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Koji starter (quantity to use is marked on the packet)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3.8 l Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("850 g Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("a) Making the soy sauce base")])]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pod the soybeans, then rinse them in cold water, discarding any that are old.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Place the soybeans in a larger pot. Cover and soak overnight. Drain and replace with clean water and drain again.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Place soybeans in a large saucepan covered with freshwater. Cook for 4-5 hours on low heat. You can test to see when they are cooked: you should be able to mash the soybeans with your fingers.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Drain the soybeans and mash them into a smooth consistency.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the wheat flour gradually to the soybeans. This should finish up like a dough mixture. Knead the mixture just like you would for bread.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Make sure the mixture is not too hot. This is when you need to add the Koji starter mixture.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Transfer the mixture to a tray 8 mm deep. Spread the mixture out in the tray. Use your fingers to make furrows, just like when you put seeds into a tray to germinate. But do not cover it over.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Allow the mixture to rest for 2 days in a warm humid place. The bacteria will start to develop. You will start to see this: it looks a sort of green colour. After two days, we now start the fermenting brine mixture.")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("b) Fermenting and pasteurising the sauce")])]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("As this is a very long process, you have to choose a place where you can place the Koji (this is the name given to the mixture). As this ferments, it really smells.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Dissolve the salt into 3.8 litres of water. Mix this well till all the salt has dissolved. This is the brine mixture. Mix the koji and brine together to create moromi (this means fermentation mash). The koji mix will not separate.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Now place the mixture into a large earthenware jar that has a good lid. This jar needs to hold about 7.6 l of liquid, which leaves you room to stir it.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pour the brine over the top of the mixture. You will need a long spoon for this. Stir the mixture well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Keep the moromi in a warm place and stir daily for a week. Make sure that the temperature is stable and the lid is on tightly. This will really smell – it’s normal!")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Stir the moromi once a week for the next 6-12 months. The longer you leave it the stronger it will be. This is where it really starts to ferment.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When the fermentation has finished, strain the mixture through a cheesecloth, making sure that you get every last drop of the liquid. It’s the liquid that you will use for the next stage. Discard the moromi mixture.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Place the liquid into a saucepan ready to pasteurize the soy sauce. Heat the soy sauce over medium heat. Use a thermometer to ensure that the soy sauce stays at the same temperature of 90°C for 20 minutes but must not boil. When this is finished, transfer the soy sauce into heat-proof pots. Test with a sugar thermometer to monitor the temperature.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Now that the soy sauce is pasteurized, you can store it in a pot or several pots and store it in the fridge. This is now ready to try. It can be stored for up to three years.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Note: It’s long and smelly but the end result is worth it.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor147"
    }
  }), _vm._v("6.2.5.11 Coco Beans with Cod Paste (Brandade De Morue)")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-173",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-055.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Brandade de morue (cod paste) is a French dish from the town of Nîmes in Southern France. It is made from morue (dried salted cod) that has been soaked in water to remove the salt and is then mixed with milk and olive oil to make a paste. It is very popular in the South of France as an aperitif or with starters. The tradition of using dried salted cod in the Mediterranean areas goes back to the fishing fleet of Northern Europe bringing their catches to the Mediterranean ports to exchange the cod for salt, olive oil, wine and other products such as fruits. It’s very similar to the bitter Seville oranges that found their way to Dundee and produced the famous Dundee marmalade.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("A. For the cod paste")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients: for 6 people")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Dried salted cod")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Warm milk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Glass of cold milk")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the dried salted cod in cold water for 48 hours, changing the water 4 times.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Drain the fish and put in a saucepan with water. Heat and just before boiling, add a glass of cold milk. Remove from the heat and allow to stand for 10 minutes. The cod should not boil. Drain and remove all bones while still warm.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Prepare equal volumes of warm milk and olive oil. Break the fish with your fingers into a heavy-bottomed pan.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the pan on low heat and with a strong wooden spoon start to turn the fish add little by little small equal quantities of milk and oil, stirring continuously, continue till you have a stiff paste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("The fish paste can be stored in the refrigerator, for up to 4 days.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("B. For the dish")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Shelled coco beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Cod paste")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Grated dry goat’s cheese")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat oven at 180°C")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the beans in the vegetable stock until soft. Allow to cool.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the beans and cod paste in an oven-proof dish and mix together. Cover the mixture with grated goat’s cheese and cook until well browned. Cook for about 30 minutes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Note: If coco beans are not available you can use other sorts of beans. Goat’s cheese is mentioned, as this is the local cheese of the Nîmes area, but other fresh cheeses can be used.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("If you have made more cod paste than necessary, no problem: it can be used on toast.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor148"
    }
  }), _vm._v("6.2.6 Lentil Salads")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor149"
    }
  }), _vm._v("6.2.6.1 Puy Lentil Salad")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer285"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-056.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Dried green Puy lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Large red onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Piece of ginger, 2 cm")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Cider vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Dijon mustard")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Turmeric powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cumin powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash and drain the lentils. Cook for 20-25 minutes in three times their volume of non-salted water. Drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel the red onions cut into half and slice finely. Skin the ginger and grate.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Make the dressing by mixing the Dijon mustard, ginger and spices with the cider vinegar and add the olive oil. Check the seasoning with the salt and pepper.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the lentils in a salad bowl, add red onion and mix together, then add the dressing.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor150"
    }
  }), _vm._v("6.2.6.2 Coral Lentils and Pepper Salad")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-174",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-057.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Coral lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Red pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Green pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Yellow pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Carrot")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Sesame oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Light Soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Nuoc mam")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp chopped fresh coriander")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash and drain the coral lentils. Soak in cold water for 30 minutes then drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the lentils into twice the volume of non-salted water and cook for 20-30 minutes until tender. Drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel onions and slice. Clean and de-seed the peppers and cut into small strips. Peel the carrot and cut into small squares. Peel and chop the garlic finely.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Make the dressing with the garlic, light soy sauce, olive and sesame oils and Nuoc mam, incorporating the chopped coriander")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a salad bowl, mix the lentils with the red onions and peppers, then add the dressing. Mix together well.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor151"
    }
  }), _vm._v("6.2.6.3 Beluga Lentil Basil Salad Sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-175",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-058.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Beluga lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Celeriac")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Pesto sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Red pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Tomato")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Sweet paprika powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel the onions, garlic and celeriac. Chop one onion and garlic finely. Grate the celeriac in a machine. Slice the remaining 2 onions. Clean and de-seed the red peppers, then cut into strips.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Wash and check the beluga lentils under the running water. Drain, cover with cold water, then drain again. In a saucepan, cover the beluga lentils with twice their volume of water. Add a little salt and the herbes de Provence, one onion and garlic. Put on the heat and bring to a boil. Reduce the heat and simmer for about 25 minutes until the beluga lentils are cooked. Drain and reserve.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Once the lentils have cooled down, put them into a salad bowl. Add the 2 onions, celeriac and red peppers mixed together, then add the pesto sauce and remix.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve in flat bowls and cover the salad with slices of tomato sprinkled with paprika powder.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor152"
    }
  }), _vm._v("6.2.6.4 Sprouted Lentil Salad")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("You can buy sprouted lentils, or you can grow them yourselves. If you want to grow them yourself, please see our section on how this can be done. You can buy the sprouting seeds through the internet or in delicatessen shops.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200 g Sprouted lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Red onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Red peppers")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Wholegrain mustard")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and slice onion. Clean and de-seed the peppers then slice. Peel and chop finely the garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the sprouts in a salad bowl and mix with onions and peppers.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Make the dressing with the wholegrain mustard, garlic, vinegar and olive oil. Season with salt and pepper and add to the salad bowl. Stir and serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor153"
    }
  }), _vm._v("6.2.6.5 Roast Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Dried Puy lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Paprika")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Garam masala with Pimento")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat oven at 200°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Wash and drain the lentils, put into a saucepan and cover by 2 cm with cold water. Bring to a boil, reduce heat and simmer for 18-20 minutes until cooked.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop the garlic finely.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Return the lentils to the pan. Add other ingredients and mix together well. Pour the mixture onto greaseproof paper in a baking pan.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the lentils in the oven for 15 minutes. Remove and stir. Return to the oven and cook for a further 15 minutes. Serve warm.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor154"
    }
  }), _vm._v("6.2.6.6 Sprouted Green Lentil Burger")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 5 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("650 g Fresh sprouted green lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Tomato sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Chopped garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Sage")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Cumin")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Coconut flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Ghee or olive oil for frying")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1/2 tsp Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Place all the ingredients together in a blender to produce a slightly stiff paste, keeping the ghee for frying.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Make the paste into balls, then flatten to give a rather thin burger. Or you can make small balls.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the burger in a hot pan with ghee or oil until browned on both sides.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor155"
    }
  }), _vm._v("6.2.7 Lupin Salads and Starters")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Traditional Lupins")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The origins of lupins are in the Mediterranean area and Latin America. Lupin beans have been eaten for thousands of years. The lupin bean as such has a bitter taste due to the presence of certain alkaloids some of which are toxic and must be removed before eating. Lupin beans can be used after preparation as an aperitif or as a dish in the same way as chickpeas.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("There are many ways of sweetening lupins, and in each area where families have their own method, we will give a typical method.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor156"
    }
  }), _vm._v("6.2.7.1 Sweetening of Traditional Lupins")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer288"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-059.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash the lupin beans and soak in cold water for 24 hours")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Rinse beans and put into fresh cold water. Bring to a boil and simmer for about one hour till cooked.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Let the beans cool. Once cold, drain, rinse and put into a pot of cold water.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Soak for 3-4 days, changing the water twice every day.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Check to make sure that the bitterness has disappeared. If not, continue.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Store the beans in the refrigerator in either a solution of brine or in brine and vinegar.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The beans must be soaked in water to eliminate salt before use.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor157"
    }
  }), _vm._v("6.2.7.2 Lupin Beans as Aperitif")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is the common way of eating lupin beans. Once desalted, they are served as such and are eaten after removing the skin. They can also be used once skinned as a salad ingredient.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Desalted lupin  beans can be used to make houmous or falafel in the place of cooked chickpeas.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("At the present time, food manufactures are selling pasta based on lupins.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor158"
    }
  }), _vm._v("6.2.7.3 Lupin Houmous")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200"), _c('span'), _vm._v("g Lupin Flakes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Large cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Nutmeg")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Sprigs of fresh coriander")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Sesame oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Juice of 1 lemon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Lebanese bread")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Put the lupin flakes in a saucepan. Cover with water, then boil in salted water for about 4 minutes and drain well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop the garlic. Chop the coriander.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When the lupin flakes are cold, put them into a blender with the salt, nutmeg and lemon juice. While blending, gradually add a little bit of olive oil. Continue mixing, adding the olive oil until you have the desired consistency.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the mixture into a bowl, decorate with coriander and drizzle with the sesame oil.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve at room temperature, slice the Lebanese bread.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor159"
    }
  }), _vm._v("6.2.7.4 Low Carb Pancake with Lupin and Plain Flour")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a neutral pancake that can be used in sweet or savoury dishes.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 5 pancakes:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("100 g Sweet lupin flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Plain flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Cornflour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("700 ml Milk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("10 g Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("In a bowl, mix together sweet lupin flour, plain flour, cornflour, salt and sugar. Heat the milk up, just to take the chill off: do not boil.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Gradually add the warm milk to the pancake mixture, whisking to obtain a lightish cream texture without lumps.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a bowl, beat the 2 eggs together, then gradually add this to the pancake mixture.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Allow the mixture to stand for about six hours. It can be made the night before.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Before you cook the pancakes, pre-heat your oven on medium heat, so that when the pancakes are cooked you can keep them warm while you cook the others.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Check the pancake mixture is not too thick. If this is the case, add a little bit more milk. Heat a pan with a small quantity of butter and when hot add a ladle of the pancake mixture and cook until browned. Turn and do the other side. (After cooking each pancake, I wipe the pan and start again.)")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("These pancakes can be used for either sweet or savoury dishes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor160"
    }
  }), _vm._v("6.2.7.5 Low Carb Pizza with Sweet Lupin Flour")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer289"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-060.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for two pizzas")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("1. For the Pizza Dough")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200"), _c('span'), _vm._v("g Plain flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Lupin flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 pkt Dry yeast")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Warm water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Flour for kneading and rolling")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("2. For the Pizza")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200"), _c('span'), _vm._v("g Tomato confit")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 g Skinned red peppers")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("30 Anchovy fillets")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("10 Black olives")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("30 g Hard cheese")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Few leaves of marjoram")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("For the dough")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Take a large salad bowl. Add a little flour, dry yeast and sugar. Mix together, then add a little warm water to make a dough. Cover with a cloth and place in a warm place for 1 hour.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("The yeast should now have activated. So, we can add salt, olive oil gradually, then we gradually add the plain and lupin flours. Mix this well together: you need to obtain a sticky dough. If it’s too dry, add a bit of warm water. Re-cover with the cloth and place in a warm place for another hour.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Knead well together on a floured board. This can be made the day before.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("For the pizza")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat oven at 200°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Take half the dough, make a ball and flatten it. Put the dough on a board with a little flour and roll to a diameter of about 25 cm.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cover a greaseproof baking tray with greaseproof paper. Place the dough onto this.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Mash the tomatoes and red peppers to make a paste. Grate the cheese and set it aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Brush the dough with olive oil. Cover with the paste, add anchovies, sprinkle with the grated cheese, add olives and decorate with the marjoram. Season to taste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the pizza in the oven for about 10-15 minutes. Check to see if it’s a nice bronze colour. Serve with a salad.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor161"
    }
  }), _vm._v("6.2.8 Peanut Salads and Aperitifs")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor162"
    }
  }), _vm._v("6.2.8.1 Roasted Peanuts")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Shelled or unshelled raw peanuts")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat over 160°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("If using unshelled peanuts, take the shells off. Place the shelled peanuts in a bowl, then roll them through your fingers, getting as much skin off as you can. Sprinkle with salt and rub them together well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the raw peanuts on a shallow oven tray, only a single layer.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook for about 15-20 minutes. Remove from the oven just before the end of the time, as the peanuts will continue to cook while cooling.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This recipe can also be used with sugar, sugar and salt, spices or soy sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor163"
    }
  }), _vm._v("6.2.8.2 Peanut Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-176",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-061.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Roasted peanuts")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Honey")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Put the peanuts into a food processor and blend for 3-5 minutes, the peanut will pass from crumbly to wet crumbly to a paste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add honey and salt to taste and remix.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pack in jars and keep in the refrigerator.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor164"
    }
  }), _vm._v("6.2.8.3 Sugar-Coated Peanuts")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("150 g Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("125 ml Coconut milk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Sesame seeds")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("70 g Rice flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 g Fresh shelled peanuts")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 ml Vegetable oil. (This is for deep frying.)")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Mix together the sugar, coconut milk, salt, sesame seeds, rice flour and peanuts.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the vegetable oil until hot but not smoking. Cook the peanuts in batches, putting them carefully into the hot oil until they are browned and crunchy. Dry them on absorbent paper. It tastes very nice!")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor165"
    }
  }), _vm._v("6.2.8.4 Potato and Beetroot Salad with Peanut Sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Cooked potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 g Cooked beetroot")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Large red onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Crunchy peanut butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Sesame oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Balsamic vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel the red onion and cut into slices. Peel the garlic and chop finely.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the potatoes and beetroot into small squares and put them in a salad bowl. Then add the onions.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the peanut butter, olive oil and sesame oils, garlic, balsamic vinegar into a food processor and run to obtain a paste. Add salt and pepper to taste, then mix together well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the sauce to the salad bowl and toss before serving.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor166"
    }
  }), _vm._v("6.2.8.5 Indian Peanut Chaat Salad")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer291"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-062.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("3 cups Peanuts with shells")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("¼ tsp Chaat Masala")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Sea salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Turmeric powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt to taste")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Red chilli powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Roasted cumin seeds")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Onion, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium tomato")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Green chillies")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Fresh coriander leaves chopped")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Put the peanuts into a large saucepan, add the sea salt and turmeric powder and cover with water. Bring to a boil, then simmer for about 3 hours. Drain. Let it cool, then shell the peanuts.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the peanuts in a bowl. Add salt, chaat masala, red chilli powder, roasted cumin seeds, onion, tomato, green chillies, coriander leaves and lemon juice and mix together well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve hot or cold.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor167"
    }
  }), _vm._v("6.2.16 Mimosa Aperitifs")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor168"
    }
  }), _vm._v("6.2.16.1 Mimosa Eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Eggs cooked like this have been served for thousands of years, even in Roman times. But the name was given to this recipe when Captain Cook brought the Mimosa trees to Europe. The mimosa flowers looked so much like the eggs they served that they named them mimosa eggs.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 Mimosa Eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("6 Hardboiled eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Mayonnaise")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp White vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("¼ tsp Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Paprika")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Chopped Parsley")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salad leaves")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("In a saucepan, boil then eggs till they are hard-boiled. Shell the eggs and cut into two. Remove the yolks and put them in a salad bowl.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add to the egg yolks, the mayonnaise, white vinegar, salt and sugar. Mix them together well. Then mash the mixture together well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Fill the white of the eggs with the egg yolk mixture. On a serving plate, cover this with salad leaves then place the mimosa eggs on the plate. Sprinkle this with chopped parsley and paprika.")])]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-177",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-063.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor169"
    }
  }), _vm._v("6.3 Main Dishes")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2-first"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor170"
    }
  }), _vm._v("6.3.1 Peas/Mangetout Main Dishes")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor171"
    }
  }), _vm._v("6.3.1.1 Rice with Green Peas and Broad Beans")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer293"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-065.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 2 people. The ingredients are indicated by volume: interesting in certain cases. In this case the volume equals 250 ml.")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 vol Long grain rice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("1 vol Green peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("1 vol Broad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("3 vol Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("1 Packet Spanish spigol")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("1 Pinch Saffron")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Put the stock into a saucepan. Add Spanish spigol and salt. Bring to a boil. When boiling, add the green peas and broad beans and cook for 2 minutes. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Take a flat pan, add the oil and when hot fry the rice until white.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the stock with vegetables and spigol to the flat pan with the rice in. Stir and cook until most of the liquid has disappeared: this should take about 20 minutes. Check the rice to see if it’s cooked.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Season with salt and pepper to taste. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("N.B. Spigol is a Spanish mixture for paella and can be found in most deli stores.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor172"
    }
  }), _vm._v("6.3.1.2 Gratin of Peas and Spinach with Brandade")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The Brandade, a French speciality from Nîmes, is a paste made from salted cod. The salted cod is soaked for 48 hours to eliminate the salt and is then mixed with olive oil to make a paste. This dates from the time when Northern European fishermen caught cod in the Northern Atlantic, dried and salted the cod on board, and brought to the Mediterranean ports to trade and exchange salted cod for wine, olive oil and oranges.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 2 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Green peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Spinach leaves")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Brandade de morue")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 ml Stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Medium potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Grated Parmesan cheese")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat oven to 180°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel the potatoes and cut into cubes. Wash the spinach. If you are using fresh green peas, pod them.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Place the potatoes into a saucepan, cover with water and bring to a boil. When they are cooked, drain and mash them. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a saucepan, add the stock and salt, bring to a boil. Add peas and spinach leaves and cook for 2 minutes. Drain and allow to cool.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Mix the Brandade with the vegetables and put them in an oven-proof dish. Cover with a layer of mashed potatoes, powder with grated Parmesan cheese and put in the oven for about 25 minutes until well browned.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor173"
    }
  }), _vm._v("6.3.1.3 Mangetout with Rice and Shrimps")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 2 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Mangetout")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Long Rice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("40 g Dried Shrimps")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("800 ml Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Sesame oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Masala with chilli")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Strands of saffron")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the dried shrimps in hot for about 45 minutes, then drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the stock into a saucepan. Add mangetout, shrimps, masala and saffron. Bring to a boil, season and reserve.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put olive and sesame oils into a flat pan and heat. When hot, add the rice cook until the rice whitens. Once the rice has whitened, add the contents of the saucepan and cook slowly until almost dry. Check that the rice is cooked. Season and serve. Goes well with a dal.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor174"
    }
  }), _vm._v("6.3.1.4 Lamb Stew with Green Peas")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer294"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-066.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("4 Thick slices of neck of lamb")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium carrot")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium potato")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Courgette")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Frozen peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Mild paprika")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Garam masala")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 ml White wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("400 ml Vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop onions and garlic. Peel and cut potatoes into cubes. Peel carrot and clean courgette and slice into discs.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the olive oil into a heavy stew pan, heat the oil and brown the sliced neck of lamb. Once brown, set aside in a bowl.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In the pan, add onion and garlic and allow to soften. Return the lamb with the spices and herbes de Provence. Add the wine and cook for 5 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add carrot and stock, season with salt and pepper and simmer slowly for one hour.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add potatoes and courgettes and continue cooking. Just before the potatoes are cooked, add the peas and cook for about 5 minutes. Check seasoning and serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor175"
    }
  }), _vm._v("6.3.1.5 Greek-Style Peas and Potatoes with Chicory")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer295"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-067.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("6 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 kg Fresh peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Large chicory roots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("10 Medium tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 Large potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Bunch of dill")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Juice of one lemon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Marjoram")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("750 ml Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Shell peas, peel and chop onions and garlic, peel potatoes and dice them, slice chicory and cut in 1.5 cm cubes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a saucepan with boiling water, blanch the tomatoes. Drain. When cold, peel the skin off. Cut the tomatoes into slices.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the onion and garlic in a heavy pan with the olive oil and cook slowly for about 10 minutes until soft, but do not brown.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add chopped tomatoes and marjoram and cook for 10 minutes. Add water, salt and pepper. Add the diced potatoes and chicory. Cook for 15 minutes on average heat.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add peas and chopped dill and cook until the vegetables are soft.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add lemon juice, stir and cook for a further 5 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve with pasta and feta.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("If you can’t find chicory, you can use salsify.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor176"
    }
  }), _vm._v("6.3.1.6 Goat’s Meat Stew with Peas")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-178",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-068.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a typical Greek country dish.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 kg Goat’s meat")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 ml Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Plain flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Medium tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 kg Medium carrots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Fresh shelled peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Origami")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Thyme")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Bay leaves")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 ml Vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat oven to 180°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the tomatoes into four, peel and dice carrots. Peel onions and garlic and slice.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the meat into bite-sized pieces and coat with flour, salt and pepper. Place in a stew pot with the olive oil and cook on all sides until browned.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add chopped onions and garlic and continue to cook until the onions are softened.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add sliced tomatoes, diced carrots and herbs. Add a little stock to cover and continue cooking slowly until the meat softens. Add stock or water to keep covered. Cook for 60 to 75 minutes or until tender.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When the meat has softened, add peas and cook for a further 5 minutes, or until cooked.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve with rice or pasta.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor177"
    }
  }), _vm._v("6.3.1.7 Chickpeas and Chorizo")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer297"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-069.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("600 g Dry chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Chorizo")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Bay leaves")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak chickpeas overnight. Drain chickpeas and rinse well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and crush the garlic. Put the chickpeas in a saucepan and cover with water. Add garlic, bay leaves and salt. Bring to a boil and simmer for 30 minutes. Check to see if the chickpeas are soft, then drain. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the chorizo into slices. In a frying pan, add oil and heat. When hot, add the chorizo slices, fry until they are slightly brown, then add the chickpeas mixture. Cook for a further 3 minutes. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor178"
    }
  }), _vm._v("6.3.1.8 Pork Fillet with Coco Beans and Mangetout")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Fillet of pork")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Shelled coco beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Mangetout")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Red peppers")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium carrot")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat oven to 180°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Slice the pork fillet into slices. Peel and chop 1 onion and garlic. Put 1 tbsp of olive oil in a pan and heat. Add the onions and garlic to the pan and cook until soft. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cover the coco beans with salted water and simmer for 10 minutes. Cook until soft. Drain and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel one onion and cut into six. Peel carrot and cut into rounds, cut the pepper into 3 cm squares and trim the mangetout and cut them in half.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put all the vegetables except the mangetout into a salad bowl. Add salt and pepper, herbes de Provence and 1 tbsp of oil and mix together. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put meat and onions in an oven-proof dish cover with the vegetables except the mangetout. Add a little of the meat water during the cooking to make sure that the dish does not dry out.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When cooked, add mangetout and coco beans, stirring them together. Return to the oven for a further 5 minutes and serve. The mangetout should remain crunchy.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor179"
    }
  }), _vm._v("6.3.2 Broad Beans Main Dishes")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor180"
    }
  }), _vm._v("6.3.2.1 Broad Bean Risotto")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer298"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-070.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Shelled broad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Arborio rice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("600 ml Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Powdered cumin")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 ml White wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Mascarpone")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cook the broad beans on salted boiling water for about 10 minutes. Drain, keeping the water they were cooked in. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop the onions and cook them in the olive oil. Once soft, add the rice and allow to whiten.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the herbs and cumin and salt and pepper. Add the white wine and cook for 3 minutes. Add the stock, mascarpone and beans.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Continue to cook, stirring and making sure it does not dry out; add water if necessary. Cook this for about 15-20 until the rice is cooked. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor181"
    }
  }), _vm._v("6.3.2.2 Gratin of Broad Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("300 g Shelled broad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 g Squash")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Salted pork belly")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cumin powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Grated Parmesan")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Grated Pecorino")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Strong honey")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Glass of white wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat oven to 180°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Blanch the beans in salted boiling water for about 3 minutes, then drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel the squash and cut into small pieces, then cook in salted water for 10 minutes. Then drain and make into a purée with a masher.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop the onion, heat the olive oil, then add the chopped onions. Cook until soft. Add cumin, paprika, garam masala, white wine and honey. Season to taste with pepper and salt. Stir and bring to a boil and add the mashed squash.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the beans into a greased oven-proof dish and cover with the squash. Sprinkle with the Parmesan and Pecorino, then cook in the oven for 20 minutes, until golden-brown on top.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor182"
    }
  }), _vm._v("6.3.2.3 Whole Broad Beans with Pork")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Young whole broad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Shoulder of pork")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("5 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Duck fat")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Fresh bunch of coriander")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 ml Pork stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash the whole broad beans, remove the ends and cut into 5-cm pieces. Peel and crush the garlic, cut the tomatoes into 6 pieces.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the pork into 3-cm cubes. In a pan add the duck fat. When it’s hot, add the pork pieces. Fry until nice and golden-brown.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the garlic and tomatoes and cook for 2 minutes. Add salt and pepper. Add the stock, cover and simmer for 30 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Check seasoning, then add the beans and cook until tender.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve with rice sprinkled with coriander.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor183"
    }
  }), _vm._v("6.3.2.4 Stir-Fried Broad Beans and Vegetables")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer299"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-071.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("300 g Shelled broad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Bok Choy")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Celery")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Young carrots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Dill")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Roasted sesame")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Boil the beans in salted water until tender. Drain and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop onions and garlic finely.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the Bok choy, celery and carrots into 3 cm lengths and then into thin sticks.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add olive oil to a wok on medium heat, add vegetables and stir, keeping the vegetables moving for about 5 minutes. Then add all the other ingredients and continue cooking until the vegetables are cooked but still crunchy.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve with rice.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor184"
    }
  }), _vm._v("6.3.3 Chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor185"
    }
  }), _vm._v("6.3.3.1 Lamb with Chickpeas")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer300"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-072.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("2 Shanks of lamb")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 g Neck of lamb")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("400 g Cooked chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 g Couscous")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Piece fresh ginger, about 5 cm")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 g Tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Garam masala")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Ground cumin")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Ground paprika")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Boil some water in a saucepan. When it’s boiling, add the tomatoes and bring to a boil. Boil till the skins start to come away. Drain and set aside to cool. When the tomatoes are cold, take the skin off and cut into four.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Chop the onions, garlic and ginger. Put the olive oil in a heavy pan and heat. Cook the onions until soft, add Herbes de Provence, garlic and ginger. Heat for another minute while stirring.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the shanks of lamb, neck of lamb in the pan and brown all over.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the peeled chopped tomatoes and spices with a part of the stock. Simmer slowly covered for about 35 minutes, or until tender.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook couscous as instructed on the packet.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Season the couscous with salt and pepper, then add the washed and drained chickpeas and serve hot.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve the lamb and couscous and harissa.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor186"
    }
  }), _vm._v("6.3.3.2 Andalusian Chickpeas with Spinach")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 kg Spinach, washed and cleaned")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 g Tinned chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Shallot")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbs de Province")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Ground cumin")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Powdered paprika")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Sliced stale bread")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Wine vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 ml Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("20 g Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Take a saucepan. Add a very small amount of water, put it on the heat and add the spinach and butter. Cover for 1 or 2 minutes until the spinach has wilted. Remove from the heat and allow to cool. Once cold enough, squeeze the spinach to remove water and chop, not too finely. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the stale bread into very small cubes. Chop the garlic and shallot very finely.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Wash and drain the chickpeas.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the olive oil into a heavy pan and heat. As soon as it is hot, add the garlic and shallot. Cook until they start to brown. Add the bread, stirring. Add the herbes de Provence and spices. Have a glass of water handy in case it sticks and stir well so that it is all mixed together, then add the spinach. Continue stirring and add the chickpeas. Add the vinegar.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When well mixed and hot, serve with a drizzle of olive oil.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This dish is a main dish in a Spanish tapas bar.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor187"
    }
  }), _vm._v("6.3.3.3 La Cocido Spanish Chickpea Stew")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer301"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-073.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Originally this dish was brought to Spain by the Arabs and was traditionally served without pork. However, at the time of the Inquisition, Queen Catarina ‘The Catholique’ decided that this national and widely eaten dish should be served with pork to detect the false Muslim and Jewish converts to Catholicism. Since that time, the dish is always served with pork.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Dried chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Chicken")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Sliced stewing steak")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Salted pork belly")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Lean pork")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g White cabbage")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("8 Medium Potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Medium carrots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Turmeric powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Bay leaves")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Paprika powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the chickpeas overnight. Drain and rinse well, then cook them in salted water, until soft.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a saucepan, add water, then cook the pork belly for 10 minutes. Drain. When cool, slice. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel the onions, garlic, carrots and potatoes. Slice the onion and garlic. Cut the carrots and potatoes in two. Slice the cabbage.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the lean pork and stewing steak into 6 pieces. Cut the chicken into 6 pieces.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a large casserole, add the lean pork, pork belly, stewing steak and chicken, herbes de Provence, spices and bay leaves. Then cover with water. Bring to the boil. When boiling, reduce heat and simmer for half an hour.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the onions, garlic, carrots, potatoes and cabbage. Simmer for a further 20 minutes. Add chickpea, making sure there is enough liquid. If it’s too dry, add some water. Season with salt and pepper to taste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Place the vegetables on a large plate, then place the meat on the top of the vegetables.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Traditionally this dish is served in the following way: the juice is served as soup to start with, then the rest is served as a main dish.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor188"
    }
  }), _vm._v("6.3.3.4 White Shark with Chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-179",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-074.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("4 White shark steaks")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Tinned chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium red pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Pimento powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Paprika powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 bunch of fresh coriander")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 dose Saffron")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 ml Stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Lemon confit")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop the onions and garlic. De-seed the red pepper and cut into strips")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a flat pan, add the olive oil and heat. Add the sliced red pepper until slightly browned. Add garlic and onion chopped finely, spices and herbes de Provence, stirring. Add stock and cook for 1 minute.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the washed and drained chickpeas, saffron, salt and pepper and the rest of the stock. Cook for 10 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the coriander and the shark and cook for 5 to 10 minutes. Turn the shark steaks. Slice the lemon confit.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Remove shark and set aside, keeping it warm. Cook the sauce and chickpeas about 10 minutes. Check seasoning, add the shark and sliced lemon and serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor189"
    }
  }), _vm._v("6.3.3.5 Chickpeas with Beef")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("4 Beef spare ribs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Calf’s feet")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Tinned chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Paprika")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Coriander")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Beef stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop onions, garlic and tomatoes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put spare ribs and calf’s feet in a saucepan. Add garlic, onions, tomatoes, oil and herbs. Cover with stock. Bring to a boil and simmer for 4 hours.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add chickpeas, paprika, coriander and check seasoning. Cook for a further 5 minutes. Serve hot. This can be served with either rice or potatoes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor190"
    }
  }), _vm._v("6.3.4 Fresh Bean Main Dishes")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-180",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-075.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor191"
    }
  }), _vm._v("6.3.4.1 Coco Beans and Black Cabbage")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer304"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-076.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 2 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Shelled coco beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Black Florentine cabbage")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Large onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("60 g Salted pork belly")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 ml Vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Garam masala")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 ml White wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Slice the cabbage, then steam in salted water for 5 to 10 minutes. Drain and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the stock into a saucepan, then put the coco beans into the stock. Cook for about 15 minutes until soft. Set the saucepan aside. Do not drain: the rest of the ingredients will go into this later.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop onion and garlic. Chop the salted pork into small pieces.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the onions and pork in the olive oil until they start softening. Add herbes de Provence, spices, garlic and wine and cook for 4 minutes. Then add this to the saucepan with the coco beans in. Add the chopped cabbage to this also.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Check seasoning, heat and serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor192"
    }
  }), _vm._v("6.3.4.2 Fresh Green Bean Gratin")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("750 g Fresh green beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Cheddar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Grated Parmesan")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Trim the beans and cut into 4 cm lengths. Grate the Cheddar cheese. Peel and crush the garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Set the oven to 200°C. Put the fresh beans in an oven-proof dish. Season with salt, pepper and crushed garlic, mixing well together. Put a knob of butter on the beans, cover with foil, and roast for about 15 minutes, then stir well. Then cook covered with the foil for another 15 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Take off the foil, sprinkle the grated Cheddar and Parmesan. Cook for another 15 minutes until brown. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor193"
    }
  }), _vm._v("6.3.4.3 Indian Cluster Beans and Potato Curry")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer305"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-077.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Fresh cluster beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 g New potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("25 cm Ginger")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cardamom pods")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Cumin seeds")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Pinch of Asafoetida")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1/2 tsp Turmeric powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("8 Curry leaves")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("¼ tsp Chilli powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Coriander powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Garam masala")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Top and tail the cluster beans and remove side threads if necessary.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Wash potatoes and cut into cubes. Cut the tomatoes into cubes: do not peel.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop onion, ginger and garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the oil in a pan and add cardamom, cumin and asafoetida.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When grains splatter, add curry leaves and the chopped onion, garlic, ginger, turmeric and salt, then cook until well browned")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the rest of the spices and tomatoes, stir and fry until oil separates.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add tomatoes and cluster beans and stir-fry for a further few minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add a bit more water and bring to a boil. Turn heat down and add the potatoes. Cover and cook until potatoes are cooked. Stir occasionally to avoid sticking.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Sprinkle with garam masala and serve hot. You can serve this with either dal and chapatti or rice.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor194"
    }
  }), _vm._v("6.3.5 Dried Bean")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor195"
    }
  }), _vm._v("6.3.5.1 Brazilian Feijoada")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer306"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-079.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Feijoada is a traditional Portuguese dish made with brown beans and meat. Feijoada is very popular all over Brazil and when you walk into a restaurant there is most often a big ceramic pot of bubbling brown beans. Recently there has been a fashion for eating the traditional food of slaves, and Feijoada with black beans is the typical case. In fact, the black beans are the most expensive as they cannot be picked by machine.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 8 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("2"), _c('span'), _vm._v("kg Dry black beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Pig’s feet")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Pig’s ears")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("800 g Pieces of smoked pork shoulder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Big smoked sausage, cut into chunks")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Sultana’s")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 kg Rice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1.5 kg Portuguese cabbage, shredded")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Beef stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Oil or fat, for cooking")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cumin")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Thyme")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Sage")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Chilli")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the smoked shoulder of pork overnight. Drain and rinse.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Soak the black beans in water for 24 hours. Drain and rinse a couple of times.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the pig’s feet and ears for one and a half hours. Drain and discard water.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Chop the onions and garlic and put into a heavy saucepan with oil or fat. Cook until soft.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add all meats, stock, spices, herbs and sultanas and cook for 1 hour. Add the drained black beans and cook until tender.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a saucepan, add water and bring to a boil. When boiling, add the rice. The cooking time will depend on what type of rice you choose: check on the packet.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the Portuguese cabbage for 5-8 minutes in salted water and drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve the three dishes in separate bowls. This looks very appetising.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor196"
    }
  }), _vm._v("6.3.5.2 Cassoulet")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-181",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-080.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a typical dish from the South-west of France. It is made with local beans and is traditionally cooked in an earthenware dish with a special shape. The name Cassoulet comes from this earthenware pot.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Dry white beans (usually Tarbes beans)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 g Pork belly")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("400 g Shoulder of pork")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 g Lamb")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Confit of Duck")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 g Pig skin rind")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 g Toulouse sausages")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium carrot")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 g Tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Bouquet garni")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 Cloves")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 ml White wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Goose or duck fat")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Dry breadcrumbs")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the white beans overnight in cold water. Drain and rinse a few times.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pre-heat oven at 150°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop 2 of the onions and garlic. Peel and chop carrot. Slice tomatoes and leave a moment to drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the onions in the fat and when soft add the garlic, tomatoes and white wine. Cook for 10 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the pork and lamb into 3 cm cubes and half the pig skin into slices, about 3 x 2 cm. Peel the last onion and stick this with the cloves.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Take a large saucepan. Add the meat, white beans, carrot, onion with cloves and bouquet garni. Cover with water, check seasoning with salt and pepper and simmer slowly for 2 hours.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Prick the sausages and cook in fat for a few minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Allow the beans to cool. Remove the carrot, the onion with cloves, and the bouquet garni.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Make the Cassoulet. Rub the inside of the earthenware pot with duck fat, cover the bottom part with the pig skin (skin inside). Fill the tin with alternate layers of meat and beans. Finish with the confit and the sausage. Make sure that there is enough liquid and sprinkle with breadcrumbs. Place the dish in the oven and cook for 2 hours. During the second hour remove the dish to break the crust and check the liquid level. At the end of the time, switch to grill to brown the surface.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("The Cassoulet should be served hot with a full-bodied red wine from the South-west of France.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor197"
    }
  }), _vm._v("6.3.5.3 Garbure")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is another typical dish from the French South-West, but in this case the Atlantic side of the Pyrenees. This was a typical peasant food for many years and is basically a stew with whatever is available, but there are certain elements that are always present: potatoes, cabbage, beans and some sort of dried, salted or conserved meat. What we are giving below is not a real recipe but an indication of what can be used, and what perhaps was reserved for Gala days.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 People:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 Cabbage")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Leeks")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Medium carrots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 Medium potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 g Dry white beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Branches of celery")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium turnip")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 tbsp Duck fat")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Sprigs of parsley")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cayenne pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Legs of confit of duck")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("5 Wings of duck confit")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Slice of Bayonne ham")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 Slice of stale bread")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 tbsp Grated cheese (preferably dry sheep’s cheese)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("The day before, soak the white beans in a large quantity of cold water. Drain, rinse and renew a couple of times. Afterwards, drain and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pre-heat oven at 200°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and cut the potatoes, carrots, and turnip into small cubes. Peel and chop onion and garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Clean and cut the leeks and celery into fine slices. Slice the cabbage not too thinly and blanch in boiling water for about 5 minutes. Drain and set aside")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a large pot, cook the leeks, onion and half of the garlic in the duck fat. Simmer slowly for 10 minutes. Stir regularly to avoid sticking.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cover with water. Once boiling, add the vegetables except the potatoes and cabbage, and add the ham. Salt slightly as the ham is probably very salted. Cover and simmer slowly until the vegetables are soft.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When the beans are cooked, add the potatoes and the cabbage.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("At this stage, transfer the Garbure, the duck confit, duck wings. Cover this with all the cooked vegetables. Make sure there is enough water. Cover with the stale bread, push down and sprinkle with the remaining garlic and the grated cheese. Put in the oven and cook until browned.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor198"
    }
  }), _vm._v("6.3.5.4 Chilli Con Carne")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer308"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-081.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is found as a daily dish worldwide. Its origin is widely disputed between Mexico and the southern states of the USA. However, most people seem to agree that Texas was probably the origin.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 kg Chunks of beef")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("400 g Tinned red beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("3 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("3 Large tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("2 Red peppers")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("1 Red chilli")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("3 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("1 tbsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("1 tsp Garam masala with chilli")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("1 tsp Cumin powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("1 l Beef stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop onions and garlic. Peel and chop tomatoes. De-seed and clean red peppers and cut into small strips.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the meat into small cubes. Cut the red chilli into two and remove the seeds, then cut into small pieces.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the olive oil in a heavy saucepan and fry the onion for 5 minutes. Add meat and brown. Add garlic, peppers and tomatoes and cook for a further 5 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add herbes de Provence, spices and red chilli. Stir for a couple of minutes, add part of the stock, check seasoning, cover and simmer for 1 hour.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Wash and drain the red beans.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Check that the meat is cooked, add the red beans, cook for a further 10 minutes to warm the sausages and red beans. Check that the rice is cooked. Season to taste. Serve while hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor199"
    }
  }), _vm._v("Cooking in Louisiana")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The following two recipes illustrate the Cajun cooking of beans in Louisiana. The first, with beans and maize, shows the influence of Pre-Columbian cooking culture; the second is more recent and represents the New Orleans cooking of beans and rice, which inspired a jazz man like Louis Armstrong to finish his letters with ‘Red beans and Ricely’. Beans are indigenous to the southern States of the USA, and African rice came to the area with the slave trade, as the slaves knew how to grow it.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor200"
    }
  }), _vm._v("6.3.5.5 Dry White Beans and Sweet Corn")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Tinned white beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Tinned sweet corn")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 Chicken thighs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Shallot")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Red pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cayenne pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 ml Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Pork dripping")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash and drain the beans and sweet corn. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop garlic and onions. Cut the tomatoes into 4. De-seed and cut the red pepper into squares.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a large saucepan, heat the pork dripping on medium heat. Seal the chicken thighs. Once browned, remove from the saucepan and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In the same saucepan, add the onions and garlic and cook until the onions are soft. Then add the red peppers and cook for 5 minutes. Then add the herbes de Provence, tomatoes, spices and stock. Bring to a boil and simmer for 30 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the beans and sweet corn. Add salt and pepper to taste. Cook for 5 minutes. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor201"
    }
  }), _vm._v("6.3.5.6 Creole Beans and Rice with Sausages")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer309"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-082.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400"), _c('span'), _vm._v("g Tinned red beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("400 g Long grain rice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Large pork sausages")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("75 g Pork dripping")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Green pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Bay leaves")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Ground cumin")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Turmeric Powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1/2 tsp Cayenne Powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Chopped parsley")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("In a frying pan, add 25 g of pork dripping. When it’s very hot, add the sausages. Cook well. When they are cooked, place on a plate and cut into pieces. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop onions and garlic. De-seed and clean green pepper and cut into squares.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Take a heavy-bottomed pan and heat. Add the rest of the dripping and melt. Add onions and cook until slightly transparent. Add green pepper and garlic with the rice. Stir until the rice whitens, then add spices and bay leaves. Stir, then add water progressively until the rice is cooked.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When the rice is cooked, add parsley and sausages, drain the beans and rise them, then add them to the rice. Cook, making sure that the beans and sausages are well cooked. Check seasoning and serve in soup bowls.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor202"
    }
  }), _vm._v("6.3.5.7 Oven Dish with Borlotti Beans and Chorizo")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer310"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-083.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("600 ml Tomato, lightly puréed")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Salted lean pork belly")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Chorizo, mild")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium red onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Red pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium Potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("400 g Tinned borlotti beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("125 ml White wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Oregano")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Chopped parsley")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Branches of parsley")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and slice the onion, peel and chop garlic. Clean and de-seed the red pepper and cut into small squares. Peel the potatoes and cut into slices. Drain and rinse the borlotti beans.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the lean pork into small pieces and slice the chorizo. Then pour the oil into a pan and fry the salted pork and chorizo. Remove the meat and dry on absorbent paper. Remove most of the fat, leaving about 2 tsp.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Replace the pan on the heat. When hot, add onion, garlic and red pepper and cook for 5 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add oregano, potatoes, borlotti beans, tomato purée, stock, wine and the cooked pork and chorizo. Check the seasoning.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook for a further 10 minutes, sprinkle with parsley and serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor203"
    }
  }), _vm._v("6.3.5.8 Savoy Beans with Diots")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-182",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-084.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a typical dish from the French Alps and is made with diots, which are cabbage sausages. These sausages are made from pig’s head, pig’s neck and some lean pork, mixed with 50% cabbage. These sausages are made in the autumn when the pig is slaughtered, and after being made they are air-dried and then smoked. They can be kept all winter.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("750 g Dry white beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Salted lean pork belly, sliced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Diots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the pork for 6 hours. Then drain set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the white beans in unsalted water for 21/2 hours. After 1 hour, add the soaked pork.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Towards the end of the cooking time for the white beans, cook the diots in a frying pan.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("At the end of the cooking time, check that the beans are tender. Season with salt and pepper, and serve on hot plates with a slice of pork and the diots.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor204"
    }
  }), _vm._v("6.3.5.9 Baked Beans On Toast")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer312"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-085.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a dish that is very popular all over the Anglo-Saxon world. It is a main course, a snack or a standby. Generally, it is made with a can of beans, which most people have in their cupboards. The principle is to have a slice or two of English bread, thickly cut and toasted. All the main canned food producers do them. Heat the beans, season and serve on toast.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Should you wish to make your own, here is the recipe for Baked Beans.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Dry white beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Worcestershire sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("450 ml Tomato purée")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("450 ml Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the bean overnight in cold water, drain and rinse. Peel the onions and slice.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Take a heavy pot with a well-fitting lid. Put in the oil and fry the onion until soft but not browned. Add all the ingredients except salt and pepper. Make sure that the beans are covered with stock and cook slowly for about 1 hour. Ensure all along that the beans are covered; if not, add stock or water. The sauce has to have a thickish consistency.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Once the beans are cooked, season with salt and pepper.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve on toasted bread.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor205"
    }
  }), _vm._v("6.3.5.10 Loubia White Beans with Beef and Calf’s Feet")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("A typical North Africa food popular all over North Africa. Sometimes a variation is made with vegetables.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("2 Calf’s feet, cleaned of skin and cut into pieces")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 g Beef neck")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Dry white beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Bunch flat parsley")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Bay leaf")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Paprika powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Beef stock cube")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Harissa")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-183",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-086.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the white beans overnight. Drain and rinse a few times. Peel and chop tomatoes, onions and garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the calf’s feet and lamb neck in a heavy pan. Cover with stock and cook for 45 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add spices, herbs, onion, garlic and tomatoes. Cook slowly for 25 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add lemon juice and white beans. Cook until the beans are cooked, for about 15 minutes. Check water: if need b,e add a bit more as the cooking proceeds. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor206"
    }
  }), _vm._v("6.3.5.11 Stir-Fried Tofu and Vegetables")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer314"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-087.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Firm tofu")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Fresh green beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Green pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Roasted sesame")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Sesame oil")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("For the sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Light soya")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Heavy soya")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Fish sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Corn flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Rice vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("To prepare the tofu: set the oven to 200°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Remove tofu from its packaging and drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Wrap the tofu in a cloth and place between two wooden flat plates. If the cloth gets wet quickly, change the cloth once or twice until there is no further liquid.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When the tofu is no longer losing water, remove from the cloth and place on a sheet of greaseproof paper. Put into the oven for about 30 minutes, turning now and then. Remove from the oven and cut into rectangular blocks of about 1 x 2 cm and allow to continue to dry.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("To prepare the sauce: mix all the ingredients in a bowl.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel the onion and de-seed the green pepper and slice. Cut the green beans into 5 mm slices, about 2 cm long.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the wok on the heat, add the sesame oil and when hot, add the onions, green peppers and green beans. Stir regularly until soft, about 7-8 minutes. Add the sauce until it starts to thicken. Keep stirring and add the tofu. Stir slowly until cooked, then serve sprinkled with roasted sesame.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor207"
    }
  }), _vm._v("6.3.5.12 Stir-Fried Chicken with Cellophane Noodles")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200 g Cellophane noodles")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("600 g Chicken breast")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Red pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Green pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Yellow pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("20 cm Fresh ginger")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Flour")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("For the sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Light soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Heavy soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Rice vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Fish sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cut the chicken into thin slices of 9 cm long. Set aside. Clean and de-seed the peppers and cut onions and peppers into thin slices. Chop the garlic and ginger finely.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("For the sauce, place all the ingredients in a bowl together and mix well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Roll the chicken in flour to coat.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the wok on medium heat, add 2 tbsp oil and when hot, stir-fry the chicken until brown. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the noodles for 1 to 2 minutes in boiling salted water, or as indicated on the packet. Drain and keep warm.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the remaining oil in the wok and cook all the other ingredients until softened but not overcooked. Add sauce and cook until it starts to thicken. Add chicken to heat. Add the cellophane noodles. Serve warm.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor208"
    }
  }), _vm._v("6.3.5.13 Stir-Fried Shrimps and Bean Sprouts")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer315"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-088.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 2 persons:")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("a. For the stir-fry")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("300 g Fresh shrimps")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Green pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 cm Fresh ginger root")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Fresh bean sprouts")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Roasted sesame seeds")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Mixed olive and sesame oil")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("b. For the sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Light soy")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Thick soy")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Rice vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Fish sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Corn flour or arrowroot")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Shell the shrimp. Clean onion, garlic, and ginger. De-seed pepper. Cut the onion and pepper into thin strips of about 2 cm, chop garlic and ginger finely, wash and drain sprouts.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put 1 tbsp of oil in a wok and heat on medium heat. When hot, cook the shrimps. When cooked, set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("For the sauce, put all the ingredients into a bowl and mix together well. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the remaining oil to the wok and when hot, add onion, pepper, ginger, garlic and sesame. When the vegetables start to soften, add the sauce and continue stirring. When the sauce starts to thicken, add shrimps and bean sprouts and stir until the bean sprouts are warm but not cooked: the bean sprouts should be crunchy. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor209"
    }
  }), _vm._v("6.3.5.14 Akra with Dry Black-eyed Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-184",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-089.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Black-eyed beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ Onion (onions cut into large pieces - keep the skin)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("235 ml Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Chilli sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the black-eyed beans in water for 2 hours until they are soft. Drain and rinse a few times.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the black-eyed beans in water and soak for 2 minutes. Drain after a few minutes, wash the black-eyed beans and drain. With your hands, rub the beans together so that the skins come away. Take away the skins.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Repeat the above three or four times. The idea is that when you have finished, you have no skins left.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a mixer, add black-eyed beans, onions and water. Mix until you have a purée consistency. Salt to taste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Mix the purée well to get some air into the mixture.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat a deep fat fryer. When the oil is hot, add the onion skins. Then add the purée with a spoon, to form balls. Cook until golden. Place on absorbent towelling to get rid of any oil.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve warm with a chilli sauce.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor210"
    }
  }), _vm._v("6.3.5.15 Akra with Black-eyed Beans")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer317"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-090.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("For the dough")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Black-eyed bean flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("¼ Salted water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 pkt Bread yeast")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Large onions")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("For the sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic (Crushed)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Tomato purée")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp White vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Chilli")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("A few springs of parsley to decorate")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Mix the black-eyed bean flour, water and yeast together. Peel and chop finely the onions then add to the flour mixture. Cover the bowl with a cloth and set aside for 1 hour. It will double its size.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("De-seed chilli and cut finely. In a saucepan, add oil and heat. Add tomato purée, salt pepper and garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Let this cook slowly. When it’s cooked, add white vinegar and chopped, de-seeded chilli. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat a frying pan. When it’s warm, make small balls with the flour mixture using a spoon.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook till they are golden brown, then serve with the sauce. Sprinkle with parsley.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor211"
    }
  }), _vm._v("6.3.5.16 Cornbread and Beans")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer318"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-091.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a very popular dish from the southern states of the United States. Cornbread is made from maize, but maize is called ‘corn’ in America so we have kept the name cornbread. The history of cornbread goes back a long way, to the time that the Maya and Aztec were making maize tortillas. North of the Rio Grande (the present-day Mexican frontier), the American indigenous people like Cherokees and others were cultivating beans and maize and making an early form of cornbread which was served with beans. The dried maize was stone-ground and mixed with water into a thick pourable paste that was cooked on hot stones and cinders on the campfire. This fairly hard disc was eaten with beans and with what was available: meat, fish or animal fats. It was nourishing and was the staple food of these tribes.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("With the arrival of immigrants and slaves, both adopted cornbread as a basic food and many attempts to improve it were made by adding wheat flour, butter, buttermilk and eggs. However, the cornbread was always heavy. At this time, the cornbread was called hoe bread as it was cooked in the blade of a gardener’s hoe, in the same way as you would use a saucepan on an open fire. The big change came in 1840 with the discovery of baking powder by the American Alfred Bird, because it could be used to raise gluten-free products like cornbread. The product was commercialized in 1850.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("We will give a recipe of the cornbread and beans that is representative of traditional Southern cooking.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("For the cornbread")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("100"), _c('span'), _vm._v("g Corn flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Polenta")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 ml Peanut oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Bicarbonate of soda")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("45 ml Milk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Egg, slightly beaten")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat oven at 200°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a bowl, mix together corn flour, polenta, salt, bicarbonate of soda and baking powder. Mix well. Gradually add the beaten egg and milk, making sure you obtain a pourable paste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat a cast iron skillet, then add the peanut oil when very hot. Pour the paste into the skillet and cook in the oven for 20-25 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When the cornbread is cooked, serve it with the pinto beans mixture shown below. Serve warm.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("For the pinto bean’s mixture")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 kg Pinto beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2  Rashers of bacon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Bay leaves")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash the beans and soak overnight. Drain and rinse well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel the onion and garlic. Chop the onion and crush the garlic. Cut the bacon into squares.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a heavy-bottomed saucepan, fry the bacon until crispy. Add onion, garlic and bay leaves. Add a little water and cook for 5 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Drain the beans, add to the saucepan and cover with water. Cook slowly for about 1 hour. Add salt and pepper. Check cooking and if ready, set aside and keep warm.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor212"
    }
  }), _vm._v("6.3.6 Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor213"
    }
  }), _vm._v("6.3.6.1 Lentils with Herb Sausages")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer319"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-092.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("6 Herb sausages")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium carrot")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Bay leaf")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Spring of thyme")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Chicken stock cube")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Knob of butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper grains")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop the onion. Peel the carrot and cut into discs.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the butter in a saucepan. When hot, cook the onions and carrot for 5 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add lentils, chicken, stock cube, salt and pepper grains. Cover with two volumes of water and cook for 35 minutes")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pierce the sausages, add them to the pan and cook further 25 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Five minutes before the end of the cooking, adjust the seasoning.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor214"
    }
  }), _vm._v("6.3.6.2 Beef Sausages with Lentils")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer320"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-093.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("For the lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("450 ml Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Large tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Branches of celery")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Paprika powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("For the sausages")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Minced meat")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("50 ml Red wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("1 tsp Paprika powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("1 tsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("4 Sheets of cotton, 20 cm x 20 cm")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop garlic. Peel and skin tomatoes then cut into small pieces. Chop the celery into small pieces.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat olive oil in a saucepan. Add garlic, tomatoes, paprika and celery. Fry until the juice starts to reduce. Add the lentils and a little of the stock. Bring to a boil and simmer. To avoid the lentils breaking up, add water as necessary. Cook for about 15-20 minutes. Check seasoning. Set aside and keep warm.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a bowl, mix together all the ingredients for the sausages. Roll into 4 cylindrical forms. Place each sausage shape onto the cloth, then roll the cloth and tie with string, making sure they are well sealed.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a saucepan, put the sausages in, then add water to cover. Bring to a boil and simmer for 20 minutes. Take the sausages out from the water with a ladle. Let them cool down, then unwrap them.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a frying pan add oil and heat. When hot, cook the sausages, making sure they are nice and brown on all sides and cooked through.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve the sausages with the lentils.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor215"
    }
  }), _vm._v("6.3.6.3 Wild Duck with Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 2 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 Wild duck")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Small white cabbage")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 Juniper berries")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Paprika")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat oven at 180°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop the onions and garlic. Cut the cabbage into 4, then into slices.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the cabbage into a saucepan, cover with water and add half the garlic, salt and pepper. Cook for 10 minutes. Drain the cabbage, keeping the liquid back. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Mix the cabbage with a little salt and the juniper berries. Clean the duck, then stuff with the cabbage mixture. Close the duck using cocktail sticks to keep it together. Rub the duck with olive oil, herbes de Provence and paprika. Place the duck in a casserole dish add a bit of water. Cook for 30-40 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a large pan, heat the oil. When hot, add the rest of the garlic and onions. Fry them till they start to soften and turn a bit brown. Then add the lentils and reserved liquid from the cabbage. Simmer for 20 minutes, making sure it does not dry out.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When the duck is cooked, cut it in half and serve with the lentils.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor216"
    }
  }), _vm._v("6.3.6.4 Lentils with Fresh Pasta")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-185",
    attrs: {
      "alt": "C:\\Users\\Mr STRIBLING\\Documents\\Peas & Beans Book 30.7.18\\Recipe photos  13.7.2018 us\\PIC_0331.JPG",
      "src": "image/Stribling-6-094.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a typical Southern German dish, originally for poor people: lentils and flour are cheap and easy to conserve. It is also very nutritious, with a high protein content. Today the dish is popular worldwide.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8",
    attrs: {
      "lang": "fr-FR",
      "xml:lang": "fr-FR"
    }
  }, [_c('span', {
    staticClass: "CharOverride-15",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("For the lentils")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("5 Slices thick cut bacon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Large yellow onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Carrot")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Leek")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1.2 l Beef stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Bay leaf")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("¼ tsp Ground pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 ml White vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Chopped fresh parsley")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method for the lentils:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cut bacon into slices and peel and dice finely the onion. Finely slice the carrot and leek.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat half the olive oil in a saucepan. When hot, add the sliced bacon. When the bacon is well-cooked, take it out of the saucepan and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In the same saucepan, add the rest of the olive oil. Cook the onions until transparent, about 5-7 minutes, then add butter, carrot and leek. Cook for 5 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add lentils, stock, bay leaf, salt, pepper, sugar, vinegar and parsley. Cook for 10-15 minutes; add extra stock if too thick. Check to see if the lentils are cooked.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve with fresh pasta (see below).")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("For the fresh pasta")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Plain flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("5-6 Eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Pinch of nutmeg")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Mix all the ingredients in a bowl to obtain a firm paste. If the paste is too hard, add another egg.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Roll the paste to a thickness of about 5 mm. Cut into 5 mm-wide strips and thin lengths of about 2 cm.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the pieces in boiling salted water. When they rise to the surface, they should be removed, cooled under cold water and allowed to dry.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the butter in a frying pan. When it’s hot, add the fresh pasta and fry until golden-brown.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor217"
    }
  }), _vm._v("6.3.6.5 Rice with Lentils ‘Mujadara’")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a typical dish with lentil from the Middle East. It is eaten in most countries and is a dish with lentils and rice and generally some type of meat.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200 g Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Round rice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Ground cumin")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Garam with chilli")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 Cardamom pods")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Peppercorns")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Pine nuts")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Yoghurt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash and drain the lentils. Crush the peppercorns and cardamom pods in a mortar.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the lentils in three times their volume of water with a little salt until they start to soften. Check cooking time on the packet, as this varies depending on the lentils. When cooked, drain and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and slice onion, chop the garlic finely. Put half the oil in a heavy pan and cook the onion until browned. Add garlic and all the spices cooked further minute and set half aside on absorbent paper. Pour the rest of oil and onion into the pan with the lentils.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the rice with about twice its volume of water. Bring to a boil and simmer for 5 minutes, then add the lentils and pine nuts. Continue cooking until the rice is cooked; add water if necessary. When the rice is cooked, the water should all have disappeared.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Allow the dish to stand some minutes before serving. Serve in bowl, adding the warmed onion and a large spoonful of yoghurt.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This recipe is inspired by a meal prepared in the desert by Yemeni friends. Of course, in the desert there are no onions or yoghurt, but it was good served with grilled lamb.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor218"
    }
  }), _vm._v("6.3.6.6 Confit of Duck with Lentils")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer322"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-095.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("4 Legs of duck confit")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Duck fat")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("16 Small potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("8 Shallots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cumin powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat oven 180°C. Peel and chop the onions and garlic, peel the potatoes and shallots.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the duck fat into a saucepan and heat, add the duck legs until browned and set aside and keep warm.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat half of the olive oil in a saucepan. Then add the chopped onion and garlic to the pan with the cumin, salt and pepper, cook until the onion softens, add lentils and cover with stock, stir and cook slowly adding stock as the water is absorbed until the lentils are cooked. Keep warm.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the potatoes and shallots in a roasting tin. Add the rest of the olive oil, salt and pepper and the herbs. Place the leg of duck confit on top. Place in the oven and cook for 30 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve as shown in the photograph.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor219"
    }
  }), _vm._v("6.3.8 Peanuts")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor220"
    }
  }), _vm._v("6.3.8.1 Beef with Peanuts and Noodles")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("700 g Fillet steak")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Sesame oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Transparent noodle")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Lime juice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Grated lime peel")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Fish sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Corn flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Peanuts")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop onions and garlic. Slice beef steak into thin strips.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a saucepan, cook the noodles in salted boiling water for 1 minute. Drain and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a bowl, mix together the sauce with soy sauce, fish sauce, lime juice and corn flour. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a wok, heat both olive and sesame oil. When very hot, add the beef strips. When they are sealed, take them out of the pan and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In the same wok, cook the onions and garlic until they start to soften and turn brown, then add the beef strips and the sauce. Cook for a further 2 minutes, making sure the sauce does not stick. Then add the noodles, stirring well. Just cook till the noodles have reheated. To serve, sprinkle with the peanuts.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor221"
    }
  }), _vm._v("6.3.8.2 West African Pork with Beans in Peanut Sauce")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer323"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-096.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Lean pork")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Tinned red beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Tinned sweet corn")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Collard greens")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Chorizo")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Red onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("70 g Tin tomato purée")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Peanut butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Peanut oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Chilli powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cumin")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cut the pork into cubes and chorizo into slices. Cut the collard greens into 2.5 cm strips. Peel and chop onion and garlic. Peel potatoes and cut in half. Drain and rinse red beans and sweet corn.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the peanut oil into a saucepan and heat. Cook the onions and garlic. When they start to soften, add pork pieces and cumin. Cook for 10 minutes. Add the chorizo and cook for a further 3 minutes. Set aside and keep warm.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the potatoes in salted water, boil for 10 minutes then add the red beans and sweet corn and cook for a further 10 minutes. Then drain the potatoes and beans.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a wok, add tomato purée, peanut butter and chilli powder, then mix well. Heat, stirring to get a smooth paste, then add potatoes, beans and collard greens. Adjust the seasoning and cook for 5 minutes. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor222"
    }
  }), _vm._v("6.3.8.3 Fish with Dried Peppers Sichuan Pepper and Peanuts")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer324"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-097.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("A. For the marinade and fish:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g White fish")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Egg white, slightly beaten")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("¼ tsp Ground pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Corn flour")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("B. For the sauce:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Chinese chilli bean sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp White rice vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Corn flour")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("C. For the stir-fry:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("400"), _c('span'), _vm._v("ml Peanut or vegetable oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("4 Spring onions cut in 2.5"), _c('span'), _vm._v("cm lengths")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("19-15 Dried chilli peppers, cut in half and de-seeded")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("4 Cloves of garlic, minced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("2 tsp Sichuan pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("100 g Roasted peanuts")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("A. For the marinade and fish")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Put the fish in a large bowl. Add all the other ingredients and mix together with your hands until all the fish is covered. Allow to stand 15 minutes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("B. For the sauce")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("In a bowl, mix all the ingredients together and set aside.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("C. For the stir-fry")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Divide the fish into three. Put half the oil in the wok and heat. Add one portion of fish and stir carefully until browned on both sides, then place on absorbent paper. Do the same with the other portions. Keep warm.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("To prepare the wok for stir-fry, discard oil, add water and bring to a boil, scrape with a spatula and empty. Dry the surface with an absorbent paper towel.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the rest of the oil in the wok, heat until smoking. Add spring onions, dried chilli, garlic and Sichuan peppers until the garlic is golden: about 30 seconds. Add sauce and cook until sauce thickens, then add fish and toss lightly. Transfer fish to a plate, sprinkle with the roasted peanuts and serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor223"
    }
  }), _vm._v("6.3.8.4 Spicy Lamb and Peanut Sauté")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-186",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-098.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a typical West African dish.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("2 tbsp Peanut oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("700 g Lamb shoulder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Large onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Tinned tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("¼ tsp Cayenne pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 ml Beef stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 ml Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Chunky peanut butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Carrots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Jalapeño peppers")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Shelled peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("400 g Cooked rice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cut the lamb into 2.5 cm cubes. Peel the onion and chop coarsely, dice the carrots and remove the seeds from the jalapeño peppers.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat peanut oil in a heavy-bottomed pan, over medium heat. Add lamb and onions and cook until the lamb is browned. Stir occasionally and cook for 6 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Season, then add tomatoes, stock and water and simmer until the lamb is tender: about 1 hour and 20 minutes. In a steamer, place the rice to re-heat.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Stir in the peanut butter. Add carrots, jalapeño peppers and cayenne pepper and cook until carrots are tender. Add peas and cook until they are cooked.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Remove jalapeño peppers, as they are very hot. Serve on hot rice.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor224"
    }
  }), _vm._v("6.3.8.5 Chard, Sweet Potato and Peanut Stew")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("2 tbsp Vegetable oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Large onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cumin seeds")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("400 g Sweet potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Crushed chilli flakes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("400 g Tinned tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("140 g Salted roasted peanuts")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Chard leaves")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop onion. Peel and cut sweet potatoes into large chunks. Wash the chard leaves and cut into two.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the vegetable oil in a pan with lid and heat on medium heat. Add onion and cook until browned. Stir in cumin seeds until fragrant: about 1 minute, Add sweet potatoes, chilli flakes, tomato and 750 ml water. Bring to a boil and simmer for 15 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Blend the peanuts in a processor to obtain a lumpy peanut butter. Add to the stew and stir. Check seasoning, then simmer for 15 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add chard leaves. Stir and simmer for 10 minutes, until the chard is cooked.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Season to taste and serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor225"
    }
  }), _vm._v("6.3.8.6 West African Chicken Peanut Stew")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-187",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-099.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("2 tbsp Peanut oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Chicken drumsticks")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Chopped ginger")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cayenne pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1.2 L Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Small sweet potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Tinned tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Collard greens")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Peanut butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop onion, garlic and ginger. Peel and cut sweet potatoes. Roughly chop the collard greens.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the peanut oil into pan on medium heat. Add onion, garlic and ginger. Stir until soft, then add chicken drumsticks and stir until browned.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Season with salt and peppers and cayenne. Add the stock, bring to a boil and simmer for 5 minutes. Add tomatoes, collard greens and peanut butter. Partly cover and simmer for 20 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve hot with rice.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor226"
    }
  }), _vm._v("6.3.8.7 Mafe Senegalai with Two Meats")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 persons:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1.2 kg Stewing beef")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("600 g Lean pork")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("5 Tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Beef stock cube")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Large onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Peanut paste")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Vegetable oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Dijon Mustard")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop the onion. Cut the pork and beef into 3 cm cubes. Cut the tomatoes into 4.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook onion and meats in the oil until they are browned.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add tomatoes, beef cubes and Dijon mustard and cover with water.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Simmer 3 hours on low heat; the meat should be tender. Make sure it does not dry out. If necessary, add some water.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Mix the peanut paste and cook a few minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Check seasoning and serve on plain rice.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor227"
    }
  }), _vm._v("6.4 Side Dishes")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2-first"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor228"
    }
  }), _vm._v("6.4.1 Peas and Mangetout")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Peas and mangetout are often served just boiled or steamed. The important thing is not to overcook in order to have a crunchy and tasty dish, which will also avoid destroying the vitamins and other nutrients. The peas should be boiled the minimum time, and the cooking can be stopped by rinsing the peas in cold water. The exact cooking time is difficult to fix as it will depend on the variety and age of the peas. The best thing to do is to watch and check the cooking.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor229"
    }
  }), _vm._v("6.4.1.1 Fresh Peas with Lean Gammon")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("4 Thick lean slices of gammon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium red onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Fresh peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("400 g Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Plain flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ l Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cut the gammon into 5 cm slices. Peel and slice the onions.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put ½ the amount of butter in a frying pan. Cook the onions and gammon until they are brown: about 20 minutes. Set aside and keep warm.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a saucepan, melt the butter, gradually adding the flour, then add the stock a little at a time, making a smooth sauce.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the peas to the sauce. Season to taste. Cook for about 10 minutes. Serve the pea sauce on top of the onions and gammon.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Mushy peas ")]), _vm._v("are very similar to "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Pease pudding")]), _vm._v(" (see "), _c('a', {
    attrs: {
      "href": "#/STRIBLINGLadyBeanPrelimsall_in_one_without_Hlinks_#_idTextAnchor055"
    }
  }, [_vm._v("page 135")]), _vm._v("), but the taste is very different.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor230"
    }
  }), _vm._v("6.4.1.2 Mushy Peas")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer327"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-100.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a traditional British dish generally served with fish and chips.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Marrow fat peas, dried peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("10 ml Full cream")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the peas in water for up to 12 hours, then drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the peas in salted boiling water until soft.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the peas, butter and cream into a blender and process, leaving small pieces of peas. Season and serve warm.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Today, mushy peas are often made with fresh or frozen peas. However, the taste is not the same.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor231"
    }
  }), _vm._v("6.4.1.3 Pea Fritters")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-188",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/shutterstock_407630140.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 fritters:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200 ml Pease pudding mixture (see recipe, "), _c('a', {
    attrs: {
      "href": "#/STRIBLINGLadyBeanPrelimsall_in_one_without_Hlinks_#_idTextAnchor055"
    }
  }, [_vm._v("page 135")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 ml Bread crumbs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop onions.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Mix onions, herbs salt and pepper with the pease pudding mixture.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the breadcrumbs bit by bit; while mixing to obtain a stiff dough, the consistency will vary depending of the quantities of crumbs you use.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Once that the consistency is correct, form into 4 cakes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Flour the cakes and fry in a pan until well browned.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor232"
    }
  }), _vm._v("6.4.1.4 Green Peas with Capers and Braised Chicory")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer329"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-103.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("4 Chicory")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Shelled peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Capers")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Clean the chicory and cook in boiling water for 8 minutes, then drain. Cut the chicory into two and put into a heavy pan with 1 tbsp oil. Cook slowly until browned, then keep warm.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Boil the peas for about 5 minutes in lightly salted water, then drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Chop the onion and garlic and cook in a pan with the remaining oil until softened.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the herbs, capers, peas and season to taste. Stir for 2 minutes and then mix well. Pour the sauce over the chicory before serving. Note that this side dish goes well with roast meat.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor233"
    }
  }), _vm._v("6.4.1.5 Mangetout with Sesame")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-189",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-104.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Mangetout")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Red pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Sesame seeds")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Blanch the mangetout in lightly salted water for 3 minutes and drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel onion and garlic, de-seed pepper, chop onions and garlic and cut pepper into strips. Cook with oil in a heavy pan. Once the vegetables start to soften, add pepper to pan. Cook for 5 minutes and add the peas and sesame seeds. Stir for a further 2 minutes. Check seasoning and serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor234"
    }
  }), _vm._v("6.4.1.6 Mangetout Sautéd with Shallots")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 2 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200 g Fresh mangetout")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Big shallots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Chopped fresh coriander")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop the shallots. Trim the mangetout and cut into 2 cm lengths.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat a pan with the oil. Add shallots and cook over a moderate heat for about 30 minutes, until the shallots are browned.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the cut mangetout and coriander. Season and cook while stirring 5 minutes. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor235"
    }
  }), _vm._v("6.4.1.7 Mangetout with Carrots")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer331"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-105.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200 g Mangetout")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Carrots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Chopped basil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Remove the stem and string from the mangetout and cut into 3. Clean the carrots and cut into 1/2 cm discs.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the carrots in boiling salted water for about 5 minutes until they start getting tender. Add the mangetout and cook a minute more, then drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the chopped onion and garlic in a pan with the olive oil until soft. Season, then add the mangetout and carrots, stirring. Add the basil, stir for 1 minute and serve warm.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor236"
    }
  }), _vm._v("6.4.2 Broad Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor237"
    }
  }), _vm._v("6.4.2.1 Plain Boiled Fresh Broad Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Broad beans are often served simply boiled. The only problem is the skin. If young, the skin can be left on; however, if they are not young or fresh the skin must be removed as it is hard and does not taste good. Beans should not be overcooked and can be improved with a little butter or olive oil. They can also be mixed with chopped garlic, onion, parsley, coriander or mint to taste.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor238"
    }
  }), _vm._v("6.4.2 Broad Beans and Tomatoes")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer332"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-106.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Pre-cooked broad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Tomatoes type Roma")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Ground cumin")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 ml White wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop garlic and onions and skin the tomatoes. Slice the tomatoes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the oil in the pan and soften the onions. Add garlic, tomatoes, herbs and cumin. Simmer until they get a little dry. Add white wine and simmer for 5 minutes. Add the broad beans and season with salt and pepper. Cook to warm the beans. Add a little water if too dry.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor239"
    }
  }), _vm._v("6.4.3 Chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Over the last fifty years chickpeas have become popular in many parts of the world.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The chickpea is a very versatile food and can be used in so many ways. Typically, a can of chickpeas, simply opened, drained and served with lemon juice and olive oils is a very acceptable snack. If using dried chickpeas, these would have to be soaked for 24 hours, then drained and cooked.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor240"
    }
  }), _vm._v("6.4.3.1 Chickpeas with Tomato and Harissa")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-190",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-107.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a popular dish from North Africa and is often served with couscous or tagine dishes.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people: ")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Cooked chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Tomato confit")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Harissa")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 ml Vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash and drain the chickpeas.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop onion and garlic. Chop the tomatoes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the oil in the pan and heat. Add onions and garlic and cook until the onions are soft. Add tomatoes, harissa and the stock. Heat for a few minutes and add the chickpeas. Check the seasoning to taste and serve warm.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor241"
    }
  }), _vm._v("6.4.3.2 Chickpeas with Peppers")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer334"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-108.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500"), _c('span'), _vm._v("g cooked chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Red Pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Green pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Piece Ginger, about 2 cm")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Masala with chilli")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 ml Walnut wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 ml Vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash and drain the chickpeas.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop onion. De-seed peppers and cut in large portions.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel garlic and ginger and finely chop.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the oil in a flat pan and heat. Add onions, peppers, garlic and ginger, and cook until the onion is soft.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add herbs and spices. Stir and deglaze with the walnut wine. Simmer for a few minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the stock and chickpeas. Stir and check seasoning before serving.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor242"
    }
  }), _vm._v("6.4.3.3 Chickpeas and Spinach")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 2 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Cooked chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Spinach")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cumin")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Sumac")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("10 g Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Lemon for garnish")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash and drain the chickpeas.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Wash and chop spinach, then put it in a saucepan. Add a bit of water, salt and butter. Cook for 1 minute and drain. Retain the liquid.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the oil in a pan. When hot, add and cook the sliced onion and when soft add spices, salt and pepper. Add the chickpeas and spinach and the spinach water you retained. Cook for a further 2 minutes, stirring. Serve hot with wedges of lemon.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor243"
    }
  }), _vm._v("6.4.3.4 Galettes of Lentils and Chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-191",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-109.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Orange lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Onions, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Curry powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Tin (420 g) chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Fresh ginger, grated")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Egg")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tsp Chopped parsley")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Chopped coriander")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("180 g Breadcrumb flour")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cook lentils in a large casserole in salted boiling water, just till they are tender.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the oil in a frying pan. Cook the onions until they are golden, and then add the curry powder. Cook for a further minute.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Drain the chickpeas. Mix chickpeas, half the lentils, ginger, egg and the onions together. Put in a blender and mix for about 20 seconds. Put the blended mixture into a large salad bowl.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add to the blender mixture the rest of the lentils, plus the parsley and coriander. This gives the galettes a bit of texture.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Divide the mixture into 10 portions, and then make them into round flattened balls. Put in the fridge for about 15 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Using the breadcrumb flour, flour the galettes before cooking.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat some oil in a frying pan. When the oil is hot, cook the galettes for a few minutes on each side till they are golden. You can also cook these galettes on the barbecue or under a grill.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor244"
    }
  }), _vm._v("6.4.4 Fresh Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-192",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-110.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor245"
    }
  }), _vm._v("6.4.4.1 Boiled Fresh Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("One of the lost popular ways of serving fresh beans is boiled or steamed. The important thing is to boil them slightly in salted water and to be careful not to overcook them, so that the beans keep some texture, are still crunchy and keep most of the nutrient value.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor246"
    }
  }), _vm._v("6.4.4.2 Boiled Beans with Onions and Garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Tinned red kidney beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Packet of fresh parsley")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop the onions and garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Wash, dry and chop the parsley finely.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the oil in a pan. When hot, add the onion and cook for 5 minutes. Add garlic and parsley, stirring. Add red kidney beans and serve as soon as it’s hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor247"
    }
  }), _vm._v("6.4.4.3 Beans and Beans")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer337"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-111.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This dish is a mixture of fresh beans and cooked dry beans and is always a great success. In fact, with the diversity of colours of both types of beans, it is always good to look at.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Fresh flat green beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Tinned red kidney beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("10 Shallots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Masala with chilli")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cumin")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 ml Dry Sherry")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash and prepare the green beans and cut into a suitable form.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel the shallots and chop into large slices.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop the garlic finely.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Wash and drain the red beans.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the green beans in slightly salted boiling water until tender but crunchy, then drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the oil into a flat pan and heat. Cook the shallots until soft, then add garlic, herb and spices, stirring. Add the sherry and cook for 2 minutes. Add the beans and kidney beans. Cook for a further few minutes, making sure that the beans are hot. Serve as soon as it’s hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor248"
    }
  }), _vm._v("6.4.4.4 Green Beans with Tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Fresh beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Tomato purée")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Parsley")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash and drain beans and cut into 5 cm lengths.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the tomato purée into a pan. Add olive oil and crushed garlic, then season and bring to a boil. Add beans. Lower heat and simmer slowly for 20 minutes or until tender.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve with parsley.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor249"
    }
  }), _vm._v("6.4.4.5 Green Bean Relish")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer338"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-112.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 3 average pots:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 kg Dwarf beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Large onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Red peppers")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("750 ml Wine vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp French seeded mustard")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("30 g Corn flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Turmeric powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Masala, with or without chilli")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("120 g Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel the onions and cut into fine slices. Clean and de-seed peppers and cut into thin strips and then into 2 cm lengths. Top and tail the beans and cut into 3 cm lengths. Peel the garlic and chop finely.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the beans in salted water for about 3 minutes: they should remain crunchy. Drain, cool in cold water and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put half the vinegar in a saucepan with the onions and garlic. Bring to a boil and simmer for 5 minutes. Add the red peppers and simmer for another 10 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("While cooking the onions, make a sauce in a bowl with the French seeded mustard, turmeric, corn flour, masala and a small amount of vinegar, being careful to avoid lumps. Add the sauce to the saucepan and mix together well. Add sugar, salt and most of the vinegar. Allow to cook for about 2 minutes, then add the beans and cook a few minutes longer. The paste should be consistent; if too dry, add a little more vinegar. Allow to cool.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the relish into glass pots and store in the fridge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This relish goes well with smoked salmon and cheese.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor250"
    }
  }), _vm._v("6.4.5 Dry Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor251"
    }
  }), _vm._v("6.4.5.1 White Lima Beans Sauté with Coriander")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer339"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-113.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 3 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Tinned white lima Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Large shallots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cumin powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 ml White wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Bunch of fresh coriander")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash and drain the beans.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel the shallots and cut into rings, peel and chop garlic, chop coriander.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the oil in a pan and cook shallots until soft. Add salt, pepper, cumin and white wine. Cook for a few minutes to reduce wine and add beans with the coriander. Stir, then serve when hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor252"
    }
  }), _vm._v("6.4.5.2 Kidney Beans with Peppers")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer340"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-114.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Tinned kidney beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Red peppers")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Green pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cumin powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Garam masala")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 ml Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash and drain the beans. Peel and chop onion and garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("De-seed and clean the peppers and cut into fine strips.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the oil in a pan. When hot, add onions and garlic. Cook until transparent, then add spices, chicken stock, salt and pepper. Bring to a boil and add the peppers. When the peppers have softened, add the beans. Check seasoning, add stock if necessary, and stir. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor253"
    }
  }), _vm._v("6.4.5.3 Beans and Sauerkraut")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer341"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-115.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Pre-cooked sauerkraut")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Tinned white beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Salted pork belly")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Large red onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Garam masala with chilli")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 ml White wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and cut the onions into half moon slices. Peel and chop the garlic. Slice the pork belly.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the oil in a pan. Add onion and cook until the onions start to soften. Add garlic, herbs and garam masala and stir. Add white wine and pork belly and cook until the wine has partly evaporated.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add beans and sauerkraut. Cook for a further 2 minutes, stirring. Add water if dry. ")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Transfer to an oven dish and cook for 20 minutes in an oven at 180°C or until slightly browned.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor254"
    }
  }), _vm._v("6.4.5.4 Dry Black Beans with Potatoes and Bok Choy")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 2 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200 g Dry black beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Cooked sauerkraut")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Bok choy")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Ghee")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Vegetable oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cumin powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Paprika, mild")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 ml White wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash the beans and soak overnight. Drain and rinse. Cook the beans very slowly in salted water for 30-40 minutes. Keep an eye on the cooking as it will depend on variety and age of the beans. The beans should be cooked but still keep their form.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel the potatoes. Cut Bok choy in 1 cm slices. Peel and chop the onions.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the potatoes in salted water. When they are cooked, remove, then lightly cook the Bok choy for 1 minute. Remove and drain, keeping the stock. Cut the potatoes into small squares.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the ghee in the oil. When hot, add the onions, cook until softening add white wine, herbs and spices. Cook for a further minute. Add beans, potatoes and Bok choy, plus a little of the retained stock to keep the dish fairly wet. Cook a minute while stirring. Transfer to an oven-proof dish and cook in an oven at 180°C for 20 minutes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("NOTE: This dish can be made with other crucifers such as mustard, cabbage and Brussels sprouts.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor255"
    }
  }), _vm._v("6.4.5.5 Refried Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-193",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-116.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a classical Mexican dish which is popular in the southern states of the U.S. and to a lesser extent all over the world.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Dry black beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Lard/dripping")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Smoked paprika")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop onions and garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Wash and check beans. Put them in a large saucepan with the herbs, salt and pepper and onions and garlic and cover with about 5 cm water. Bring to a boil and cook covered for 80 minutes or until soft.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Drain and keep the cooking liquid.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Return the beans to the saucepan and mash the beans with a potatoes masher to obtain a smooth but slightly lumpy paste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the lard/dripping in a heavy-bottomed pan and when hot add the bean paste and smoked paprika. Keep stirring until the paste is thick and hot. Add the liquid in small quantities if necessary.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor256"
    }
  }), _vm._v("6.4.6 Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-194",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-117.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor257"
    }
  }), _vm._v("6.4.6.1 French Lentils with Pork Belly")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Dry lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Pork belly")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Large onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("10 ml Dry white wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Oregano")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash the lentils and check that there are no stones. Cut the pork belly into small squares and chop onion and garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the oil in a pan and heat add pork and onions and cook until the onion is soft, and the pork a little bit crispy.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add garlic, salt and pepper, oregano and the white wine once boiling add the lentils and cover with water.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Reduce the heat and simmer slowly, the lentils must be cooked very slowly in a minimum of water, so it is necessary to add water in order to avoid the lentil breaking up.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("The cooking time will vary on the lentils keep checking them.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor258"
    }
  }), _vm._v("6.4.6.2 Black Beluga Lentils with Rice")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200 g Long grain white rice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Beluga lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Large shallots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Red pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cumin powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 ml Dry white wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("In a saucepan, add water and salt and bring to a boil. Add the rice and cook for 9 minutes. Drain and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop the shallots. Clean the red pepper and cut into small slices.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the oil in a heavy pan and heat. Once hot, add shallots and pepper and fry until the shallots soften. Add herbs and cumin. Stir, then add the white wine. Once hot, add lentils, cover with water and reduce the heat to a low simmer.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Stir carefully and add water as necessary; the cooking time will be about 10-15 minutes. Follow closely, adding water as necessary. Just before the end, add the rice. Check seasoning with salt and pepper and allow the last water to be absorbed. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor259"
    }
  }), _vm._v("6.4.6.3 Brown Lentils with Swiss Chard and Za’atar (Spices)")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200 g Fresh Swiss chard")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 g Brown lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Za’atar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Za’atar is a mixture of marjoram, sumac and sesame seeds. It is very popular in the Middle East and North Africa.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash the Swiss chard and remove the green leaves. Cut the white pieces of Swiss chard into large pieces and cook in salted water until very slightly cooked and still firm. Drain and set aside. Keep the water, then use this to cook the leaves. Cook for 5 minutes. Drain and add to the white chard pieces.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Wash and check the lentils. Peel and chop onion and garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the oil and cook the onions until soft. Add the garlic and za’atar with a little water and bring to a boil. Add the lentils and cover with water. Return to the boil, then reduce the heat and simmer for 10-15 minutes until cooked, adding water as necessary.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When the lentils are cooked, add the white pieces and leaves of chard and season with salt and pepper. Reheat before serving.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor260"
    }
  }), _vm._v("6.4.7 Lupins")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The name sweet lupin is given to different varieties from the normal European lupin that is bitter and requires long preparation. The sweet lupin defines the newer varieties of lupin that have been developed and produce a lupin that is not bitter. The use of lupins, beans, flakes or flour is very interesting for vegetarian, low carb and gluten-free cooking, as the lupin has a very high protein and very low carbohydrate content. Lupin flour can be used in part for a lot of pasta dishes except for fresh pasta of the tagliatelle or spaghetti type, the reason being the lack of texture of the lupin flour when cooked. For this reason, it can only be used at 10-15% in thin pasta and therefore does not represent a significant reduction in carbs.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-195",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-118.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor261"
    }
  }), _vm._v("6.4.7.1 Low Carb Spätzle")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("100 g Lupin flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Wheat flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1/ 2 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Sunflower oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("14 cl Water")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Mix the flours and salt together.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Beat the eggs and gradually add to the flours to give a smooth paste. Then gradually add the water.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put a large saucepan of salted boiling water. When the water boils, add the paste slowly with a spätzle press to the boiling water. When the spätzle rise to the surface, allow them to cook for about 3 minutes, then remove with a perforated spoon and allow to drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When the spätzle are cold, they can be fried in the sunflower oil until browned and served. If not used immediately they should be refrigerated.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("You can replace the wheat flour with chickpea flour. It also gives a nice taste.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.4.7.2 Low Carb Gnocchi with Herbs")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-196",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-119.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("600 g Floury potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Wheat flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Lupin flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Egg")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Extra flour for working")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Chopped fresh tarragon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Chopped chives")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("40 g Pine nuts")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Juice of 2 lemons")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Parmesan")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel the potatoes and cook until soft in boiling salted water. Drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Mash the potatoes with a potato masher. Mix with salt, butter and the beaten egg, and allow to cool. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Mix the lupin and wheat flour together to make a pasta. Add the mashed potatoes and mix them well together. Put the paste on a wooden work surface and knead to produce homogeneous dough.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Flour the board and roll the dough into a sausage of about 2 cm large.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Roll the sheets on a gnocchi board, if you have one; otherwise, form each piece of gnocchi with the back of a fork into ball shapes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the gnocchi in salted boiling water for 4 minutes and drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When the gnocchi are cold, heat the butter in a pan and fry the gnocchi until browned. Add garlic, pine nuts and herbs and cook on a lower heat for 2 minutes. Add the lemon juice and serve with a sprinkle of Parmesan.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.4.7.3 Gluten-Free Gnocchi with Pesto")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-197",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-120.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This gnocchi recipe is the same at the one above: steps 1 to 5. But we have replaced the wheat flour with chickpea flour.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("For the sauce:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Chopped fresh Basil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Chopped Pine nuts")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Grated Pecorino")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 cl White wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Chop the onions and garlic finely.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the olive oil and add the chopped onion. When the onion is soft and a bit brown, add the cold gnocchi and garlic and cook until the gnocchi are slightly coloured. Add white wine and cook to reduce the wine.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the basil, pine nuts and Pecorino. Check seasoning, adding pepper and salt to taste. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-1"
  }, [_vm._v("6.5 Sweets, Desserts and Drinks")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2-first"
  }, [_vm._v("6.5.3 Chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.3.1 Chickpea and Pistachio Biscuits")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer347"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-121.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Chickpea flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("125 g Icing sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("125 g Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Cardamom pods")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Pistachio nuts")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Mix chickpea flour, sugar, butter and cardamom pods together. Allow to stand 3-4 hours in the fridge.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Roll the paste into a thickness of 1 cm and cut to shape.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Decorate with pistachio nuts and cook in the oven at a medium temperature, 140 C° for 7 minutes. Allow to cool in the oven.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.3.2 Fried Churros")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer348"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-122.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("A type of provincial street food served at fairs.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Tinned chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("6 Eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("100 g Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("100 ml Orange flower water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("250 ml Milk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("7"), _c('span'), _vm._v("g Baker’s yeast")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Remove the skin from the chickpeas and mash into a smooth paste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Mix the yeast with a little warm water and salt. Set aside till it starts to ferment.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Separate the egg yolks. Mix the egg yolks, milk, orange flower water, sugar and yeast mixture together.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Mount (whisk) the egg whites. I always add a bit of salt this helps the egg to mount. Then gradually add this to the egg yolk mixture. Mix together well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Let the mixture stand for about 1 hour. The mixture should remain fluid.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat a deep fat fryer. I use a cake funnel to make this: it’s the easiest way. When the fat is hot, squeeze the cake funnel into the fat. This might take a few goes in the hot fat. Once well browned, remove from the hot oil, place on absorbent paper, sprinkle with sugar and serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.3.3 Gluten-Free Canistrelli with Chestnut and Chickpea Flour Buns")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-197",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-123.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients: for about 10 pieces")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("50 g Chestnut flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Chickpea flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("20 g Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 ml White wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 ml Sunflower oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("¼ tsp Bicarbonate of soda")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Preheat oven at 180°C. Mix together the chestnut and chickpea flour, sugar, and bicarbonate of soda.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Gradually add the white wine and oil to the mixture, making a dough-like mixture.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When the dough is a good texture, make into square shapes and place on a greaseproof baking tray. Let stand for 15 minutes covered.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook for 10 minutes. Then turn the oven down to 150°C and cook for a further 10 minutes. Check to see if they are cooked. If not cooked, cook a bit longer.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.3.4 Canistrelli with Chickpea Flour")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-198",
    attrs: {
      "alt": "C:\\Users\\Mr STRIBLING\\Downloads\\93639129_s.jpg",
      "src": "image/Stribling-6-124.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Canistrelli is a traditional Corsican cake made from flour and with a taste of anise. This variation is interesting as it is low in carb and has no gluten.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for about 25 cakes:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Chickpea flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ pkt Baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 ml Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("80 g Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("5 cl Pastis")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("5 cl Dry white wine")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Mix all the dry ingredients together. Add olive oil, white wine and pastis. Knead the dough to obtain a homogeneous paste. Cut up and make about 25 balls, flatten the balls and place on a baking tray.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the cakes at 180°C for about 20 minutes. Allow to cool before serving.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Pastis is a French aperitif with a taste of aniseed.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_vm._v("6.5.5 Dry Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.5.1 Adzuki Bean Sweets")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer351"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-125.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 500 g of sweets:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200 g Adzuki dry beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Icing sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1/2 tsp Nutmeg")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt, 1 pinch")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the beans overnight (8-12 hours) and drain and rinse.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the adzuki beans in a large pan and cover with water. Put on the heat and bring to a boil. Stop the heat and cover. Allow to stand for 5 minutes, then drain. Put the adzuki beans back into the saucepan, cover with water and bring to a boil. Simmer for 1 hour. Make sure it does not dry out, if need be adding a bit more water. The beans should crush easily between the fingers.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Once the adzuki beans are cooked, add the sugar, nutmeg and salt, stirring all the time. The paste is cooked when you can see the bottom of the saucepan: a little bit like when you make jam, but producing a thicker paste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("On a baking tray, place a sheet of greaseproof paper. Sprinkle this with icing sugar. Then pour the paste onto this. Flatten to the required thickness and cut into squares. Place in the fridge. This can be kept for up to a week.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.5.2 Korean Sweet Bean Paste Bread")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer352"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-126.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 16 small breads:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("450 g Flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("350 g Sweet bean paste")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("60 ml Warm water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("60 ml Warm milk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("60 g Melted butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("60 g Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Instant dried yeast")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("11/2 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Butter for coating")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Black sesame seeds")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Mix the flour, salt, sugar and yeast in a large salad bowl.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add milk and water gradually to the flour mixture. Mix well together.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pour in the butter and mix. Check that the dough is the correct consistency: not too sticky. Adjust with flour or water. Knead for about 20 minutes until smooth and elastic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cover and set aside in a warm place for 30 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pre-heated oven at 180°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the bean paste into 16 pieces and roll each into a ball. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Uncover the dough and work slightly to remove air. Cut the dough into 16 portions and roll each into a ball.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Take the dough balls and flatten them. Place the bean paste ball in the centre, fold the dough around the paste to cover and make a round flattened form. Cut each piece with a sharp knife in part of the upper surface. Do the same for all the others. Coat the bread buns with the rest of the butter and sprinkle with the sesame seeds. Set aside on a baking dish for 20 minutes in a warm place.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook for about 15 minutes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.5.3 Japanese Red Bean Paste Pancakes")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("4 Eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("140 g Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Honey")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("160 g Plain flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Vegetable oil for cooking")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("400 g Sweet bean paste")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Mix eggs, sugar and honey in a bowl and whisk till you have a smooth paste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Mix the flour and baking powder into the batter. When it’s mixed well, place in the fridge for at least 15 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("If the batter seems too thick, add a bit of water.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat a non-stick pan. When it’s very hot, take a small ladle of batter and pour this into the hot oil to make the pancakes. Cook on both sides until lightly golden on both sides. Make two for each person. Spread the sweet bean paste in the middle and serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.5.4 Making Soy Milk")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer353"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-127.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 ml Soybeans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Sugar if necessary")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the beans in a container in of water overnight.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Drain and wash beans.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Remove as many of the skins as possible.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add 1 l of water to the beans, put in a food processor and blend until smooth.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Filter the blend through a cheesecloth and squeeze to finish.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cool and refrigerate")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This can be kept up to 4 days in the fridge. If you require it to be sweet, add sugar to taste.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.5.5. Chocolate Cake with Soy Milk")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer354"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-128.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 8 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 ml Plain flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("160 g Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("80 ml Chocolate powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("65 ml Vegetable oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp White vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Vanilla extract")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 ml Soy milk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Icing sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat oven to 160°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a large bowl, add flour, sugar, salt, chocolate powder and baking powder. Mix all the ingredients together well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In another bowl, add soy milk, vegetable oil and vanilla extract. Whisk all together well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add all the ingredients together and mix with a wooden spoon. Don’t over-mix.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pour the mixture into a greaseproof baking tin.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Bake for 40 minutes. Check to see if it’s cooked by inserting a knife in the middle of the cake: if there is no moisture on the knife, it’s ready.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Allow to cool and then dust with icing sugar.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.5.6 Soy Yoghurt")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer355"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-129.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 l Soy milk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Agar-agar powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("125 g Soy yoghurt activator")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat the oven at 43°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pour the soy milk into a saucepan. Add the agar-agar powder and heat slowly, making sure it does not boil.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pour the mixture into a bowl. Let the mixture cool a bit. When it’s nearly cold, add the soy yoghurt activator. Stir well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pour the mixture into small yoghurt-size pots. Turn the oven off, let it cool a bit, then place the pots in the oven without lids on. This can be done in an airing cupboard as well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Leave in the oven for at least 8 hours.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cover the jars and store in the fridge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.5.7 Kudzu Japanese Starch Cake")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer356"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-130.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("100 g Kudzu powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("50 g Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("50 ml Water")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Put all the ingredients into a saucepan and mix.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the saucepan on a medium low heat, stirring constantly to avoid lumps.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When the paste turns transparent and starts to come away from the pan, it is ready.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Wet a square mould, pour in the paste and smooth with a wet spatula. Allow to cool")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When cold, de-mould and cut into squares.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("These square cakes are sweet and rather tasteless and are generally served with a sweet sauce such a black sugar syrup alone or mixed with ground roasted soybean or dried fruits.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_vm._v("6.5.6 Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.6.1 Lentil and Chocolate Brownies")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Makes about 25 Brownies")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Cooked black lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 g Chocolate chips")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Unsweetened apple sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Chopped walnuts")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Vanilla extract")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Cocoa powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Preheat over at 180°C")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put into a food processor, lentils, chocolate chips, apple sauce, eggs and vanilla. Mix together well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add cocoa powder and salt. Blend well. When the texture is correct add the walnuts to the mixture.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pour the mixture into a greaseproof baking tray. Cook for about 30-35 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Leave to cool before cutting into squares.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.6.2 Lentil Granola Bars")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer357"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-131.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("50 g Tinned red lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 g Oat meal")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("75 g Barley flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1/4 tsp Cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Mixed dried fruit")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Sunflower seeds")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Pumpkin seeds")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("180 ml Coconut oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("75 g Peanut butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("75 ml Golden syrup")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Egg")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Vanilla extract")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("In a large bowl, mix together oats, brown sugar, barley flour, salt and cinnamon. After mix in the dried fruit and seeds.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In another bowl, whisk together the oil, peanut butter, golden syrup, egg and vanilla extract.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the two sets of ingredients together, then add the red lentils. Place the mix in a greased baking tray.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook in oven at 180°C for about 25-30 minutes, till golden on the outside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When it’s cooked, let the cake cool, and then cut into bars.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_vm._v("6.5.7 Lupins")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.7.1 Low Carb Pancake with Lupin and Plain Flour")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a neutral pancake that can be used as a sweet or savoury dish.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 5 pancakes:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("100 g Sweet lupin flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Plain flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Corn flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("700 ml Semi creamed milk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Olive oil for cooking")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Mix together both flours with sugar and salt. Beat the eggs together then gradually add this to the mixture. ")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Slowly add the milk while stirring to obtain a homogeneous cream without lumps.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Set aside in a cool place for about 10 hours.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat a pan. Add a little oil and when hot, pour one ladle of the pancake mixture. Cook until the pancake starts to colour and turn. Complete the cooking and remove the pancake. Add a little oil and repeat the operation.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.7.2 Lupin Spice Biscuits")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer358"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-132.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("50 g Lupin flakes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Plain flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("180 g Brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Mixed spices")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("110 g Melted butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("90 g Malt syrup")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Egg")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat oven at 180°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the following ingredients in a food mixer: lupin flakes, plain flour, sugar, baking powder and mixed spices. Mix together well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Gradually add to the mixture the butter, the malt syrup and then the egg. Mix until all the ingredients are well mixed together.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Knead the mixture. Wrap in a plastic bag and put it into the fridge for about 1 hour.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Take the dough out of the fridge and roll out on a floured board. Cut into shapes of your choice, then pierce with a folk.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the cut-out shapes on a greaseproof baking tray. Bake in the oven for about 4 minutes, then turn the biscuits over, so they cook on both sides. Cook for another 4 minutes. They cook very quickly, so keep an eye on them.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.7.3 Gluten-Free Lupin Pancakes")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-199",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-133.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("50 g Lupin flakes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Ricotta")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Lemon zest")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("5 tsp Semi skimmed milk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Vanilla essence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Egg whites")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Baking powder (gluten-free)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("10 g Butter for frying")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Put all the ingredients except the butter into a blender. Blend well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Place the batter mixture in the fridge and leave overnight.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat oil and butter. When this mixture is warm, cook the pancakes in a non-stick pan. This batter takes longer to cook than normal pancakes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_vm._v("6.5.7.4 Lupin Carrot Cake")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("150 g Lupin flakes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("75 g Almond powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Bicarbonate of soda")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Ground cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Carrots, peeled and grated")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 ml Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Maple syrup")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Vanilla essence")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Icing:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Spreadable cream cheese")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("75 g Icing sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Vanilla essence")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat oven at 170°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the lupin flakes, almond powder, bicarbonate of soda and cinnamon into a large bowl.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In another bowl, put in brown sugar, oil, maple syrup, eggs and vanilla essence. Mix with a whisk till you have a smooth paste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Mix all the ingredients together, then add the grated carrots, until you get a nice texture.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Grease a baking tray. Pour the mixture into the baking tray. Cook for about 1 hour.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("To make the icing, put all the ingredients for the icing together in a bowl and mix together well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When the cake is cold, put the icing on top.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_vm._v("6.5.9 Carob")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.9.1 Carob Cake")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("6 Eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("80 g Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 ml Milk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Coconut sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("30 g Carob powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("60 g Plain flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Pkt Baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Preheat oven at 180°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a large bowl, mix together the flour, baking powder, salt and carob powder.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In another bowl, beat the eggs together, then add the coconut sugar. Then gradually add this to the flour mixture to produce a smooth paste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Place the butter in a small saucepan. Heat on medium heat just till the butter is all melted. Add this to the mixture, then add the milk.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Grease a square cake tin. Then pour the mixture into this. Bake for 20 minutes. Test with a knife to see if it’s cooked through.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.9.2 Carob Sauce")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer360"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-134.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("2 tsp Carob powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Pinch of salt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("In a saucepan, melt the butter on a very low heat, so that it does not burn.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the rest of the ingredients into the saucepan, stirring gradually to avoiding any lumps. Heat on low heat, stirring all the time till you get a sauce texture.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This can be used on ice cream or pancakes, or even for savoury dishes.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_vm._v("6.5.10 Tamarind")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.10.1 Tamarind Sweet Balls")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-200",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-135.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200"), _c('span'), _vm._v("g Tamarind paste")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1"), _c('span'), _vm._v("kg Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Mix the tamarind paste with half the sugar into equal shaped balls.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Use the rest of the sugar to roll the balls to coat.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put them in the fridge to cool. Serve cool.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Tamarind balls can be flavoured to taste using ginger, cinnamon, cardamom or chilli powder, depending on your taste.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_vm._v("6.5.10.2 Tamarind Date Cake")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer362"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-136.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("275 g Plain flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Dates, stoned and chopped")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 g Brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Tamarind paste")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Large eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Bicarbonate of soda")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Icing:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 g Icing sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6-8 Ground cardamom pods")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Put the chopped dates and tamarind paste in a pan and cover with water. Bring to a boil. Cook for about 5 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Take off the heat, add the butter. Let the butter melt while the mixture cools.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pre-heat oven at 180°C. Add brown sugar to the mixture. In a bowl, beat the eggs together, then gradually add eggs, flour and bicarbonate of soda to the mixture.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pour the mixture into a greaseproof baking tin. Cook for about 60-70 minutes. Test to see if it’s cooked.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Make the icing: mix all the ingredients for the icing together, making a paste. When the cake is cooked, pour the icing over.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_vm._v("6.5.11 Mesquite")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.11.1 Mesquite Bean Jelly")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer363"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-137.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("7 kg Mesquite beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ Lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("5 l Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Packet of gelatine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1.75 kg Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Break the mesquite beans and put in a large pan of water. Soak overnight.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Drain the beans, then put them in a large pan with fresh water. Cook for 1 hour.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Drain, saving the juice. Boil 1½ l of the juice in a pan, add the lemon juice and boil for 5 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Continue to boil, slowly adding sugar and then gelatine. Continue to stir. Cook for another 5 minutes. ")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Strain through cheesecloth and pour into sterilised jars and seal. Then turn the jars upside down to cool, just like you do for jam.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.11.2 Mesquite Syrup")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 ml Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Mesquite pods (washed)")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Place water and mesquite pods in a large covered pot and cook at a very low heat for 12 hours.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When cooked, keep the liquid. Then heat the liquid and boil, reducing to a thin, syrupy consistency.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Bottle. When cool, you can serve it on pancakes or on toast. You can keep the syrup for a few days.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.11.3 Mesquite Tortillas")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-201",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-138.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1½ Vol of plain flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ Vol of mesquite flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ Vol of water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("In a bowl, mix together both flours and salt with a wooden spoon.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Gradually mix in the olive oil and water to arrive at a dough consistency. Knead for 2 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Divide the mixture into 12 balls, all about the same size. Then flatten them in discs of about 20 cm, or in a tortillas press.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook them on a griddle for about 1 minute on each side, and serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_vm._v("6.5.13 Liquorice")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-202",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-140.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.13.1 Liquorice Root Extract")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer366"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-139.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200 g Liquorice root")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 bottle of vodka or any strong alcohol of your taste")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Place the liquorice root in a half-full jar.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pour over the vodka, leaving a gap at the top of the jar of 5 cm.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Store in a dark place. Shake every day.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In 4 weeks’ time, it should be ready.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve as a liqueur, or you can use it to marinate meat.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.13.2 Black Liquorice Caramels")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Makes about 60 pieces:")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tin sweetened condensed milk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("120 ml Light syrup")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("¼ tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Liquorice extract")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Black food colouring")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("In a large heavy saucepan over low to medium heat, melt the butter. Add sweetened condensed milk, sugar, light syrup and salt. Stir continually.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Use a thermometer to cook till the heat reaches about 110°C. At this stage, it should have a chewy texture,")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Remove from the heat. Add liquorice extract and black food colouring. Line a baking tray with greaseproof paper.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pour mixture into the baking tray and leave to cool. When it’s cold, place in the fridge for about 1 hour.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut into sweet sizes. Wrap in wax paper. It’s very good!")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.13.3 Liquorice Cake")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("We are using coconut sugar in this recipe. Coconut sugar is made in the same way as maple syrup.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("150 g Twisted liquorice pieces")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 g Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 g Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 g Single cream")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 g Plain flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("For the topping:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Cream cheese")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Grated zest and juice of ½ lemon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("40 g Icing sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Preheat oven at 200°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Chop the liquorice into small pieces. Keep a few back to decorate the cake.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a saucepan, add the butter, cream and liquorice. Heat on medium heat and bring to a boil. Reduce the heat and simmer; you must make sure that it does not stick. When all the liquorice has dissolved, take off the heat and set aside to cool.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a large bowl, beat the eggs and sugar together. Then gradually add the flour and salt, making sure you have a nice smooth mixture. Then add the cooled liquorice mixture, stirring well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Take a round cake tin and grease. Pour the mixture into this. Place in the oven and cook for 15 minutes. Test this with a knife to see if it’s cooked. When cooked, let the cake cool.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("For the topping: mix the cream cheese lemon juice, zest and icing sugar together in a bowl, until you have a smooth paste. Spread this on the top of the cake and then decorate with the rest of the liquorice.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_vm._v("6.5.14  Rooibos")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.14.1 Rooibos beverage")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-203",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-141.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Rooibos is a bush that grows around the Table Mountain in Cape Town in South Africa and has leaves that turn red at maturity for this reason the red bush carries the Afrikaans name of Rooibos. The bush produces red leaves that are like tea. It is used either dried or fresh for beverages and infused like tea; in fact, it’s sometimes called red tea.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In South Africa, the infusion is made with hot milk in a similar way to the infusion of tea in India, probably due to the early presence of Indian traders all along the east coast of Africa. The infusion of rooibos has some therapeutic actions and has the advantage of not containing stimulants as is the case of coffee and tea.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Today rooibos is consumed worldwide and is generally infused in water.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_vm._v("6.5.15 False Acacia")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.15.1 Acacia Flower Fritters")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients: For 5 fritters")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("5 Stems of Acacia flowers")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Plain flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Caster sugar (for sprinkling)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 ml Cold beer")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 ml Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("¼ tsp Baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Sunflower oil")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("In a bowl, mix the flour, baking powder and salt together.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add to the flour and salt very slowly to the water, stirring with a whisk to avoid any lumps. When this is smooth, gradually add the beer, stirring all the time till you arrive at a smooth consistency.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Place the batter mixture into the fridge for at least 1 hour.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the sunflower oil in a deep fat fryer. When the oil is hot, dip the flower stems in the batter, one at a time, very carefully so as not to damage the flowers. The stem cooks very quickly. Cook till golden, then remove and place on absorbent paper. Continue until they are all cooked.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Sprinkle with the icing sugar and serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_vm._v("6.5.16 Mimosa")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.16.1 Mimosa and Lemon Jelly")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("100 g Mimosa tassels")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 l Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 kg Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("30 g Pectin")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Lemons (juice and zest)")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("In a saucepan, boil 2 l of water. When it’s boiled, turn it off. Then steep the mimosa tassels for 20 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Filter the juice through a cheesecloth, keeping the liquid. Put the liquid back into the saucepan, then add the pectin and sugar, stirring all the time.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Bring to a boil and add the juice of the lemons.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook, stirring constantly, for about 25 minutes, until it’s thick.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the lemon zest. Bottle in sterilized jars. Cool pots upside down.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.16.2 Crystallised Mimosa Flowers")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer368"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-142.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("100 g Mimosa flower heads")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Egg whites")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Pinch of salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Castor sugar as needed")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Whisk the egg whites, adding a pinch of salt and slowly adding a few drops of water.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the mixture into a large, shallow bowl. Put the mimosa flowers into the mixture, trying not to break them.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the sugar in another bowl, then dip each mimosa head into the sugar. This takes a bit of time: the best way is to use tweezers.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cover a large plate with greaseproof paper (you might need several plates).")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Set flowers aside to let completely dry: up to 24–36 hours.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Store the flowers in layers, separating with grease paper.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Store in an airtight container.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer370"
    }
  })])])])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9781398463455',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(64)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(66);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 66 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.ba764d775716bc454be3.js